console.log("%cCarty: collection add to cart - Powered by CleverApps", "font-weight: bold; background-color: #fff; color: #000"); console.log("Get it here: https://apps.shopify.com/collection-cart-button");
if (typeof jQuery === 'undefined') {
    // jQuery is not defined, so dynamically load it
    var script_carty = document.createElement('script');
    script_carty.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
    script_carty.onload = function() {
        // jQuery has loaded, now you can use it safely
        mainFunctionThatUsesJQuery();
    };
    document.head.appendChild(script_carty);
} else {
    // jQuery is already defined, so you can use it immediately
    mainFunctionThatUsesJQuery();
}

function mainFunctionThatUsesJQuery() {
    // Your code that depends on jQuery goes here
    // For example:
    $(document).ready(function() {
        // Your jQuery-dependent code here
        ! function (e) {
            
 if (window.location.hostname.includes('beitrimastories.com') && 
      (window.location.pathname === '/' || window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}\/?$/))) {
    return; // Exit if on any Beitrimastories.com home page (including country versions)
  }
  if (window.location.hostname.includes('fastshion-1.myshopify.com')) { const style = document.createElement('style'); style.innerHTML = 'div.cleverapps-collections-add-to-cart-widget { z-index: 3 !important; }'; document.head.appendChild(style); }
            let cartify = "/apps/cartiapp";
            let cleverlink = Shopify.shop;
            function getData() {
                return new Promise((resolve, reject) => {
                    jQuery.ajax({
                        type: "POST",
                        url: cartify,
                        data: { shop: cleverlink },
                        success: function(data) {
                            resolve(data);
                        },
                        error: function(xhr, status, error) {
                            reject(new Error(`AJAX request failed you uninstalled the app`));
                        }
                    });
                });
            }
            getData()
                .then((settings) => {
                    if(typeof settings.data === 'undefined'){
                        throw new Error("you uninstalled the app");
                        return;
                    }
                    let data = JSON.parse(settings.data[0].data);
                    function t(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function n(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
                        }
                    }

                    function r(e, t, r) {
                        return t && n(e.prototype, t), r && n(e, r), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e
                    }

                    function a(e, t, n) {
                        return t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n, e
                    }

                    function i(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), t && u(e, t)
                    }

                    function o(e) {
                        return o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
                            return e.__proto__ || Object.getPrototypeOf(e)
                        }, o(e)
                    }

                    function u(e, t) {
                        return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
                            return e.__proto__ = t, e
                        }, u(e, t)
                    }

                    function s(e, t) {
                        if (t && ("object" == typeof t || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return function (e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e
                        }(e)
                    }

                    function c(e) {
                        var t = function () {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {}))), !0
                            } catch (e) {
                                return !1
                            }
                        }();
                        return function () {
                            var n, r = o(e);
                            if (t) {
                                var a = o(this).constructor;
                                n = Reflect.construct(r, arguments, a)
                            } else n = r.apply(this, arguments);
                            return s(this, n)
                        }
                    }
                    var l = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "isInsideThemeEditor",
                                value: function () {
                                    return window.Shopify && window.Shopify.designMode
                                }
                            }, {
                                key: "getShop",
                                value: function () {
                                    if (e._isShopGlobalAvailable()) return e._shopGlobal();
                                    if (e._isDocumentDomainAvailable()) return e._documentDomain();
                                    if (e._isDocumentLocationAvailable()) return e._documentLocation();
                                    throw new Error("Shop domain matching *.myshopify.com not found")
                                }
                            }, {
                                key: "getPresentmentCurrency",
                                value: function () {
                                    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : ""
                                }
                            }, {
                                key: "getRoute",
                                value: function () {
                                    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : ""
                                }
                            }, {
                                key: "_isShopGlobalAvailable",
                                value: function () {
                                    return true;
                                }
                            }, {
                                key: "_isDocumentDomainAvailable",
                                value: function () {
                                    return false;
                                }
                            }, {
                                key: "_isDocumentLocationAvailable",
                                value: function () {
                                    return false;
                                }
                            }, {
                                key: "_shopGlobal",
                                value: function () {
                                    return Shopify.shop;
                                }
                            }, {
                                key: "_documentDomain",
                                value: function () {
                                    return document.domain
                                }
                            }, {
                                key: "_documentLocation",
                                value: function () {
                                    return document.location.href
                                }
                            }]), e
                        }(),
                        d = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "isEmpty",
                                value: function (t) {
                                    return !e.isNotEmpty(t)
                                }
                            }, {
                                key: "isNotEmpty",
                                value: function (e) {
                                    return e && e.length > 0
                                }
                            }, {
                                key: "arrayFrom",
                                value: function (e) {
                                    return Array.prototype.slice.call(e)
                                }
                            }, {
                                key: "find",
                                value: function (e, t) {
                                    var n = e.filter(t);
                                    return n.length > 0 ? n[0] : null
                                }
                            }, {
                                key: "distinct",
                                value: function (e) {
                                    return e.filter((function (e, t, n) {
                                        return n.indexOf(e) === t
                                    }))
                                }
                            }, {
                                key: "arrayEquals",
                                value: function (e, t) {
                                    return Array.isArray(e) && Array.isArray(t) && e.length === t.length && e.every((function (e, n) {
                                        return e == t[n]
                                    }))
                                }
                            }, {
                                key: "removeDuplicates",
                                value: function (e) {
                                    return e.filter((function (t, n) {
                                        return e.indexOf(t) === n
                                    }))
                                }
                            }, {
                                key: "cleanEmptyElements",
                                value: function (e) {
                                    return e.filter((function (e) {
                                        return null != e
                                    }))
                                }
                            }]), e
                        }(),
                        f = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "isNotEmpty",
                                value: function (t) {
                                    return !e.isEmpty(t)
                                }
                            }, {
                                key: "isEmpty",
                                value: function (t) {
                                    return null == t || "null" === t || 0 === e._removeWhiteSpaces(t).length
                                }
                            }, {
                                key: "endsWith",
                                value: function (t, n) {
                                    return !e.isEmpty(t) && !e.isEmpty(n) && -1 !== t.indexOf(n, t.length - n.length)
                                }
                            }, {
                                key: "_removeWhiteSpaces",
                                value: function (e) {
                                    return null == e ? e : e.replace(/&nbsp;/g, " ").trim()
                                }
                            }]), e
                        }();
                    a(f, "replaceLast", (function (e, t, n) {
                        if (f.isEmpty(e) || f.isEmpty(t)) return e;
                        var r = e.lastIndexOf(t);
                        return -1 !== r ? e.substring(0, r) + n : e
                    }));
                    var p, h, v = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "getInternationalContext",
                                value: function (t) {
                                    return f.isNotEmpty(t) ? e._removeTrailingSlash(t) : ""
                                }
                            }, {
                                key: "_removeTrailingSlash",
                                value: function (e) {
                                    return f.replaceLast(e, "/", "")
                                }
                            }]), e
                        }(),
                        y = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "removeLocalizedContext",
                                value: function (e, t) {
                                    var n = v.getInternationalContext(t);
                                    return f.isNotEmpty(n) ? e.replace(n, "") : e
                                }
                            }]), e
                        }(),
                        m = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "isDemoPage",
                                value: function (e) {
                                    var t = y.removeLocalizedContext(e, "/");
                                    return null !== t.match(/^\/.*\/test.html/) || null !== t.match(/^\/.*\/demo\//)
                                }
                            }, {
                                key: "isCollectionPage",
                                value: function (e, t) {
                                    var n = y.removeLocalizedContext(e, t);
                                    return null !== n.match(/^\/collections(\/)?.*/) && null === n.match(/^\/.*\/products\/.*/)
                                }
                            }, {
                                key: "isHomePage",
                                value: function (e, t) {
                                    var n = y.removeLocalizedContext(e, t);
                                    return n.length <= 1 || null !== n.match(/^\/index/) || null !== n.match(/^\/pages\/home/)
                                }
                            },
                                {
                                    key: "isPages",
                                    value: function (e) {
                                        var t = e || location.pathname;
                                        return null !== t.match(/^(\/..)?\/pages(\/)?.*/) && null === t.match(/^\/.*\/products\/.*/)
                                    }
                                },
                                {
                                    key: "isSearchResultsPage",
                                    value: function (e, t) {
                                        var n = y.removeLocalizedContext(e, t);
                                        return null !== n.match(/\/search\/?$/) || null !== n.match(/\/search-results-page\/?$/)
                                    }
                                }, {
                                    key: "isProductPage",
                                    value: function (e, t) {
                                        var n = y.removeLocalizedContext(e, t);
                                        return null !== n.match(/^\/products\/.*/) || null !== n.match(/^\/.*\/products\/.*/) || null !== n.match(/^\/products_preview.*/)
                                    }
                                }, {
                                    key: "isCartPage",
                                    value: function (e, t) {
                                        return null !== y.removeLocalizedContext(e, t).match(/^\/cart/)
                                    }
                                }]), e
                        }(),
                        g = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "hasParameterInUrl",
                                value: function (t) {
                                    var n = document.location.href;
                                    return e.hasParameter(n, t)
                                }
                            }, {
                                key: "getParameterInUrl",
                                value: function (t) {
                                    var n = document.location.href;
                                    return e.getParameter(n, t)
                                }
                            }, {
                                key: "hasParameter",
                                value: function (e, t) {
                                    return new RegExp("[?|&]" + t + "=([^&]*)").test(e)
                                }
                            }, {
                                key: "getParameter",
                                value: function (t, n) {
                                    return e.hasParameter(t, n) ? new RegExp("[?|&]" + n + "=([^&]*)").exec(t)[1] : ""
                                }
                            }, {
                                key: "removeParameters",
                                value: function (e) {
                                    return e.split("?")[0]
                                }
                            }, {
                                key: "_shopifyServletPath",
                                value: function () {
                                    return null == window.__st || null == window.__st.pageurl ? location.pathname : e.servletPath(window.__st.pageurl)
                                }
                            }, {
                                key: "servletPath",
                                value: function (e) {
                                    if (f.isEmpty(e)) return "";
                                    var t = e.indexOf("/");
                                    if (-1 == t) return "/";
                                    var n = e.indexOf("?");
                                    return -1 == n && (n = e.length), e.substring(t, n)
                                }
                            }, {
                                key: "isDemoPage",
                                value: function () {
                                    var e = location.pathname;
                                    return m.isDemoPage(e)
                                }
                            }, {
                                key: "isHomePage",
                                value: function () {
                                    var t = e._shopifyServletPath(),
                                        n = l.getRoute();
                                    return m.isHomePage(t, n)
                                }
                            }, {
                                key: "isProductPage",
                                value: function () {
                                    var t = e._shopifyServletPath(),
                                        n = l.getRoute();
                                    return m.isProductPage(t, n)
                                }
                            }, {
                                key: "isCartPage",
                                value: function () {
                                    var t = e._shopifyServletPath(),
                                        n = l.getRoute();
                                    return m.isCartPage(t, n)
                                }
                            }, {
                                key: "isCollectionPage",
                                value: function () {
                                    var t = e._shopifyServletPath(),
                                        n = l.getRoute();
                                    return m.isCollectionPage(t, n)
                                }
                            }, {
                                key: "isSearchResultsPage",
                                value: function () {
                                    var t = e._shopifyServletPath(),
                                        n = l.getRoute();
                                    return m.isSearchResultsPage(t, n)
                                }
                            }, {
                                key: "getInternationalContext",
                                value: function () {
                                    var e = l.getRoute();
                                    return v.getInternationalContext(e)
                                }
                            }, {
                                key: "getCartPage",
                                value: function () {
                                    return e.getInternationalContext() + "/cart"
                                }
                            }, {
                                key: "getCheckoutPage",
                                value: function () {
                                    return e.getInternationalContext() + "/checkout"
                                }
                            }, {
                                key: "getProductPage",
                                value: function (t) {
                                    return e.getInternationalContext() + "/products/" + t
                                }
                            }]), e
                        }(),
                        _ = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "getTimestamp",
                                value: function () {
                                    var t = '1666071873';
                                    return t ? _.getParameter(t.src, "timestamp") : null
                                }
                            }, {
                                key: "hasNgrokScriptTag",
                                value: function () {
                                    return (document.currentScript && document.currentScript.src ? document.currentScript.src : "").includes(C.ngrokUrl())
                                }
                            }, {
                                key: "hasDevScriptTag",
                                value: function () {
                                    return (document.currentScript && document.currentScript.src ? document.currentScript.src : "").includes(C.devUrl())
                                }
                            }, {
                                key: "isMainLoaded",
                                value: function () {
                                    var e = d.arrayFrom(document.getElementsByTagName("script")),
                                        t = (C.cdnUrl() + "/js/core/main.min.js").replace("https:", "").replace("http:", "");
                                    return null != d.find(e, (function (e) {
                                        return e && e.src && -1 !== e.src.indexOf(t)
                                    }))
                                }
                            }, {
                                key: "_getShopifyAppScriptTag",
                                value: function () {
                                    var e = d.arrayFrom(document.getElementsByTagName("script")),
                                        t = C.cdnUrl().replace("https:", "").replace("http:", "");
                                    return d.find(e, (function (e) {
                                        return e && e.src && -1 !== e.src.indexOf(t)
                                    }))
                                }
                            }]), e
                        }(),
                        C = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "cdnUrl",
                                value: function () {
                                    return e._isLocalhost() ? e.LOCAL_URL : e.isNgrok() ? e.NGROK_CDN_URL : e._isDev() ? e.DEV_CDN_URL : e.PRODUCTION_CDN_URL
                                }
                            }, {
                                key: "ngrokUrl",
                                value: function () {
                                    return e.NGROK_CDN_URL
                                }
                            }, {
                                key: "devUrl",
                                value: function () {
                                    return e.DEV_CDN_URL
                                }
                            }, {
                                key: "appId",
                                value: function () {
                                    return e.APP_ID
                                }
                            }, {
                                key: "cssClassPrefix",
                                value: function () {
                                    return e.APP_CSS_CLASS_PREFIX
                                }
                            }, {
                                key: "isNgrok",
                                value: function () {
                                    return _.hasNgrokScriptTag()
                                }
                            }, {
                                key: "_isLocalhost",
                                value: function () {
                                    var e = location.href;
                                    return null !== e.match(/\/\/localhost/) || null !== e.match(/\/\/bs-local.com/) || null !== e.match(/\/\/192.168.*/)
                                }
                            }, {
                                key: "_isDev",
                                value: function () {
                                    return _.hasDevScriptTag()
                                }
                            }]), e
                        }();
                    a(C, "PRODUCTION_CDN_URL", "https://collections-add-to-cart.CLEVER.dev"),
                        a(C, "NGROK_CDN_URL", "https://****-**-*-***-***.eu.ngrok.io/collections-add-to-cart"),
                        a(C, "DEV_CDN_URL", "https://dev-collections-add-to-cart.CLEVER.dev"),
                        a(C, "LOCAL_URL", "http://localhost:8080/collections-add-to-cart"),
                        a(C, "APP_ID", "collections-add-to-cart"),
                        a(C, "APP_CSS_CLASS_PREFIX", "cleverapps-collections-add-to-cart-"),
                        a(C, "AVOID_WIDGET_TAG", "avoid-cleverapps-add-to-cart-button"),
                        a(C, "FORCE_WIDGET_TAG", "show-cleverapps-add-to-cart-button"),
                        a(C, "DIFFERENT_BUTTON_TEXT_TAG", "cleverapps-add-to-cart-button-text:"),
                        a(C, "BUTTON_REDIRECT_TO_PRODUCT_PAGE_TAG", "cleverapps-add-to-cart-button-redirect-to-product-page"),
                        a(C, "BUTTON_REMAIN_ON_PAGE_TAG", "cleverapps-add-to-cart-button-remain-on-page"),
                        a(C, "BUTTON_REDIRECT_TO_CHECKOUT_TAG", "cleverapps-add-to-cart-button-redirect-to-checkout"),
                        a(C, "BUTTON_REDIRECT_TO_CART_TAG", "cleverapps-add-to-cart-button-redirect-to-cart"),
                        a(C, "PROCESSED_BY_CLEVER_CLASS", "processed-by-CLEVER"),
                        a(C, "PROCESSED_BY_CLEVER_SELECTOR", "." + C.PROCESSED_BY_CLEVER_CLASS),
                        p = "undefined" != typeof window ? window : void 0, h = function (e, t) {
                        var n = [],
                            r = Object.getPrototypeOf,
                            a = n.slice,
                            i = n.flat ? function (e) {
                                return n.flat.call(e)
                            } : function (e) {
                                return n.concat.apply([], e)
                            },
                            o = n.push,
                            u = n.indexOf,
                            s = {},
                            c = s.toString,
                            l = s.hasOwnProperty,
                            d = l.toString,
                            f = d.call(Object),
                            p = {},
                            h = function (e) {
                                return "function" == typeof e && "number" != typeof e.nodeType
                            },
                            v = function (e) {
                                return null != e && e === e.window
                            },
                            y = e.document,
                            m = {
                                type: !0,
                                src: !0,
                                nonce: !0,
                                noModule: !0
                            };

                        function g(e, t, n) {
                            var r, a, i = (n = n || y).createElement("script");
                            if (i.text = e, t)
                                for (r in m)(a = t[r] || t.getAttribute && t.getAttribute(r)) && i.setAttribute(r, a);
                            n.head.appendChild(i).parentNode.removeChild(i)
                        }

                        function _(e) {
                            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? s[c.call(e)] || "object" : typeof e
                        }
                        var C = "3.5.1",
                            b = function (e, t) {
                                return new b.fn.init(e, t)
                            };

                        function w(e) {
                            var t = !!e && "length" in e && e.length,
                                n = _(e);
                            return !h(e) && !v(e) && ("array" === n || 0 === t || "number" == typeof t && 0 < t && t - 1 in e)
                        }
                        b.fn = b.prototype = {
                            jquery: C,
                            constructor: b,
                            length: 0,
                            toArray: function () {
                                return a.call(this)
                            },
                            get: function (e) {
                                return null == e ? a.call(this) : e < 0 ? this[e + this.length] : this[e]
                            },
                            pushStack: function (e) {
                                var t = b.merge(this.constructor(), e);
                                return t.prevObject = this, t
                            },
                            each: function (e) {
                                return b.each(this, e)
                            },
                            map: function (e) {
                                return this.pushStack(b.map(this, (function (t, n) {
                                    return e.call(t, n, t)
                                })))
                            },
                            slice: function () {
                                return this.pushStack(a.apply(this, arguments))
                            },
                            first: function () {
                                return this.eq(0)
                            },
                            last: function () {
                                return this.eq(-1)
                            },
                            even: function () {
                                return this.pushStack(b.grep(this, (function (e, t) {
                                    return (t + 1) % 2
                                })))
                            },
                            odd: function () {
                                return this.pushStack(b.grep(this, (function (e, t) {
                                    return t % 2
                                })))
                            },
                            eq: function (e) {
                                var t = this.length,
                                    n = +e + (e < 0 ? t : 0);
                                return this.pushStack(0 <= n && n < t ? [this[n]] : [])
                            },
                            end: function () {
                                return this.prevObject || this.constructor()
                            },
                            push: o,
                            sort: n.sort,
                            splice: n.splice
                        }, b.extend = b.fn.extend = function () {
                            var e, t, n, r, a, i, o = arguments[0] || {},
                                u = 1,
                                s = arguments.length,
                                c = !1;
                            for ("boolean" == typeof o && (c = o, o = arguments[u] || {}, u++), "object" == typeof o || h(o) || (o = {}), u === s && (o = this, u--); u < s; u++)
                                if (null != (e = arguments[u]))
                                    for (t in e) r = e[t], "__proto__" !== t && o !== r && (c && r && (b.isPlainObject(r) || (a = Array.isArray(r))) ? (n = o[t], i = a && !Array.isArray(n) ? [] : a || b.isPlainObject(n) ? n : {}, a = !1, o[t] = b.extend(c, i, r)) : void 0 !== r && (o[t] = r));
                            return o
                        }, b.extend({
                            expando: "jQuery" + (C + Math.random()).replace(/\D/g, ""),
                            isReady: !0,
                            error: function (e) {
                                throw new Error(e)
                            },
                            noop: function () {},
                            isPlainObject: function (e) {
                                var t, n;
                                return !(!e || "[object Object]" !== c.call(e) || (t = r(e)) && ("function" != typeof (n = l.call(t, "constructor") && t.constructor) || d.call(n) !== f))
                            },
                            isEmptyObject: function (e) {
                                var t;
                                for (t in e) return !1;
                                return !0
                            },
                            globalEval: function (e, t, n) {
                                g(e, {
                                    nonce: t && t.nonce
                                }, n)
                            },
                            each: function (e, t) {
                                var n, r = 0;
                                if (w(e))
                                    for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);
                                else
                                    for (r in e)
                                        if (!1 === t.call(e[r], r, e[r])) break;
                                return e
                            },
                            makeArray: function (e, t) {
                                var n = t || [];
                                return null != e && (w(Object(e)) ? b.merge(n, "string" == typeof e ? [e] : e) : o.call(n, e)), n
                            },
                            inArray: function (e, t, n) {
                                return null == t ? -1 : u.call(t, e, n)
                            },
                            merge: function (e, t) {
                                for (var n = +t.length, r = 0, a = e.length; r < n; r++) e[a++] = t[r];
                                return e.length = a, e
                            },
                            grep: function (e, t, n) {
                                for (var r = [], a = 0, i = e.length, o = !n; a < i; a++) !t(e[a], a) !== o && r.push(e[a]);
                                return r
                            },
                            map: function (e, t, n) {
                                var r, a, o = 0,
                                    u = [];
                                if (w(e))
                                    for (r = e.length; o < r; o++) null != (a = t(e[o], o, n)) && u.push(a);
                                else
                                    for (o in e) null != (a = t(e[o], o, n)) && u.push(a);
                                return i(u)
                            },
                            guid: 1,
                            support: p
                        }), "function" == typeof Symbol && (b.fn[Symbol.iterator] = n[Symbol.iterator]), b.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), (function (e, t) {
                            s["[object " + t + "]"] = t.toLowerCase()
                        }));
                        var k = function (e) {
                            var t, n, r, a, i, o, u, s, c, l, d, f, p, h, v, y, m, g, _, C = "sizzle" + 1 * new Date,
                                b = e.document,
                                w = 0,
                                k = 0,
                                S = se(),
                                x = se(),
                                T = se(),
                                A = se(),
                                E = function (e, t) {
                                    return e === t && (d = !0), 0
                                },
                                P = {}.hasOwnProperty,
                                I = [],
                                O = I.pop,
                                D = I.push,
                                B = I.push,
                                j = I.slice,
                                L = function (e, t) {
                                    for (var n = 0, r = e.length; n < r; n++)
                                        if (e[n] === t) return n;
                                    return -1
                                },
                                N = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                                R = "[\ \\t\\r\\n\\f]",
                                F = "(?:\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\])+",
                                q = "\\[" + R + "*(" + F + ")(?:" + R + "*([*^$|!~]?=)" + R + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + F + "))|)" + R + "*\\]",
                                U = ":(" + F + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + q + ")*)|.*)\\)|)",
                                V = new RegExp(R + "+", "g"),
                                H = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$", "g"),
                                M = new RegExp("^" + R + "*," + R + "*"),
                                $ = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"),
                                W = new RegExp(R + "|>"),
                                z = new RegExp(U),
                                G = new RegExp("^" + F + "$"),
                                Q = {
                                    ID: new RegExp("^#(" + F + ")"),
                                    CLASS: new RegExp("^\\.(" + F + ")"),
                                    TAG: new RegExp("^(" + F + "|[*])"),
                                    ATTR: new RegExp("^" + q),
                                    PSEUDO: new RegExp("^" + U),
                                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)", "i"),
                                    bool: new RegExp("^(?:" + N + ")$", "i"),
                                    needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)", "i")
                                },
                                Y = /HTML$/i,
                                X = /^(?:input|select|textarea|button)$/i,
                                K = /^h\d$/i,
                                J = /^[^{]+\{\s*\[native \w/,
                                Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                                ee = /[+~]/,
                                te = new RegExp("\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\([^\\r\\n\\f])", "g"),
                                ne = function (e, t) {
                                    var n = "0x" + e.slice(1) - 65536;
                                    return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320))
                                },
                                re = /([\0-]|^-?\d)|^-$|[^\0--￿\w-]/g,
                                ae = function (e, t) {
                                    return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
                                },
                                ie = function () {
                                    f()
                                },
                                oe = Ce((function (e) {
                                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
                                }), {
                                    dir: "parentNode",
                                    next: "legend"
                                });
                            try {
                                B.apply(I = j.call(b.childNodes), b.childNodes), I[b.childNodes.length].nodeType
                            } catch (t) {
                                B = {
                                    apply: I.length ? function (e, t) {
                                        D.apply(e, j.call(t))
                                    } : function (e, t) {
                                        for (var n = e.length, r = 0; e[n++] = t[r++];);
                                        e.length = n - 1
                                    }
                                }
                            }

                            function ue(e, t, r, a) {
                                var i, u, c, l, d, h, m, g = t && t.ownerDocument,
                                    b = t ? t.nodeType : 9;
                                if (r = r || [], "string" != typeof e || !e || 1 !== b && 9 !== b && 11 !== b) return r;
                                if (!a && (f(t), t = t || p, v)) {
                                    if (11 !== b && (d = Z.exec(e)))
                                        if (i = d[1]) {
                                            if (9 === b) {
                                                if (!(c = t.getElementById(i))) return r;
                                                if (c.id === i) return r.push(c), r
                                            } else if (g && (c = g.getElementById(i)) && _(t, c) && c.id === i) return r.push(c), r
                                        } else {
                                            if (d[2]) return B.apply(r, t.getElementsByTagName(e)), r;
                                            if ((i = d[3]) && n.getElementsByClassName && t.getElementsByClassName) return B.apply(r, t.getElementsByClassName(i)), r
                                        } if (n.qsa && !A[e + " "] && (!y || !y.test(e)) && (1 !== b || "object" !== t.nodeName.toLowerCase())) {
                                        if (m = e, g = t, 1 === b && (W.test(e) || $.test(e))) {
                                            for ((g = ee.test(e) && me(t.parentNode) || t) === t && n.scope || ((l = t.getAttribute("id")) ? l = l.replace(re, ae) : t.setAttribute("id", l = C)), u = (h = o(e)).length; u--;) h[u] = (l ? "#" + l : ":scope") + " " + _e(h[u]);
                                            m = h.join(",")
                                        }
                                        try {
                                            return B.apply(r, g.querySelectorAll(m)), r
                                        } catch (t) {
                                            A(e, !0)
                                        } finally {
                                            l === C && t.removeAttribute("id")
                                        }
                                    }
                                }
                                return s(e.replace(H, "$1"), t, r, a)
                            }

                            function se() {
                                var e = [];
                                return function t(n, a) {
                                    return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = a
                                }
                            }

                            function ce(e) {
                                return e[C] = !0, e
                            }

                            function le(e) {
                                var t = p.createElement("fieldset");
                                try {
                                    return !!e(t)
                                } catch (e) {
                                    return !1
                                } finally {
                                    t.parentNode && t.parentNode.removeChild(t), t = null
                                }
                            }

                            function de(e, t) {
                                for (var n = e.split("|"), a = n.length; a--;) r.attrHandle[n[a]] = t
                            }

                            function fe(e, t) {
                                var n = t && e,
                                    r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                                if (r) return r;
                                if (n)
                                    for (; n = n.nextSibling;)
                                        if (n === t) return -1;
                                return e ? 1 : -1
                            }

                            function pe(e) {
                                return function (t) {
                                    return "input" === t.nodeName.toLowerCase() && t.type === e
                                }
                            }

                            function he(e) {
                                return function (t) {
                                    var n = t.nodeName.toLowerCase();
                                    return ("input" === n || "button" === n) && t.type === e
                                }
                            }

                            function ve(e) {
                                return function (t) {
                                    return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && oe(t) === e : t.disabled === e : "label" in t && t.disabled === e
                                }
                            }

                            function ye(e) {
                                return ce((function (t) {
                                    return t = +t, ce((function (n, r) {
                                        for (var a, i = e([], n.length, t), o = i.length; o--;) n[a = i[o]] && (n[a] = !(r[a] = n[a]))
                                    }))
                                }))
                            }

                            function me(e) {
                                return e && void 0 !== e.getElementsByTagName && e
                            }
                            for (t in n = ue.support = {}, i = ue.isXML = function (e) {
                                var t = e.namespaceURI,
                                    n = (e.ownerDocument || e).documentElement;
                                return !Y.test(t || n && n.nodeName || "HTML")
                            }, f = ue.setDocument = function (e) {
                                var t, a, o = e ? e.ownerDocument || e : b;
                                return o != p && 9 === o.nodeType && o.documentElement && (h = (p = o).documentElement, v = !i(p), b != p && (a = p.defaultView) && a.top !== a && (a.addEventListener ? a.addEventListener("unload", ie, !1) : a.attachEvent && a.attachEvent("onunload", ie)), n.scope = le((function (e) {
                                    return h.appendChild(e).appendChild(p.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
                                })), n.attributes = le((function (e) {
                                    return e.className = "i", !e.getAttribute("className")
                                })), n.getElementsByTagName = le((function (e) {
                                    return e.appendChild(p.createComment("")), !e.getElementsByTagName("*").length
                                })), n.getElementsByClassName = J.test(p.getElementsByClassName), n.getById = le((function (e) {
                                    return h.appendChild(e).id = C, !p.getElementsByName || !p.getElementsByName(C).length
                                })), n.getById ? (r.filter.ID = function (e) {
                                    var t = e.replace(te, ne);
                                    return function (e) {
                                        return e.getAttribute("id") === t
                                    }
                                }, r.find.ID = function (e, t) {
                                    if (void 0 !== t.getElementById && v) {
                                        var n = t.getElementById(e);
                                        return n ? [n] : []
                                    }
                                }) : (r.filter.ID = function (e) {
                                    var t = e.replace(te, ne);
                                    return function (e) {
                                        var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                        return n && n.value === t
                                    }
                                }, r.find.ID = function (e, t) {
                                    if (void 0 !== t.getElementById && v) {
                                        var n, r, a, i = t.getElementById(e);
                                        if (i) {
                                            if ((n = i.getAttributeNode("id")) && n.value === e) return [i];
                                            for (a = t.getElementsByName(e), r = 0; i = a[r++];)
                                                if ((n = i.getAttributeNode("id")) && n.value === e) return [i]
                                        }
                                        return []
                                    }
                                }), r.find.TAG = n.getElementsByTagName ? function (e, t) {
                                    return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0
                                } : function (e, t) {
                                    var n, r = [],
                                        a = 0,
                                        i = t.getElementsByTagName(e);
                                    if ("*" === e) {
                                        for (; n = i[a++];) 1 === n.nodeType && r.push(n);
                                        return r
                                    }
                                    return i
                                }, r.find.CLASS = n.getElementsByClassName && function (e, t) {
                                    if (void 0 !== t.getElementsByClassName && v) return t.getElementsByClassName(e)
                                }, m = [], y = [], (n.qsa = J.test(p.querySelectorAll)) && (le((function (e) {
                                    var t;
                                    h.appendChild(e).innerHTML = "<a id='" + C + "'></a><select id='" + C + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && y.push("[*^$]=" + R + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || y.push("\\[" + R + "*(?:value|" + N + ")"), e.querySelectorAll("[id~=" + C + "-]").length || y.push("~="), (t = p.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || y.push("\\[" + R + "*name" + R + "*=" + R + "*(?:''|\"\")"), e.querySelectorAll(":checked").length || y.push(":checked"), e.querySelectorAll("a#" + C + "+*").length || y.push(".#.+[+~]"), e.querySelectorAll("\\\f"), y.push("[\\r\\n\\f]")
                                })), le((function (e) {
                                    e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                    var t = p.createElement("input");
                                    t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && y.push("name" + R + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"), h.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), y.push(",.*:")
                                }))), (n.matchesSelector = J.test(g = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && le((function (e) {
                                    n.disconnectedMatch = g.call(e, "*"), g.call(e, "[s!='']:x"), m.push("!=", U)
                                })), y = y.length && new RegExp(y.join("|")), m = m.length && new RegExp(m.join("|")), t = J.test(h.compareDocumentPosition), _ = t || J.test(h.contains) ? function (e, t) {
                                    var n = 9 === e.nodeType ? e.documentElement : e,
                                        r = t && t.parentNode;
                                    return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)))
                                } : function (e, t) {
                                    if (t)
                                        for (; t = t.parentNode;)
                                            if (t === e) return !0;
                                    return !1
                                }, E = t ? function (e, t) {
                                    if (e === t) return d = !0, 0;
                                    var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                    return r || (1 & (r = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e == p || e.ownerDocument == b && _(b, e) ? -1 : t == p || t.ownerDocument == b && _(b, t) ? 1 : l ? L(l, e) - L(l, t) : 0 : 4 & r ? -1 : 1)
                                } : function (e, t) {
                                    if (e === t) return d = !0, 0;
                                    var n, r = 0,
                                        a = e.parentNode,
                                        i = t.parentNode,
                                        o = [e],
                                        u = [t];
                                    if (!a || !i) return e == p ? -1 : t == p ? 1 : a ? -1 : i ? 1 : l ? L(l, e) - L(l, t) : 0;
                                    if (a === i) return fe(e, t);
                                    for (n = e; n = n.parentNode;) o.unshift(n);
                                    for (n = t; n = n.parentNode;) u.unshift(n);
                                    for (; o[r] === u[r];) r++;
                                    return r ? fe(o[r], u[r]) : o[r] == b ? -1 : u[r] == b ? 1 : 0
                                }), p
                            }, ue.matches = function (e, t) {
                                return ue(e, null, null, t)
                            }, ue.matchesSelector = function (e, t) {
                                if (f(e), n.matchesSelector && v && !A[t + " "] && (!m || !m.test(t)) && (!y || !y.test(t))) try {
                                    var r = g.call(e, t);
                                    if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r
                                } catch (e) {
                                    A(t, !0)
                                }
                                return 0 < ue(t, p, null, [e]).length
                            }, ue.contains = function (e, t) {
                                return (e.ownerDocument || e) != p && f(e), _(e, t)
                            }, ue.attr = function (e, t) {
                                (e.ownerDocument || e) != p && f(e);
                                var a = r.attrHandle[t.toLowerCase()],
                                    i = a && P.call(r.attrHandle, t.toLowerCase()) ? a(e, t, !v) : void 0;
                                return void 0 !== i ? i : n.attributes || !v ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
                            }, ue.escape = function (e) {
                                return (e + "").replace(re, ae)
                            }, ue.error = function (e) {
                                throw new Error("Syntax error, unrecognized expression: " + e)
                            }, ue.uniqueSort = function (e) {
                                var t, r = [],
                                    a = 0,
                                    i = 0;
                                if (d = !n.detectDuplicates, l = !n.sortStable && e.slice(0), e.sort(E), d) {
                                    for (; t = e[i++];) t === e[i] && (a = r.push(i));
                                    for (; a--;) e.splice(r[a], 1)
                                }
                                return l = null, e
                            }, a = ue.getText = function (e) {
                                var t, n = "",
                                    r = 0,
                                    i = e.nodeType;
                                if (i) {
                                    if (1 === i || 9 === i || 11 === i) {
                                        if ("string" == typeof e.textContent) return e.textContent;
                                        for (e = e.firstChild; e; e = e.nextSibling) n += a(e)
                                    } else if (3 === i || 4 === i) return e.nodeValue
                                } else
                                    for (; t = e[r++];) n += a(t);
                                return n
                            }, (r = ue.selectors = {
                                cacheLength: 50,
                                createPseudo: ce,
                                match: Q,
                                attrHandle: {},
                                find: {},
                                relative: {
                                    ">": {
                                        dir: "parentNode",
                                        first: !0
                                    },
                                    " ": {
                                        dir: "parentNode"
                                    },
                                    "+": {
                                        dir: "previousSibling",
                                        first: !0
                                    },
                                    "~": {
                                        dir: "previousSibling"
                                    }
                                },
                                preFilter: {
                                    ATTR: function (e) {
                                        return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                                    },
                                    CHILD: function (e) {
                                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || ue.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && ue.error(e[0]), e
                                    },
                                    PSEUDO: function (e) {
                                        var t, n = !e[6] && e[2];
                                        return Q.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && z.test(n) && (t = o(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
                                    }
                                },
                                filter: {
                                    TAG: function (e) {
                                        var t = e.replace(te, ne).toLowerCase();
                                        return "*" === e ? function () {
                                            return !0
                                        } : function (e) {
                                            return e.nodeName && e.nodeName.toLowerCase() === t
                                        }
                                    },
                                    CLASS: function (e) {
                                        var t = S[e + " "];
                                        return t || (t = new RegExp("(^|" + R + ")" + e + "(" + R + "|$)")) && S(e, (function (e) {
                                            return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                                        }))
                                    },
                                    ATTR: function (e, t, n) {
                                        return function (r) {
                                            var a = ue.attr(r, e);
                                            return null == a ? "!=" === t : !t || (a += "", "=" === t ? a === n : "!=" === t ? a !== n : "^=" === t ? n && 0 === a.indexOf(n) : "*=" === t ? n && -1 < a.indexOf(n) : "$=" === t ? n && a.slice(-n.length) === n : "~=" === t ? -1 < (" " + a.replace(V, " ") + " ").indexOf(n) : "|=" === t && (a === n || a.slice(0, n.length + 1) === n + "-"))
                                        }
                                    },
                                    CHILD: function (e, t, n, r, a) {
                                        var i = "nth" !== e.slice(0, 3),
                                            o = "last" !== e.slice(-4),
                                            u = "of-type" === t;
                                        return 1 === r && 0 === a ? function (e) {
                                            return !!e.parentNode
                                        } : function (t, n, s) {
                                            var c, l, d, f, p, h, v = i !== o ? "nextSibling" : "previousSibling",
                                                y = t.parentNode,
                                                m = u && t.nodeName.toLowerCase(),
                                                g = !s && !u,
                                                _ = !1;
                                            if (y) {
                                                if (i) {
                                                    for (; v;) {
                                                        for (f = t; f = f[v];)
                                                            if (u ? f.nodeName.toLowerCase() === m : 1 === f.nodeType) return !1;
                                                        h = v = "only" === e && !h && "nextSibling"
                                                    }
                                                    return !0
                                                }
                                                if (h = [o ? y.firstChild : y.lastChild], o && g) {
                                                    for (_ = (p = (c = (l = (d = (f = y)[C] || (f[C] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] || [])[0] === w && c[1]) && c[2], f = p && y.childNodes[p]; f = ++p && f && f[v] || (_ = p = 0) || h.pop();)
                                                        if (1 === f.nodeType && ++_ && f === t) {
                                                            l[e] = [w, p, _];
                                                            break
                                                        }
                                                } else if (g && (_ = p = (c = (l = (d = (f = t)[C] || (f[C] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] || [])[0] === w && c[1]), !1 === _)
                                                    for (;
                                                        (f = ++p && f && f[v] || (_ = p = 0) || h.pop()) && ((u ? f.nodeName.toLowerCase() !== m : 1 !== f.nodeType) || !++_ || (g && ((l = (d = f[C] || (f[C] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] = [w, _]), f !== t)););
                                                return (_ -= a) === r || _ % r == 0 && 0 <= _ / r
                                            }
                                        }
                                    },
                                    PSEUDO: function (e, t) {
                                        var n, a = r.pseudos[e] || r.setFilters[e.toLowerCase()] || ue.error("unsupported pseudo: " + e);
                                        return a[C] ? a(t) : 1 < a.length ? (n = [e, e, "", t], r.setFilters.hasOwnProperty(e.toLowerCase()) ? ce((function (e, n) {
                                            for (var r, i = a(e, t), o = i.length; o--;) e[r = L(e, i[o])] = !(n[r] = i[o])
                                        })) : function (e) {
                                            return a(e, 0, n)
                                        }) : a
                                    }
                                },
                                pseudos: {
                                    not: ce((function (e) {
                                        var t = [],
                                            n = [],
                                            r = u(e.replace(H, "$1"));
                                        return r[C] ? ce((function (e, t, n, a) {
                                            for (var i, o = r(e, null, a, []), u = e.length; u--;)(i = o[u]) && (e[u] = !(t[u] = i))
                                        })) : function (e, a, i) {
                                            return t[0] = e, r(t, null, i, n), t[0] = null, !n.pop()
                                        }
                                    })),
                                    has: ce((function (e) {
                                        return function (t) {
                                            return 0 < ue(e, t).length
                                        }
                                    })),
                                    contains: ce((function (e) {
                                        return e = e.replace(te, ne),
                                            function (t) {
                                                return -1 < (t.textContent || a(t)).indexOf(e)
                                            }
                                    })),
                                    lang: ce((function (e) {
                                        return G.test(e || "") || ue.error("unsupported lang: " + e), e = e.replace(te, ne).toLowerCase(),
                                            function (t) {
                                                var n;
                                                do {
                                                    if (n = v ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                                return !1
                                            }
                                    })),
                                    target: function (t) {
                                        var n = e.location && e.location.hash;
                                        return n && n.slice(1) === t.id
                                    },
                                    root: function (e) {
                                        return e === h
                                    },
                                    focus: function (e) {
                                        return e === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                                    },
                                    enabled: ve(!1),
                                    disabled: ve(!0),
                                    checked: function (e) {
                                        var t = e.nodeName.toLowerCase();
                                        return "input" === t && !!e.checked || "option" === t && !!e.selected
                                    },
                                    selected: function (e) {
                                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                                    },
                                    empty: function (e) {
                                        for (e = e.firstChild; e; e = e.nextSibling)
                                            if (e.nodeType < 6) return !1;
                                        return !0
                                    },
                                    parent: function (e) {
                                        return !r.pseudos.empty(e)
                                    },
                                    header: function (e) {
                                        return K.test(e.nodeName)
                                    },
                                    input: function (e) {
                                        return X.test(e.nodeName)
                                    },
                                    button: function (e) {
                                        var t = e.nodeName.toLowerCase();
                                        return "input" === t && "button" === e.type || "button" === t
                                    },
                                    text: function (e) {
                                        var t;
                                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                                    },
                                    first: ye((function () {
                                        return [0]
                                    })),
                                    last: ye((function (e, t) {
                                        return [t - 1]
                                    })),
                                    eq: ye((function (e, t, n) {
                                        return [n < 0 ? n + t : n]
                                    })),
                                    even: ye((function (e, t) {
                                        for (var n = 0; n < t; n += 2) e.push(n);
                                        return e
                                    })),
                                    odd: ye((function (e, t) {
                                        for (var n = 1; n < t; n += 2) e.push(n);
                                        return e
                                    })),
                                    lt: ye((function (e, t, n) {
                                        for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r;) e.push(r);
                                        return e
                                    })),
                                    gt: ye((function (e, t, n) {
                                        for (var r = n < 0 ? n + t : n; ++r < t;) e.push(r);
                                        return e
                                    }))
                                }
                            }).pseudos.nth = r.pseudos.eq, {
                                radio: !0,
                                checkbox: !0,
                                file: !0,
                                password: !0,
                                image: !0
                            }) r.pseudos[t] = pe(t);
                            for (t in {
                                submit: !0,
                                reset: !0
                            }) r.pseudos[t] = he(t);

                            function ge() {}

                            function _e(e) {
                                for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
                                return r
                            }

                            function Ce(e, t, n) {
                                var r = t.dir,
                                    a = t.next,
                                    i = a || r,
                                    o = n && "parentNode" === i,
                                    u = k++;
                                return t.first ? function (t, n, a) {
                                    for (; t = t[r];)
                                        if (1 === t.nodeType || o) return e(t, n, a);
                                    return !1
                                } : function (t, n, s) {
                                    var c, l, d, f = [w, u];
                                    if (s) {
                                        for (; t = t[r];)
                                            if ((1 === t.nodeType || o) && e(t, n, s)) return !0
                                    } else
                                        for (; t = t[r];)
                                            if (1 === t.nodeType || o)
                                                if (l = (d = t[C] || (t[C] = {}))[t.uniqueID] || (d[t.uniqueID] = {}), a && a === t.nodeName.toLowerCase()) t = t[r] || t;
                                                else {
                                                    if ((c = l[i]) && c[0] === w && c[1] === u) return f[2] = c[2];
                                                    if ((l[i] = f)[2] = e(t, n, s)) return !0
                                                } return !1
                                }
                            }

                            function be(e) {
                                return 1 < e.length ? function (t, n, r) {
                                    for (var a = e.length; a--;)
                                        if (!e[a](t, n, r)) return !1;
                                    return !0
                                } : e[0]
                            }

                            function we(e, t, n, r, a) {
                                for (var i, o = [], u = 0, s = e.length, c = null != t; u < s; u++)(i = e[u]) && (n && !n(i, r, a) || (o.push(i), c && t.push(u)));
                                return o
                            }

                            function ke(e, t, n, r, a, i) {
                                return r && !r[C] && (r = ke(r)), a && !a[C] && (a = ke(a, i)), ce((function (i, o, u, s) {
                                    var c, l, d, f = [],
                                        p = [],
                                        h = o.length,
                                        v = i || function (e, t, n) {
                                            for (var r = 0, a = t.length; r < a; r++) ue(e, t[r], n);
                                            return n
                                        }(t || "*", u.nodeType ? [u] : u, []),
                                        y = !e || !i && t ? v : we(v, f, e, u, s),
                                        m = n ? a || (i ? e : h || r) ? [] : o : y;
                                    if (n && n(y, m, u, s), r)
                                        for (c = we(m, p), r(c, [], u, s), l = c.length; l--;)(d = c[l]) && (m[p[l]] = !(y[p[l]] = d));
                                    if (i) {
                                        if (a || e) {
                                            if (a) {
                                                for (c = [], l = m.length; l--;)(d = m[l]) && c.push(y[l] = d);
                                                a(null, m = [], c, s)
                                            }
                                            for (l = m.length; l--;)(d = m[l]) && -1 < (c = a ? L(i, d) : f[l]) && (i[c] = !(o[c] = d))
                                        }
                                    } else m = we(m === o ? m.splice(h, m.length) : m), a ? a(null, o, m, s) : B.apply(o, m)
                                }))
                            }

                            function Se(e) {
                                for (var t, n, a, i = e.length, o = r.relative[e[0].type], u = o || r.relative[" "], s = o ? 1 : 0, l = Ce((function (e) {
                                    return e === t
                                }), u, !0), d = Ce((function (e) {
                                    return -1 < L(t, e)
                                }), u, !0), f = [function (e, n, r) {
                                    var a = !o && (r || n !== c) || ((t = n).nodeType ? l(e, n, r) : d(e, n, r));
                                    return t = null, a
                                }]; s < i; s++)
                                    if (n = r.relative[e[s].type]) f = [Ce(be(f), n)];
                                    else {
                                        if ((n = r.filter[e[s].type].apply(null, e[s].matches))[C]) {
                                            for (a = ++s; a < i && !r.relative[e[a].type]; a++);
                                            return ke(1 < s && be(f), 1 < s && _e(e.slice(0, s - 1).concat({
                                                value: " " === e[s - 2].type ? "*" : ""
                                            })).replace(H, "$1"), n, s < a && Se(e.slice(s, a)), a < i && Se(e = e.slice(a)), a < i && _e(e))
                                        }
                                        f.push(n)
                                    } return be(f)
                            }
                            return ge.prototype = r.filters = r.pseudos, r.setFilters = new ge, o = ue.tokenize = function (e, t) {
                                var n, a, i, o, u, s, c, l = x[e + " "];
                                if (l) return t ? 0 : l.slice(0);
                                for (u = e, s = [], c = r.preFilter; u;) {
                                    for (o in n && !(a = M.exec(u)) || (a && (u = u.slice(a[0].length) || u), s.push(i = [])), n = !1, (a = $.exec(u)) && (n = a.shift(), i.push({
                                        value: n,
                                        type: a[0].replace(H, " ")
                                    }), u = u.slice(n.length)), r.filter) !(a = Q[o].exec(u)) || c[o] && !(a = c[o](a)) || (n = a.shift(), i.push({
                                        value: n,
                                        type: o,
                                        matches: a
                                    }), u = u.slice(n.length));
                                    if (!n) break
                                }
                                return t ? u.length : u ? ue.error(e) : x(e, s).slice(0)
                            }, u = ue.compile = function (e, t) {
                                var n, a, i, u, s, l, d = [],
                                    h = [],
                                    y = T[e + " "];
                                if (!y) {
                                    for (t || (t = o(e)), n = t.length; n--;)(y = Se(t[n]))[C] ? d.push(y) : h.push(y);
                                    (y = T(e, (a = h, u = 0 < (i = d).length, s = 0 < a.length, l = function (e, t, n, o, l) {
                                        var d, h, y, m = 0,
                                            g = "0",
                                            _ = e && [],
                                            C = [],
                                            b = c,
                                            k = e || s && r.find.TAG("*", l),
                                            S = w += null == b ? 1 : Math.random() || .1,
                                            x = k.length;
                                        for (l && (c = t == p || t || l); g !== x && null != (d = k[g]); g++) {
                                            if (s && d) {
                                                for (h = 0, t || d.ownerDocument == p || (f(d), n = !v); y = a[h++];)
                                                    if (y(d, t || p, n)) {
                                                        o.push(d);
                                                        break
                                                    } l && (w = S)
                                            }
                                            u && ((d = !y && d) && m--, e && _.push(d))
                                        }
                                        if (m += g, u && g !== m) {
                                            for (h = 0; y = i[h++];) y(_, C, t, n);
                                            if (e) {
                                                if (0 < m)
                                                    for (; g--;) _[g] || C[g] || (C[g] = O.call(o));
                                                C = we(C)
                                            }
                                            B.apply(o, C), l && !e && 0 < C.length && 1 < m + i.length && ue.uniqueSort(o)
                                        }
                                        return l && (w = S, c = b), _
                                    }, u ? ce(l) : l))).selector = e
                                }
                                return y
                            }, s = ue.select = function (e, t, n, a) {
                                var i, s, c, l, d, f = "function" == typeof e && e,
                                    p = !a && o(e = f.selector || e);
                                if (n = n || [], 1 === p.length) {
                                    if (2 < (s = p[0] = p[0].slice(0)).length && "ID" === (c = s[0]).type && 9 === t.nodeType && v && r.relative[s[1].type]) {
                                        if (!(t = (r.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
                                        f && (t = t.parentNode), e = e.slice(s.shift().value.length)
                                    }
                                    for (i = Q.needsContext.test(e) ? 0 : s.length; i-- && (c = s[i], !r.relative[l = c.type]);)
                                        if ((d = r.find[l]) && (a = d(c.matches[0].replace(te, ne), ee.test(s[0].type) && me(t.parentNode) || t))) {
                                            if (s.splice(i, 1), !(e = a.length && _e(s))) return B.apply(n, a), n;
                                            break
                                        }
                                }
                                return (f || u(e, p))(a, t, !v, n, !t || ee.test(e) && me(t.parentNode) || t), n
                            }, n.sortStable = C.split("").sort(E).join("") === C, n.detectDuplicates = !!d, f(), n.sortDetached = le((function (e) {
                                return 1 & e.compareDocumentPosition(p.createElement("fieldset"))
                            })), le((function (e) {
                                return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
                            })) || de("type|href|height|width", (function (e, t, n) {
                                if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
                            })), n.attributes && le((function (e) {
                                return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
                            })) || de("value", (function (e, t, n) {
                                if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue
                            })), le((function (e) {
                                return null == e.getAttribute("disabled")
                            })) || de(N, (function (e, t, n) {
                                var r;
                                if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null
                            })), ue
                        }(e);
                        b.find = k, b.expr = k.selectors, b.expr[":"] = b.expr.pseudos, b.uniqueSort = b.unique = k.uniqueSort, b.text = k.getText, b.isXMLDoc = k.isXML, b.contains = k.contains, b.escapeSelector = k.escape;
                        var S = function (e, t, n) {
                                for (var r = [], a = void 0 !== n;
                                     (e = e[t]) && 9 !== e.nodeType;)
                                    if (1 === e.nodeType) {
                                        if (a && b(e).is(n)) break;
                                        r.push(e)
                                    } return r
                            },
                            x = function (e, t) {
                                for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
                                return n
                            },
                            T = b.expr.match.needsContext;

                        function A(e, t) {
                            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
                        }
                        var E = /^<([a-z][^\/\0>: \t\r\n\f]*)[ \t\r\n\f]*\/?>(?:<\/\1>|)$/i;

                        function P(e, t, n) {
                            return h(t) ? b.grep(e, (function (e, r) {
                                return !!t.call(e, r, e) !== n
                            })) : t.nodeType ? b.grep(e, (function (e) {
                                return e === t !== n
                            })) : "string" != typeof t ? b.grep(e, (function (e) {
                                return -1 < u.call(t, e) !== n
                            })) : b.filter(t, e, n)
                        }
                        b.filter = function (e, t, n) {
                            var r = t[0];
                            return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? b.find.matchesSelector(r, e) ? [r] : [] : b.find.matches(e, b.grep(t, (function (e) {
                                return 1 === e.nodeType
                            })))
                        }, b.fn.extend({
                            find: function (e) {
                                var t, n, r = this.length,
                                    a = this;
                                if ("string" != typeof e) return this.pushStack(b(e).filter((function () {
                                    for (t = 0; t < r; t++)
                                        if (b.contains(a[t], this)) return !0
                                })));
                                for (n = this.pushStack([]), t = 0; t < r; t++) b.find(e, a[t], n);
                                return 1 < r ? b.uniqueSort(n) : n
                            },
                            filter: function (e) {
                                return this.pushStack(P(this, e || [], !1))
                            },
                            not: function (e) {
                                return this.pushStack(P(this, e || [], !0))
                            },
                            is: function (e) {
                                return !!P(this, "string" == typeof e && T.test(e) ? b(e) : e || [], !1).length
                            }
                        });
                        var I, O = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
                        (b.fn.init = function (e, t, n) {
                            var r, a;
                            if (!e) return this;
                            if (n = n || I, "string" == typeof e) {
                                if (!(r = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : O.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                                if (r[1]) {
                                    if (t = t instanceof b ? t[0] : t, b.merge(this, b.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : y, !0)), E.test(r[1]) && b.isPlainObject(t))
                                        for (r in t) h(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                                    return this
                                }
                                return (a = y.getElementById(r[2])) && (this[0] = a, this.length = 1), this
                            }
                            return e.nodeType ? (this[0] = e, this.length = 1, this) : h(e) ? void 0 !== n.ready ? n.ready(e) : e(b) : b.makeArray(e, this)
                        }).prototype = b.fn, I = b(y);
                        var D = /^(?:parents|prev(?:Until|All))/,
                            B = {
                                children: !0,
                                contents: !0,
                                next: !0,
                                prev: !0
                            };

                        function j(e, t) {
                            for (;
                                (e = e[t]) && 1 !== e.nodeType;);
                            return e
                        }
                        b.fn.extend({
                            has: function (e) {
                                var t = b(e, this),
                                    n = t.length;
                                return this.filter((function () {
                                    for (var e = 0; e < n; e++)
                                        if (b.contains(this, t[e])) return !0
                                }))
                            },
                            closest: function (e, t) {
                                var n, r = 0,
                                    a = this.length,
                                    i = [],
                                    o = "string" != typeof e && b(e);
                                if (!T.test(e))
                                    for (; r < a; r++)
                                        for (n = this[r]; n && n !== t; n = n.parentNode)
                                            if (n.nodeType < 11 && (o ? -1 < o.index(n) : 1 === n.nodeType && b.find.matchesSelector(n, e))) {
                                                i.push(n);
                                                break
                                            } return this.pushStack(1 < i.length ? b.uniqueSort(i) : i)
                            },
                            index: function (e) {
                                return e ? "string" == typeof e ? u.call(b(e), this[0]) : u.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
                            },
                            add: function (e, t) {
                                return this.pushStack(b.uniqueSort(b.merge(this.get(), b(e, t))))
                            },
                            addBack: function (e) {
                                return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
                            }
                        }), b.each({
                            parent: function (e) {
                                var t = e.parentNode;
                                return t && 11 !== t.nodeType ? t : null
                            },
                            parents: function (e) {
                                return S(e, "parentNode")
                            },
                            parentsUntil: function (e, t, n) {
                                return S(e, "parentNode", n)
                            },
                            next: function (e) {
                                return j(e, "nextSibling")
                            },
                            prev: function (e) {
                                return j(e, "previousSibling")
                            },
                            nextAll: function (e) {
                                return S(e, "nextSibling")
                            },
                            prevAll: function (e) {
                                return S(e, "previousSibling")
                            },
                            nextUntil: function (e, t, n) {
                                return S(e, "nextSibling", n)
                            },
                            prevUntil: function (e, t, n) {
                                return S(e, "previousSibling", n)
                            },
                            siblings: function (e) {
                                return x((e.parentNode || {}).firstChild, e)
                            },
                            children: function (e) {
                                return x(e.firstChild)
                            },
                            contents: function (e) {
                                return null != e.contentDocument && r(e.contentDocument) ? e.contentDocument : (A(e, "template") && (e = e.content || e), b.merge([], e.childNodes))
                            }
                        }, (function (e, t) {
                            b.fn[e] = function (n, r) {
                                var a = b.map(this, t, n);
                                return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (a = b.filter(r, a)), 1 < this.length && (B[e] || b.uniqueSort(a), D.test(e) && a.reverse()), this.pushStack(a)
                            }
                        }));
                        var L = /[^ \t\r\n\f]+/g;

                        function N(e) {
                            return e
                        }

                        function R(e) {
                            throw e
                        }

                        function F(e, t, n, r) {
                            var a;
                            try {
                                e && h(a = e.promise) ? a.call(e).done(t).fail(n) : e && h(a = e.then) ? a.call(e, t, n) : t.apply(void 0, [e].slice(r))
                            } catch (e) {
                                n.apply(void 0, [e])
                            }
                        }
                        b.Callbacks = function (e) {
                            var t, n;
                            e = "string" == typeof e ? (t = e, n = {}, b.each(t.match(L) || [], (function (e, t) {
                                n[t] = !0
                            })), n) : b.extend({}, e);
                            var r, a, i, o, u = [],
                                s = [],
                                c = -1,
                                l = function () {
                                    for (o = o || e.once, i = r = !0; s.length; c = -1)
                                        for (a = s.shift(); ++c < u.length;) !1 === u[c].apply(a[0], a[1]) && e.stopOnFalse && (c = u.length, a = !1);
                                    e.memory || (a = !1), r = !1, o && (u = a ? [] : "")
                                },
                                d = {
                                    add: function () {
                                        return u && (a && !r && (c = u.length - 1, s.push(a)), function t(n) {
                                            b.each(n, (function (n, r) {
                                                h(r) ? e.unique && d.has(r) || u.push(r) : r && r.length && "string" !== _(r) && t(r)
                                            }))
                                        }(arguments), a && !r && l()), this
                                    },
                                    remove: function () {
                                        return b.each(arguments, (function (e, t) {
                                            for (var n; - 1 < (n = b.inArray(t, u, n));) u.splice(n, 1), n <= c && c--
                                        })), this
                                    },
                                    has: function (e) {
                                        return e ? -1 < b.inArray(e, u) : 0 < u.length
                                    },
                                    empty: function () {
                                        return u && (u = []), this
                                    },
                                    disable: function () {
                                        return o = s = [], u = a = "", this
                                    },
                                    disabled: function () {
                                        return !u
                                    },
                                    lock: function () {
                                        return o = s = [], a || r || (u = a = ""), this
                                    },
                                    locked: function () {
                                        return !!o
                                    },
                                    fireWith: function (e, t) {
                                        return o || (t = [e, (t = t || []).slice ? t.slice() : t], s.push(t), r || l()), this
                                    },
                                    fire: function () {
                                        return d.fireWith(this, arguments), this
                                    },
                                    fired: function () {
                                        return !!i
                                    }
                                };
                            return d
                        }, b.extend({
                            Deferred: function (t) {
                                var n = [
                                        ["notify", "progress", b.Callbacks("memory"), b.Callbacks("memory"), 2],
                                        ["resolve", "done", b.Callbacks("once memory"), b.Callbacks("once memory"), 0, "resolved"],
                                        ["reject", "fail", b.Callbacks("once memory"), b.Callbacks("once memory"), 1, "rejected"]
                                    ],
                                    r = "pending",
                                    a = {
                                        state: function () {
                                            return r
                                        },
                                        always: function () {
                                            return i.done(arguments).fail(arguments), this
                                        },
                                        catch: function (e) {
                                            return a.then(null, e)
                                        },
                                        pipe: function () {
                                            var e = arguments;
                                            return b.Deferred((function (t) {
                                                b.each(n, (function (n, r) {
                                                    var a = h(e[r[4]]) && e[r[4]];
                                                    i[r[1]]((function () {
                                                        var e = a && a.apply(this, arguments);
                                                        e && h(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[r[0] + "With"](this, a ? [e] : arguments)
                                                    }))
                                                })), e = null
                                            })).promise()
                                        },
                                        then: function (t, r, a) {
                                            var i = 0;

                                            function o(t, n, r, a) {
                                                return function () {
                                                    var u = this,
                                                        s = arguments,
                                                        c = function () {
                                                            var e, c;
                                                            if (!(t < i)) {
                                                                if ((e = r.apply(u, s)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                                                c = e && ("object" == typeof e || "function" == typeof e) && e.then, h(c) ? a ? c.call(e, o(i, n, N, a), o(i, n, R, a)) : (i++, c.call(e, o(i, n, N, a), o(i, n, R, a), o(i, n, N, n.notifyWith))) : (r !== N && (u = void 0, s = [e]), (a || n.resolveWith)(u, s))
                                                            }
                                                        },
                                                        l = a ? c : function () {
                                                            try {
                                                                c()
                                                            } catch (e) {
                                                                b.Deferred.exceptionHook && b.Deferred.exceptionHook(e, l.stackTrace), i <= t + 1 && (r !== R && (u = void 0, s = [e]), n.rejectWith(u, s))
                                                            }
                                                        };
                                                    t ? l() : (b.Deferred.getStackHook && (l.stackTrace = b.Deferred.getStackHook()), e.setTimeout(l))
                                                }
                                            }
                                            return b.Deferred((function (e) {
                                                n[0][3].add(o(0, e, h(a) ? a : N, e.notifyWith)), n[1][3].add(o(0, e, h(t) ? t : N)), n[2][3].add(o(0, e, h(r) ? r : R))
                                            })).promise()
                                        },
                                        promise: function (e) {
                                            return null != e ? b.extend(e, a) : a
                                        }
                                    },
                                    i = {};
                                return b.each(n, (function (e, t) {
                                    var o = t[2],
                                        u = t[5];
                                    a[t[1]] = o.add, u && o.add((function () {
                                        r = u
                                    }), n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock), o.add(t[3].fire), i[t[0]] = function () {
                                        return i[t[0] + "With"](this === i ? void 0 : this, arguments), this
                                    }, i[t[0] + "With"] = o.fireWith
                                })), a.promise(i), t && t.call(i, i), i
                            },
                            when: function (e) {
                                var t = arguments.length,
                                    n = t,
                                    r = Array(n),
                                    i = a.call(arguments),
                                    o = b.Deferred(),
                                    u = function (e) {
                                        return function (n) {
                                            r[e] = this, i[e] = 1 < arguments.length ? a.call(arguments) : n, --t || o.resolveWith(r, i)
                                        }
                                    };
                                if (t <= 1 && (F(e, o.done(u(n)).resolve, o.reject, !t), "pending" === o.state() || h(i[n] && i[n].then))) return o.then();
                                for (; n--;) F(i[n], u(n), o.reject);
                                return o.promise()
                            }
                        });
                        var q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
                        b.Deferred.exceptionHook = function (t, n) {
                            e.console && e.console.warn && t && q.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n)
                        }, b.readyException = function (t) {
                            e.setTimeout((function () {
                                throw t
                            }))
                        };
                        var U = b.Deferred();

                        function V() {
                            y.removeEventListener("DOMContentLoaded", V), e.removeEventListener("load", V), b.ready()
                        }
                        b.fn.ready = function (e) {
                            return U.then(e).catch((function (e) {
                                b.readyException(e)
                            })), this
                        }, b.extend({
                            isReady: !1,
                            readyWait: 1,
                            ready: function (e) {
                                (!0 === e ? --b.readyWait : b.isReady) || (b.isReady = !0) !== e && 0 < --b.readyWait || U.resolveWith(y, [b])
                            }
                        }), b.ready.then = U.then, "complete" === y.readyState || "loading" !== y.readyState && !y.documentElement.doScroll ? e.setTimeout(b.ready) : (y.addEventListener("DOMContentLoaded", V), e.addEventListener("load", V));
                        var H = function (e, t, n, r, a, i, o) {
                                var u = 0,
                                    s = e.length,
                                    c = null == n;
                                if ("object" === _(n))
                                    for (u in a = !0, n) H(e, t, u, n[u], !0, i, o);
                                else if (void 0 !== r && (a = !0, h(r) || (o = !0), c && (o ? (t.call(e, r), t = null) : (c = t, t = function (e, t, n) {
                                    return c.call(b(e), n)
                                })), t))
                                    for (; u < s; u++) t(e[u], n, o ? r : r.call(e[u], u, t(e[u], n)));
                                return a ? e : c ? t.call(e) : s ? t(e[0], n) : i
                            },
                            M = /^-ms-/,
                            $ = /-([a-z])/g;

                        function W(e, t) {
                            return t.toUpperCase()
                        }

                        function z(e) {
                            return e.replace(M, "ms-").replace($, W)
                        }
                        var G = function (e) {
                            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
                        };

                        function Q() {
                            this.expando = b.expando + Q.uid++
                        }
                        Q.uid = 1, Q.prototype = {
                            cache: function (e) {
                                var t = e[this.expando];
                                return t || (t = {}, G(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                                    value: t,
                                    configurable: !0
                                }))), t
                            },
                            set: function (e, t, n) {
                                var r, a = this.cache(e);
                                if ("string" == typeof t) a[z(t)] = n;
                                else
                                    for (r in t) a[z(r)] = t[r];
                                return a
                            },
                            get: function (e, t) {
                                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][z(t)]
                            },
                            access: function (e, t, n) {
                                return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t)
                            },
                            remove: function (e, t) {
                                var n, r = e[this.expando];
                                if (void 0 !== r) {
                                    if (void 0 !== t) {
                                        n = (t = Array.isArray(t) ? t.map(z) : (t = z(t)) in r ? [t] : t.match(L) || []).length;
                                        for (; n--;) delete r[t[n]]
                                    }(void 0 === t || b.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
                                }
                            },
                            hasData: function (e) {
                                var t = e[this.expando];
                                return void 0 !== t && !b.isEmptyObject(t)
                            }
                        };
                        var Y = new Q,
                            X = new Q,
                            K = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                            J = /[A-Z]/g;

                        function Z(e, t, n) {
                            var r, a;
                            if (void 0 === n && 1 === e.nodeType)
                                if (r = "data-" + t.replace(J, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
                                    try {
                                        n = "true" === (a = n) || "false" !== a && ("null" === a ? null : a === +a + "" ? +a : K.test(a) ? JSON.parse(a) : a)
                                    } catch (e) {}
                                    X.set(e, t, n)
                                } else n = void 0;
                            return n
                        }
                        b.extend({
                            hasData: function (e) {
                                return X.hasData(e) || Y.hasData(e)
                            },
                            data: function (e, t, n) {
                                return X.access(e, t, n)
                            },
                            removeData: function (e, t) {
                                X.remove(e, t)
                            },
                            _data: function (e, t, n) {
                                return Y.access(e, t, n)
                            },
                            _removeData: function (e, t) {
                                Y.remove(e, t)
                            }
                        }), b.fn.extend({
                            data: function (e, t) {
                                var n, r, a, i = this[0],
                                    o = i && i.attributes;
                                if (void 0 === e) {
                                    if (this.length && (a = X.get(i), 1 === i.nodeType && !Y.get(i, "hasDataAttrs"))) {
                                        for (n = o.length; n--;) o[n] && 0 === (r = o[n].name).indexOf("data-") && (r = z(r.slice(5)), Z(i, r, a[r]));
                                        Y.set(i, "hasDataAttrs", !0)
                                    }
                                    return a
                                }
                                return "object" == typeof e ? this.each((function () {
                                    X.set(this, e)
                                })) : H(this, (function (t) {
                                    var n;
                                    if (i && void 0 === t) return void 0 !== (n = X.get(i, e)) || void 0 !== (n = Z(i, e)) ? n : void 0;
                                    this.each((function () {
                                        X.set(this, e, t)
                                    }))
                                }), null, t, 1 < arguments.length, null, !0)
                            },
                            removeData: function (e) {
                                return this.each((function () {
                                    X.remove(this, e)
                                }))
                            }
                        }), b.extend({
                            queue: function (e, t, n) {
                                var r;
                                if (e) return t = (t || "fx") + "queue", r = Y.get(e, t), n && (!r || Array.isArray(n) ? r = Y.access(e, t, b.makeArray(n)) : r.push(n)), r || []
                            },
                            dequeue: function (e, t) {
                                t = t || "fx";
                                var n = b.queue(e, t),
                                    r = n.length,
                                    a = n.shift(),
                                    i = b._queueHooks(e, t);
                                "inprogress" === a && (a = n.shift(), r--), a && ("fx" === t && n.unshift("inprogress"), delete i.stop, a.call(e, (function () {
                                    b.dequeue(e, t)
                                }), i)), !r && i && i.empty.fire()
                            },
                            _queueHooks: function (e, t) {
                                var n = t + "queueHooks";
                                return Y.get(e, n) || Y.access(e, n, {
                                    empty: b.Callbacks("once memory").add((function () {
                                        Y.remove(e, [t + "queue", n])
                                    }))
                                })
                            }
                        }), b.fn.extend({
                            queue: function (e, t) {
                                var n = 2;
                                return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? b.queue(this[0], e) : void 0 === t ? this : this.each((function () {
                                    var n = b.queue(this, e, t);
                                    b._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && b.dequeue(this, e)
                                }))
                            },
                            dequeue: function (e) {
                                return this.each((function () {
                                    b.dequeue(this, e)
                                }))
                            },
                            clearQueue: function (e) {
                                return this.queue(e || "fx", [])
                            },
                            promise: function (e, t) {
                                var n, r = 1,
                                    a = b.Deferred(),
                                    i = this,
                                    o = this.length,
                                    u = function () {
                                        --r || a.resolveWith(i, [i])
                                    };
                                for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; o--;)(n = Y.get(i[o], e + "queueHooks")) && n.empty && (r++, n.empty.add(u));
                                return u(), a.promise(t)
                            }
                        });
                        var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                            te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
                            ne = ["Top", "Right", "Bottom", "Left"],
                            re = y.documentElement,
                            ae = function (e) {
                                return b.contains(e.ownerDocument, e)
                            },
                            ie = {
                                composed: !0
                            };
                        re.getRootNode && (ae = function (e) {
                            return b.contains(e.ownerDocument, e) || e.getRootNode(ie) === e.ownerDocument
                        });
                        var oe = function (e, t) {
                            return "none" === (e = t || e).style.display || "" === e.style.display && ae(e) && "none" === b.css(e, "display")
                        };

                        function ue(e, t, n, r) {
                            var a, i, o = 20,
                                u = r ? function () {
                                    return r.cur()
                                } : function () {
                                    return b.css(e, t, "")
                                },
                                s = u(),
                                c = n && n[3] || (b.cssNumber[t] ? "" : "px"),
                                l = e.nodeType && (b.cssNumber[t] || "px" !== c && +s) && te.exec(b.css(e, t));
                            if (l && l[3] !== c) {
                                for (s /= 2, c = c || l[3], l = +s || 1; o--;) b.style(e, t, l + c), (1 - i) * (1 - (i = u() / s || .5)) <= 0 && (o = 0), l /= i;
                                l *= 2, b.style(e, t, l + c), n = n || []
                            }
                            return n && (l = +l || +s || 0, a = n[1] ? l + (n[1] + 1) * n[2] : +n[2], r && (r.unit = c, r.start = l, r.end = a)), a
                        }
                        var se = {};

                        function ce(e, t) {
                            for (var n, r, a, i, o, u, s, c = [], l = 0, d = e.length; l < d; l++)(r = e[l]).style && (n = r.style.display, t ? ("none" === n && (c[l] = Y.get(r, "display") || null, c[l] || (r.style.display = "")), "" === r.style.display && oe(r) && (c[l] = (s = o = i = void 0, o = (a = r).ownerDocument, u = a.nodeName, (s = se[u]) || (i = o.body.appendChild(o.createElement(u)), s = b.css(i, "display"), i.parentNode.removeChild(i), "none" === s && (s = "block"), se[u] = s)))) : "none" !== n && (c[l] = "none", Y.set(r, "display", n)));
                            for (l = 0; l < d; l++) null != c[l] && (e[l].style.display = c[l]);
                            return e
                        }
                        b.fn.extend({
                            show: function () {
                                return ce(this, !0)
                            },
                            hide: function () {
                                return ce(this)
                            },
                            toggle: function (e) {
                                return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each((function () {
                                    oe(this) ? b(this).show() : b(this).hide()
                                }))
                            }
                        });
                        var le, de, fe = /^(?:checkbox|radio)$/i,
                            pe = /<([a-z][^\/\0> \t\r\n\f]*)/i,
                            he = /^$|^module$|\/(?:java|ecma)script/i;
                        le = y.createDocumentFragment().appendChild(y.createElement("div")), (de = y.createElement("input")).setAttribute("type", "radio"), de.setAttribute("checked", "checked"), de.setAttribute("name", "t"), le.appendChild(de), p.checkClone = le.cloneNode(!0).cloneNode(!0).lastChild.checked, le.innerHTML = "<textarea>x</textarea>", p.noCloneChecked = !!le.cloneNode(!0).lastChild.defaultValue, le.innerHTML = "<option></option>", p.option = !!le.lastChild;
                        var ve = {
                            thead: [1, "<table>", "</table>"],
                            col: [2, "<table><colgroup>", "</colgroup></table>"],
                            tr: [2, "<table><tbody>", "</tbody></table>"],
                            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                            _default: [0, "", ""]
                        };

                        function ye(e, t) {
                            var n;
                            return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && A(e, t) ? b.merge([e], n) : n
                        }

                        function me(e, t) {
                            for (var n = 0, r = e.length; n < r; n++) Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"))
                        }
                        ve.tbody = ve.tfoot = ve.colgroup = ve.caption = ve.thead, ve.th = ve.td, p.option || (ve.optgroup = ve.option = [1, "<select multiple='multiple'>", "</select>"]);
                        var ge = /<|&#?\w+;/;

                        function _e(e, t, n, r, a) {
                            for (var i, o, u, s, c, l, d = t.createDocumentFragment(), f = [], p = 0, h = e.length; p < h; p++)
                                if ((i = e[p]) || 0 === i)
                                    if ("object" === _(i)) b.merge(f, i.nodeType ? [i] : i);
                                    else if (ge.test(i)) {
                                        for (o = o || d.appendChild(t.createElement("div")), u = (pe.exec(i) || ["", ""])[1].toLowerCase(), s = ve[u] || ve._default, o.innerHTML = s[1] + b.htmlPrefilter(i) + s[2], l = s[0]; l--;) o = o.lastChild;
                                        b.merge(f, o.childNodes), (o = d.firstChild).textContent = ""
                                    } else f.push(t.createTextNode(i));
                            for (d.textContent = "", p = 0; i = f[p++];)
                                if (r && -1 < b.inArray(i, r)) a && a.push(i);
                                else if (c = ae(i), o = ye(d.appendChild(i), "script"), c && me(o), n)
                                    for (l = 0; i = o[l++];) he.test(i.type || "") && n.push(i);
                            return d
                        }
                        var Ce = /^key/,
                            be = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
                            we = /^([^.]*)(?:\.(.+)|)/;

                        function ke() {
                            return !0
                        }

                        function Se() {
                            return !1
                        }

                        function xe(e, t) {
                            return e === function () {
                                try {
                                    return y.activeElement
                                } catch (e) {}
                            }() == ("focus" === t)
                        }

                        function Te(e, t, n, r, a, i) {
                            var o, u;
                            if ("object" == typeof t) {
                                for (u in "string" != typeof n && (r = r || n, n = void 0), t) Te(e, u, n, r, t[u], i);
                                return e
                            }
                            if (null == r && null == a ? (a = n, r = n = void 0) : null == a && ("string" == typeof n ? (a = r, r = void 0) : (a = r, r = n, n = void 0)), !1 === a) a = Se;
                            else if (!a) return e;
                            return 1 === i && (o = a, (a = function (e) {
                                return b().off(e), o.apply(this, arguments)
                            }).guid = o.guid || (o.guid = b.guid++)), e.each((function () {
                                b.event.add(this, t, a, r, n)
                            }))
                        }

                        function Ae(e, t, n) {
                            n ? (Y.set(e, t, !1), b.event.add(e, t, {
                                namespace: !1,
                                handler: function (e) {
                                    var r, i, o = Y.get(this, t);
                                    if (1 & e.isTrigger && this[t]) {
                                        if (o.length)(b.event.special[t] || {}).delegateType && e.stopPropagation();
                                        else if (o = a.call(arguments), Y.set(this, t, o), r = n(this, t), this[t](), o !== (i = Y.get(this, t)) || r ? Y.set(this, t, !1) : i = {}, o !== i) return e.stopImmediatePropagation(), e.preventDefault(), i.value
                                    } else o.length && (Y.set(this, t, {
                                        value: b.event.trigger(b.extend(o[0], b.Event.prototype), o.slice(1), this)
                                    }), e.stopImmediatePropagation())
                                }
                            })) : void 0 === Y.get(e, t) && b.event.add(e, t, ke)
                        }
                        b.event = {
                            global: {},
                            add: function (e, t, n, r, a) {
                                var i, o, u, s, c, l, d, f, p, h, v, y = Y.get(e);
                                if (G(e))
                                    for (n.handler && (n = (i = n).handler, a = i.selector), a && b.find.matchesSelector(re, a), n.guid || (n.guid = b.guid++), (s = y.events) || (s = y.events = Object.create(null)), (o = y.handle) || (o = y.handle = function (t) {
                                        return void 0 !== b && b.event.triggered !== t.type ? b.event.dispatch.apply(e, arguments) : void 0
                                    }), c = (t = (t || "").match(L) || [""]).length; c--;) p = v = (u = we.exec(t[c]) || [])[1], h = (u[2] || "").split(".").sort(), p && (d = b.event.special[p] || {}, p = (a ? d.delegateType : d.bindType) || p, d = b.event.special[p] || {}, l = b.extend({
                                        type: p,
                                        origType: v,
                                        data: r,
                                        handler: n,
                                        guid: n.guid,
                                        selector: a,
                                        needsContext: a && b.expr.match.needsContext.test(a),
                                        namespace: h.join(".")
                                    }, i), (f = s[p]) || ((f = s[p] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(e, r, h, o) || e.addEventListener && e.addEventListener(p, o)), d.add && (d.add.call(e, l), l.handler.guid || (l.handler.guid = n.guid)), a ? f.splice(f.delegateCount++, 0, l) : f.push(l), b.event.global[p] = !0)
                            },
                            remove: function (e, t, n, r, a) {
                                var i, o, u, s, c, l, d, f, p, h, v, y = Y.hasData(e) && Y.get(e);
                                if (y && (s = y.events)) {
                                    for (c = (t = (t || "").match(L) || [""]).length; c--;)
                                        if (p = v = (u = we.exec(t[c]) || [])[1], h = (u[2] || "").split(".").sort(), p) {
                                            for (d = b.event.special[p] || {}, f = s[p = (r ? d.delegateType : d.bindType) || p] || [], u = u[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), o = i = f.length; i--;) l = f[i], !a && v !== l.origType || n && n.guid !== l.guid || u && !u.test(l.namespace) || r && r !== l.selector && ("**" !== r || !l.selector) || (f.splice(i, 1), l.selector && f.delegateCount--, d.remove && d.remove.call(e, l));
                                            o && !f.length && (d.teardown && !1 !== d.teardown.call(e, h, y.handle) || b.removeEvent(e, p, y.handle), delete s[p])
                                        } else
                                            for (p in s) b.event.remove(e, p + t[c], n, r, !0);
                                    b.isEmptyObject(s) && Y.remove(e, "handle events")
                                }
                            },
                            dispatch: function (e) {
                                var t, n, r, a, i, o, u = new Array(arguments.length),
                                    s = b.event.fix(e),
                                    c = (Y.get(this, "events") || Object.create(null))[s.type] || [],
                                    l = b.event.special[s.type] || {};
                                for (u[0] = s, t = 1; t < arguments.length; t++) u[t] = arguments[t];
                                if (s.delegateTarget = this, !l.preDispatch || !1 !== l.preDispatch.call(this, s)) {
                                    for (o = b.event.handlers.call(this, s, c), t = 0;
                                         (a = o[t++]) && !s.isPropagationStopped();)
                                        for (s.currentTarget = a.elem, n = 0;
                                             (i = a.handlers[n++]) && !s.isImmediatePropagationStopped();) s.rnamespace && !1 !== i.namespace && !s.rnamespace.test(i.namespace) || (s.handleObj = i, s.data = i.data, void 0 !== (r = ((b.event.special[i.origType] || {}).handle || i.handler).apply(a.elem, u)) && !1 === (s.result = r) && (s.preventDefault(), s.stopPropagation()));
                                    return l.postDispatch && l.postDispatch.call(this, s), s.result
                                }
                            },
                            handlers: function (e, t) {
                                var n, r, a, i, o, u = [],
                                    s = t.delegateCount,
                                    c = e.target;
                                if (s && c.nodeType && !("click" === e.type && 1 <= e.button))
                                    for (; c !== this; c = c.parentNode || this)
                                        if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                                            for (i = [], o = {}, n = 0; n < s; n++) void 0 === o[a = (r = t[n]).selector + " "] && (o[a] = r.needsContext ? -1 < b(a, this).index(c) : b.find(a, this, null, [c]).length), o[a] && i.push(r);
                                            i.length && u.push({
                                                elem: c,
                                                handlers: i
                                            })
                                        } return c = this, s < t.length && u.push({
                                    elem: c,
                                    handlers: t.slice(s)
                                }), u
                            },
                            addProp: function (e, t) {
                                Object.defineProperty(b.Event.prototype, e, {
                                    enumerable: !0,
                                    configurable: !0,
                                    get: h(t) ? function () {
                                        if (this.originalEvent) return t(this.originalEvent)
                                    } : function () {
                                        if (this.originalEvent) return this.originalEvent[e]
                                    },
                                    set: function (t) {
                                        Object.defineProperty(this, e, {
                                            enumerable: !0,
                                            configurable: !0,
                                            writable: !0,
                                            value: t
                                        })
                                    }
                                })
                            },
                            fix: function (e) {
                                return e[b.expando] ? e : new b.Event(e)
                            },
                            special: {
                                load: {
                                    noBubble: !0
                                },
                                click: {
                                    setup: function (e) {
                                        var t = this || e;
                                        return fe.test(t.type) && t.click && A(t, "input") && Ae(t, "click", ke), !1
                                    },
                                    trigger: function (e) {
                                        var t = this || e;
                                        return fe.test(t.type) && t.click && A(t, "input") && Ae(t, "click"), !0
                                    },
                                    _default: function (e) {
                                        var t = e.target;
                                        return fe.test(t.type) && t.click && A(t, "input") && Y.get(t, "click") || A(t, "a")
                                    }
                                },
                                beforeunload: {
                                    postDispatch: function (e) {
                                        void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                                    }
                                }
                            }
                        }, b.removeEvent = function (e, t, n) {
                            e.removeEventListener && e.removeEventListener(t, n)
                        }, b.Event = function (e, t) {
                            if (!(this instanceof b.Event)) return new b.Event(e, t);
                            e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? ke : Se, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && b.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[b.expando] = !0
                        }, b.Event.prototype = {
                            constructor: b.Event,
                            isDefaultPrevented: Se,
                            isPropagationStopped: Se,
                            isImmediatePropagationStopped: Se,
                            isSimulated: !1,
                            preventDefault: function () {
                                var e = this.originalEvent;
                                this.isDefaultPrevented = ke, e && !this.isSimulated && e.preventDefault()
                            },
                            stopPropagation: function () {
                                var e = this.originalEvent;
                                this.isPropagationStopped = ke, e && !this.isSimulated && e.stopPropagation()
                            },
                            stopImmediatePropagation: function () {
                                var e = this.originalEvent;
                                this.isImmediatePropagationStopped = ke, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
                            }
                        }, b.each({
                            altKey: !0,
                            bubbles: !0,
                            cancelable: !0,
                            changedTouches: !0,
                            ctrlKey: !0,
                            detail: !0,
                            eventPhase: !0,
                            metaKey: !0,
                            pageX: !0,
                            pageY: !0,
                            shiftKey: !0,
                            view: !0,
                            char: !0,
                            code: !0,
                            charCode: !0,
                            key: !0,
                            keyCode: !0,
                            button: !0,
                            buttons: !0,
                            clientX: !0,
                            clientY: !0,
                            offsetX: !0,
                            offsetY: !0,
                            pointerId: !0,
                            pointerType: !0,
                            screenX: !0,
                            screenY: !0,
                            targetTouches: !0,
                            toElement: !0,
                            touches: !0,
                            which: function (e) {
                                var t = e.button;
                                return null == e.which && Ce.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && be.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
                            }
                        }, b.event.addProp), b.each({
                            focus: "focusin",
                            blur: "focusout"
                        }, (function (e, t) {
                            b.event.special[e] = {
                                setup: function () {
                                    return Ae(this, e, xe), !1
                                },
                                trigger: function () {
                                    return Ae(this, e), !0
                                },
                                delegateType: t
                            }
                        })), b.each({
                            mouseenter: "mouseover",
                            mouseleave: "mouseout",
                            pointerenter: "pointerover",
                            pointerleave: "pointerout"
                        }, (function (e, t) {
                            b.event.special[e] = {
                                delegateType: t,
                                bindType: t,
                                handle: function (e) {
                                    var n, r = e.relatedTarget,
                                        a = e.handleObj;
                                    return r && (r === this || b.contains(this, r)) || (e.type = a.origType, n = a.handler.apply(this, arguments), e.type = t), n
                                }
                            }
                        })), b.fn.extend({
                            on: function (e, t, n, r) {
                                return Te(this, e, t, n, r)
                            },
                            one: function (e, t, n, r) {
                                return Te(this, e, t, n, r, 1)
                            },
                            off: function (e, t, n) {
                                var r, a;
                                if (e && e.preventDefault && e.handleObj) return r = e.handleObj, b(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
                                if ("object" == typeof e) {
                                    for (a in e) this.off(a, t, e[a]);
                                    return this
                                }
                                return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Se), this.each((function () {
                                    b.event.remove(this, e, n, t)
                                }))
                            }
                        });
                        var Ee = /<script|<style|<link/i,
                            Pe = /checked\s*(?:[^=]|=\s*.checked.)/i,
                            Ie = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

                        function Oe(e, t) {
                            return A(e, "table") && A(11 !== t.nodeType ? t : t.firstChild, "tr") && b(e).children("tbody")[0] || e
                        }

                        function De(e) {
                            return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
                        }

                        function Be(e) {
                            return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
                        }

                        function je(e, t) {
                            var n, r, a, i, o, u;
                            if (1 === t.nodeType) {
                                if (Y.hasData(e) && (u = Y.get(e).events))
                                    for (a in Y.remove(t, "handle events"), u)
                                        for (n = 0, r = u[a].length; n < r; n++) b.event.add(t, a, u[a][n]);
                                X.hasData(e) && (i = X.access(e), o = b.extend({}, i), X.set(t, o))
                            }
                        }

                        function Le(e, t, n, r) {
                            t = i(t);
                            var a, o, u, s, c, l, d = 0,
                                f = e.length,
                                v = f - 1,
                                y = t[0],
                                m = h(y);
                            if (m || 1 < f && "string" == typeof y && !p.checkClone && Pe.test(y)) return e.each((function (a) {
                                var i = e.eq(a);
                                m && (t[0] = y.call(this, a, i.html())), Le(i, t, n, r)
                            }));
                            if (f && (o = (a = _e(t, e[0].ownerDocument, !1, e, r)).firstChild, 1 === a.childNodes.length && (a = o), o || r)) {
                                for (s = (u = b.map(ye(a, "script"), De)).length; d < f; d++) c = a, d !== v && (c = b.clone(c, !0, !0), s && b.merge(u, ye(c, "script"))), n.call(e[d], c, d);
                                if (s)
                                    for (l = u[u.length - 1].ownerDocument, b.map(u, Be), d = 0; d < s; d++) c = u[d], he.test(c.type || "") && !Y.access(c, "globalEval") && b.contains(l, c) && (c.src && "module" !== (c.type || "").toLowerCase() ? b._evalUrl && !c.noModule && b._evalUrl(c.src, {
                                        nonce: c.nonce || c.getAttribute("nonce")
                                    }, l) : g(c.textContent.replace(Ie, ""), c, l))
                            }
                            return e
                        }

                        function Ne(e, t, n) {
                            for (var r, a = t ? b.filter(t, e) : e, i = 0; null != (r = a[i]); i++) n || 1 !== r.nodeType || b.cleanData(ye(r)), r.parentNode && (n && ae(r) && me(ye(r, "script")), r.parentNode.removeChild(r));
                            return e
                        }
                        b.extend({
                            htmlPrefilter: function (e) {
                                return e
                            },
                            clone: function (e, t, n) {
                                var r, a, i, o, u, s, c, l = e.cloneNode(!0),
                                    d = ae(e);
                                if (!(p.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || b.isXMLDoc(e)))
                                    for (o = ye(l), r = 0, a = (i = ye(e)).length; r < a; r++) u = i[r], "input" === (c = (s = o[r]).nodeName.toLowerCase()) && fe.test(u.type) ? s.checked = u.checked : "input" !== c && "textarea" !== c || (s.defaultValue = u.defaultValue);
                                if (t)
                                    if (n)
                                        for (i = i || ye(e), o = o || ye(l), r = 0, a = i.length; r < a; r++) je(i[r], o[r]);
                                    else je(e, l);
                                return 0 < (o = ye(l, "script")).length && me(o, !d && ye(e, "script")), l
                            },
                            cleanData: function (e) {
                                for (var t, n, r, a = b.event.special, i = 0; void 0 !== (n = e[i]); i++)
                                    if (G(n)) {
                                        if (t = n[Y.expando]) {
                                            if (t.events)
                                                for (r in t.events) a[r] ? b.event.remove(n, r) : b.removeEvent(n, r, t.handle);
                                            n[Y.expando] = void 0
                                        }
                                        n[X.expando] && (n[X.expando] = void 0)
                                    }
                            }
                        }), b.fn.extend({
                            detach: function (e) {
                                return Ne(this, e, !0)
                            },
                            remove: function (e) {
                                return Ne(this, e)
                            },
                            text: function (e) {
                                return H(this, (function (e) {
                                    return void 0 === e ? b.text(this) : this.empty().each((function () {
                                        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                                    }))
                                }), null, e, arguments.length)
                            },
                            append: function () {
                                return Le(this, arguments, (function (e) {
                                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Oe(this, e).appendChild(e)
                                }))
                            },
                            prepend: function () {
                                return Le(this, arguments, (function (e) {
                                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                        var t = Oe(this, e);
                                        t.insertBefore(e, t.firstChild)
                                    }
                                }))
                            },
                            before: function () {
                                return Le(this, arguments, (function (e) {
                                    this.parentNode && this.parentNode.insertBefore(e, this)
                                }))
                            },
                            after: function () {
                                return Le(this, arguments, (function (e) {
                                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
                                }))
                            },
                            empty: function () {
                                for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (b.cleanData(ye(e, !1)), e.textContent = "");
                                return this
                            },
                            clone: function (e, t) {
                                return e = null != e && e, t = null == t ? e : t, this.map((function () {
                                    return b.clone(this, e, t)
                                }))
                            },
                            html: function (e) {
                                return H(this, (function (e) {
                                    var t = this[0] || {},
                                        n = 0,
                                        r = this.length;
                                    if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                                    if ("string" == typeof e && !Ee.test(e) && !ve[(pe.exec(e) || ["", ""])[1].toLowerCase()]) {
                                        e = b.htmlPrefilter(e);
                                        try {
                                            for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (b.cleanData(ye(t, !1)), t.innerHTML = e);
                                            t = 0
                                        } catch (e) {}
                                    }
                                    t && this.empty().append(e)
                                }), null, e, arguments.length)
                            },
                            replaceWith: function () {
                                var e = [];
                                return Le(this, arguments, (function (t) {
                                    var n = this.parentNode;
                                    b.inArray(this, e) < 0 && (b.cleanData(ye(this)), n && n.replaceChild(t, this))
                                }), e)
                            }
                        }), b.each({
                            appendTo: "append",
                            prependTo: "prepend",
                            insertBefore: "before",
                            insertAfter: "after",
                            replaceAll: "replaceWith"
                        }, (function (e, t) {
                            b.fn[e] = function (e) {
                                for (var n, r = [], a = b(e), i = a.length - 1, u = 0; u <= i; u++) n = u === i ? this : this.clone(!0), b(a[u])[t](n), o.apply(r, n.get());
                                return this.pushStack(r)
                            }
                        }));
                        var Re = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
                            Fe = function (t) {
                                var n = t.ownerDocument.defaultView;
                                return n && n.opener || (n = e), n.getComputedStyle(t)
                            },
                            qe = function (e, t, n) {
                                var r, a, i = {};
                                for (a in t) i[a] = e.style[a], e.style[a] = t[a];
                                for (a in r = n.call(e), t) e.style[a] = i[a];
                                return r
                            },
                            Ue = new RegExp(ne.join("|"), "i");

                        function Ve(e, t, n) {
                            var r, a, i, o, u = e.style;
                            return (n = n || Fe(e)) && ("" !== (o = n.getPropertyValue(t) || n[t]) || ae(e) || (o = b.style(e, t)), !p.pixelBoxStyles() && Re.test(o) && Ue.test(t) && (r = u.width, a = u.minWidth, i = u.maxWidth, u.minWidth = u.maxWidth = u.width = o, o = n.width, u.width = r, u.minWidth = a, u.maxWidth = i)), void 0 !== o ? o + "" : o
                        }

                        function He(e, t) {
                            return {
                                get: function () {
                                    if (!e()) return (this.get = t).apply(this, arguments);
                                    delete this.get
                                }
                            }
                        }! function () {
                            function t() {
                                if (l) {
                                    c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", l.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", re.appendChild(c).appendChild(l);
                                    var t = e.getComputedStyle(l);
                                    r = "1%" !== t.top, s = 12 === n(t.marginLeft), l.style.right = "60%", o = 36 === n(t.right), a = 36 === n(t.width), l.style.position = "absolute", i = 12 === n(l.offsetWidth / 3), re.removeChild(c), l = null
                                }
                            }

                            function n(e) {
                                return Math.round(parseFloat(e))
                            }
                            var r, a, i, o, u, s, c = y.createElement("div"),
                                l = y.createElement("div");
                            l.style && (l.style.backgroundClip = "content-box", l.cloneNode(!0).style.backgroundClip = "", p.clearCloneStyle = "content-box" === l.style.backgroundClip, b.extend(p, {
                                boxSizingReliable: function () {
                                    return t(), a
                                },
                                pixelBoxStyles: function () {
                                    return t(), o
                                },
                                pixelPosition: function () {
                                    return t(), r
                                },
                                reliableMarginLeft: function () {
                                    return t(), s
                                },
                                scrollboxSize: function () {
                                    return t(), i
                                },
                                reliableTrDimensions: function () {
                                    var t, n, r, a;
                                    return null == u && (t = y.createElement("table"), n = y.createElement("tr"), r = y.createElement("div"), t.style.cssText = "position:absolute;left:-11111px", n.style.height = "1px", r.style.height = "9px", re.appendChild(t).appendChild(n).appendChild(r), a = e.getComputedStyle(n), u = 3 < parseInt(a.height), re.removeChild(t)), u
                                }
                            }))
                        }();
                        var Me = ["Webkit", "Moz", "ms"],
                            $e = y.createElement("div").style,
                            We = {};

                        function ze(e) {
                            return b.cssProps[e] || We[e] || (e in $e ? e : We[e] = function (e) {
                                for (var t = e[0].toUpperCase() + e.slice(1), n = Me.length; n--;)
                                    if ((e = Me[n] + t) in $e) return e
                            }(e) || e)
                        }
                        var Ge = /^(none|table(?!-c[ea]).+)/,
                            Qe = /^--/,
                            Ye = {
                                position: "absolute",
                                visibility: "hidden",
                                display: "block"
                            },
                            Xe = {
                                letterSpacing: "0",
                                fontWeight: "400"
                            };

                        function Ke(e, t, n) {
                            var r = te.exec(t);
                            return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t
                        }

                        function Je(e, t, n, r, a, i) {
                            var o = "width" === t ? 1 : 0,
                                u = 0,
                                s = 0;
                            if (n === (r ? "border" : "content")) return 0;
                            for (; o < 4; o += 2) "margin" === n && (s += b.css(e, n + ne[o], !0, a)), r ? ("content" === n && (s -= b.css(e, "padding" + ne[o], !0, a)), "margin" !== n && (s -= b.css(e, "border" + ne[o] + "Width", !0, a))) : (s += b.css(e, "padding" + ne[o], !0, a), "padding" !== n ? s += b.css(e, "border" + ne[o] + "Width", !0, a) : u += b.css(e, "border" + ne[o] + "Width", !0, a));
                            return !r && 0 <= i && (s += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - i - s - u - .5)) || 0), s
                        }

                        function Ze(e, t, n) {
                            var r = Fe(e),
                                a = (!p.boxSizingReliable() || n) && "border-box" === b.css(e, "boxSizing", !1, r),
                                i = a,
                                o = Ve(e, t, r),
                                u = "offset" + t[0].toUpperCase() + t.slice(1);
                            if (Re.test(o)) {
                                if (!n) return o;
                                o = "auto"
                            }
                            return (!p.boxSizingReliable() && a || !p.reliableTrDimensions() && A(e, "tr") || "auto" === o || !parseFloat(o) && "inline" === b.css(e, "display", !1, r)) && e.getClientRects().length && (a = "border-box" === b.css(e, "boxSizing", !1, r), (i = u in e) && (o = e[u])), (o = parseFloat(o) || 0) + Je(e, t, n || (a ? "border" : "content"), i, r, o) + "px"
                        }

                        function et(e, t, n, r, a) {
                            return new et.prototype.init(e, t, n, r, a)
                        }
                        b.extend({
                            cssHooks: {
                                opacity: {
                                    get: function (e, t) {
                                        if (t) {
                                            var n = Ve(e, "opacity");
                                            return "" === n ? "1" : n
                                        }
                                    }
                                }
                            },
                            cssNumber: {
                                animationIterationCount: !0,
                                columnCount: !0,
                                fillOpacity: !0,
                                flexGrow: !0,
                                flexShrink: !0,
                                fontWeight: !0,
                                gridArea: !0,
                                gridColumn: !0,
                                gridColumnEnd: !0,
                                gridColumnStart: !0,
                                gridRow: !0,
                                gridRowEnd: !0,
                                gridRowStart: !0,
                                lineHeight: !0,
                                opacity: !0,
                                order: !0,
                                orphans: !0,
                                widows: !0,
                                zIndex: !0,
                                zoom: !0
                            },
                            cssProps: {},
                            style: function (e, t, n, r) {
                                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                                    var a, i, o, u = z(t),
                                        s = Qe.test(t),
                                        c = e.style;
                                    if (s || (t = ze(u)), o = b.cssHooks[t] || b.cssHooks[u], void 0 === n) return o && "get" in o && void 0 !== (a = o.get(e, !1, r)) ? a : c[t];
                                    "string" == (i = typeof n) && (a = te.exec(n)) && a[1] && (n = ue(e, t, a), i = "number"), null != n && n == n && ("number" !== i || s || (n += a && a[3] || (b.cssNumber[u] ? "" : "px")), p.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"), o && "set" in o && void 0 === (n = o.set(e, n, r)) || (s ? c.setProperty(t, n) : c[t] = n))
                                }
                            },
                            css: function (e, t, n, r) {
                                var a, i, o, u = z(t);
                                return Qe.test(t) || (t = ze(u)), (o = b.cssHooks[t] || b.cssHooks[u]) && "get" in o && (a = o.get(e, !0, n)), void 0 === a && (a = Ve(e, t, r)), "normal" === a && t in Xe && (a = Xe[t]), "" === n || n ? (i = parseFloat(a), !0 === n || isFinite(i) ? i || 0 : a) : a
                            }
                        }), b.each(["height", "width"], (function (e, t) {
                            b.cssHooks[t] = {
                                get: function (e, n, r) {
                                    if (n) return !Ge.test(b.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? Ze(e, t, r) : qe(e, Ye, (function () {
                                        return Ze(e, t, r)
                                    }))
                                },
                                set: function (e, n, r) {
                                    var a, i = Fe(e),
                                        o = !p.scrollboxSize() && "absolute" === i.position,
                                        u = (o || r) && "border-box" === b.css(e, "boxSizing", !1, i),
                                        s = r ? Je(e, t, r, u, i) : 0;
                                    return u && o && (s -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(i[t]) - Je(e, t, "border", !1, i) - .5)), s && (a = te.exec(n)) && "px" !== (a[3] || "px") && (e.style[t] = n, n = b.css(e, t)), Ke(0, n, s)
                                }
                            }
                        })), b.cssHooks.marginLeft = He(p.reliableMarginLeft, (function (e, t) {
                            if (t) return (parseFloat(Ve(e, "marginLeft")) || e.getBoundingClientRect().left - qe(e, {
                                marginLeft: 0
                            }, (function () {
                                return e.getBoundingClientRect().left
                            }))) + "px"
                        })), b.each({
                            margin: "",
                            padding: "",
                            border: "Width"
                        }, (function (e, t) {
                            b.cssHooks[e + t] = {
                                expand: function (n) {
                                    for (var r = 0, a = {}, i = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) a[e + ne[r] + t] = i[r] || i[r - 2] || i[0];
                                    return a
                                }
                            }, "margin" !== e && (b.cssHooks[e + t].set = Ke)
                        })), b.fn.extend({
                            css: function (e, t) {
                                return H(this, (function (e, t, n) {
                                    var r, a, i = {},
                                        o = 0;
                                    if (Array.isArray(t)) {
                                        for (r = Fe(e), a = t.length; o < a; o++) i[t[o]] = b.css(e, t[o], !1, r);
                                        return i
                                    }
                                    return void 0 !== n ? b.style(e, t, n) : b.css(e, t)
                                }), e, t, 1 < arguments.length)
                            }
                        }), ((b.Tween = et).prototype = {
                            constructor: et,
                            init: function (e, t, n, r, a, i) {
                                this.elem = e, this.prop = n, this.easing = a || b.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = i || (b.cssNumber[n] ? "" : "px")
                            },
                            cur: function () {
                                var e = et.propHooks[this.prop];
                                return e && e.get ? e.get(this) : et.propHooks._default.get(this)
                            },
                            run: function (e) {
                                var t, n = et.propHooks[this.prop];
                                return this.options.duration ? this.pos = t = b.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : et.propHooks._default.set(this), this
                            }
                        }).init.prototype = et.prototype, (et.propHooks = {
                            _default: {
                                get: function (e) {
                                    var t;
                                    return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = b.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
                                },
                                set: function (e) {
                                    b.fx.step[e.prop] ? b.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !b.cssHooks[e.prop] && null == e.elem.style[ze(e.prop)] ? e.elem[e.prop] = e.now : b.style(e.elem, e.prop, e.now + e.unit)
                                }
                            }
                        }).scrollTop = et.propHooks.scrollLeft = {
                            set: function (e) {
                                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
                            }
                        }, b.easing = {
                            linear: function (e) {
                                return e
                            },
                            swing: function (e) {
                                return .5 - Math.cos(e * Math.PI) / 2
                            },
                            _default: "swing"
                        }, b.fx = et.prototype.init, b.fx.step = {};
                        var tt, nt, rt, at, it = /^(?:toggle|show|hide)$/,
                            ot = /queueHooks$/;

                        function ut() {
                            nt && (!1 === y.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(ut) : e.setTimeout(ut, b.fx.interval), b.fx.tick())
                        }

                        function st() {
                            return e.setTimeout((function () {
                                tt = void 0
                            })), tt = Date.now()
                        }

                        function ct(e, t) {
                            var n, r = 0,
                                a = {
                                    height: e
                                };
                            for (t = t ? 1 : 0; r < 4; r += 2 - t) a["margin" + (n = ne[r])] = a["padding" + n] = e;
                            return t && (a.opacity = a.width = e), a
                        }

                        function lt(e, t, n) {
                            for (var r, a = (dt.tweeners[t] || []).concat(dt.tweeners["*"]), i = 0, o = a.length; i < o; i++)
                                if (r = a[i].call(n, t, e)) return r
                        }

                        function dt(e, t, n) {
                            var r, a, i = 0,
                                o = dt.prefilters.length,
                                u = b.Deferred().always((function () {
                                    delete s.elem
                                })),
                                s = function () {
                                    if (a) return !1;
                                    for (var t = tt || st(), n = Math.max(0, c.startTime + c.duration - t), r = 1 - (n / c.duration || 0), i = 0, o = c.tweens.length; i < o; i++) c.tweens[i].run(r);
                                    return u.notifyWith(e, [c, r, n]), r < 1 && o ? n : (o || u.notifyWith(e, [c, 1, 0]), u.resolveWith(e, [c]), !1)
                                },
                                c = u.promise({
                                    elem: e,
                                    props: b.extend({}, t),
                                    opts: b.extend(!0, {
                                        specialEasing: {},
                                        easing: b.easing._default
                                    }, n),
                                    originalProperties: t,
                                    originalOptions: n,
                                    startTime: tt || st(),
                                    duration: n.duration,
                                    tweens: [],
                                    createTween: function (t, n) {
                                        var r = b.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                                        return c.tweens.push(r), r
                                    },
                                    stop: function (t) {
                                        var n = 0,
                                            r = t ? c.tweens.length : 0;
                                        if (a) return this;
                                        for (a = !0; n < r; n++) c.tweens[n].run(1);
                                        return t ? (u.notifyWith(e, [c, 1, 0]), u.resolveWith(e, [c, t])) : u.rejectWith(e, [c, t]), this
                                    }
                                }),
                                l = c.props;
                            for (function (e, t) {
                                var n, r, a, i, o;
                                for (n in e)
                                    if (a = t[r = z(n)], i = e[n], Array.isArray(i) && (a = i[1], i = e[n] = i[0]), n !== r && (e[r] = i, delete e[n]), (o = b.cssHooks[r]) && "expand" in o)
                                        for (n in i = o.expand(i), delete e[r], i) n in e || (e[n] = i[n], t[n] = a);
                                    else t[r] = a
                            }(l, c.opts.specialEasing); i < o; i++)
                                if (r = dt.prefilters[i].call(c, e, l, c.opts)) return h(r.stop) && (b._queueHooks(c.elem, c.opts.queue).stop = r.stop.bind(r)), r;
                            return b.map(l, lt, c), h(c.opts.start) && c.opts.start.call(e, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), b.fx.timer(b.extend(s, {
                                elem: e,
                                anim: c,
                                queue: c.opts.queue
                            })), c
                        }
                        b.Animation = b.extend(dt, {
                            tweeners: {
                                "*": [function (e, t) {
                                    var n = this.createTween(e, t);
                                    return ue(n.elem, e, te.exec(t), n), n
                                }]
                            },
                            tweener: function (e, t) {
                                h(e) ? (t = e, e = ["*"]) : e = e.match(L);
                                for (var n, r = 0, a = e.length; r < a; r++) n = e[r], dt.tweeners[n] = dt.tweeners[n] || [], dt.tweeners[n].unshift(t)
                            },
                            prefilters: [function (e, t, n) {
                                var r, a, i, o, u, s, c, l, d = "width" in t || "height" in t,
                                    f = this,
                                    p = {},
                                    h = e.style,
                                    v = e.nodeType && oe(e),
                                    y = Y.get(e, "fxshow");
                                for (r in n.queue || (null == (o = b._queueHooks(e, "fx")).unqueued && (o.unqueued = 0, u = o.empty.fire, o.empty.fire = function () {
                                    o.unqueued || u()
                                }), o.unqueued++, f.always((function () {
                                    f.always((function () {
                                        o.unqueued--, b.queue(e, "fx").length || o.empty.fire()
                                    }))
                                }))), t)
                                    if (a = t[r], it.test(a)) {
                                        if (delete t[r], i = i || "toggle" === a, a === (v ? "hide" : "show")) {
                                            if ("show" !== a || !y || void 0 === y[r]) continue;
                                            v = !0
                                        }
                                        p[r] = y && y[r] || b.style(e, r)
                                    } if ((s = !b.isEmptyObject(t)) || !b.isEmptyObject(p))
                                    for (r in d && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (c = y && y.display) && (c = Y.get(e, "display")), "none" === (l = b.css(e, "display")) && (c ? l = c : (ce([e], !0), c = e.style.display || c, l = b.css(e, "display"), ce([e]))), ("inline" === l || "inline-block" === l && null != c) && "none" === b.css(e, "float") && (s || (f.done((function () {
                                        h.display = c
                                    })), null == c && (l = h.display, c = "none" === l ? "" : l)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", f.always((function () {
                                        h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2]
                                    }))), s = !1, p) s || (y ? "hidden" in y && (v = y.hidden) : y = Y.access(e, "fxshow", {
                                        display: c
                                    }), i && (y.hidden = !v), v && ce([e], !0), f.done((function () {
                                        for (r in v || ce([e]), Y.remove(e, "fxshow"), p) b.style(e, r, p[r])
                                    }))), s = lt(v ? y[r] : 0, r, f), r in y || (y[r] = s.start, v && (s.end = s.start, s.start = 0))
                            }],
                            prefilter: function (e, t) {
                                t ? dt.prefilters.unshift(e) : dt.prefilters.push(e)
                            }
                        }), b.speed = function (e, t, n) {
                            var r = e && "object" == typeof e ? b.extend({}, e) : {
                                complete: n || !n && t || h(e) && e,
                                duration: e,
                                easing: n && t || t && !h(t) && t
                            };
                            return b.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in b.fx.speeds ? r.duration = b.fx.speeds[r.duration] : r.duration = b.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
                                h(r.old) && r.old.call(this), r.queue && b.dequeue(this, r.queue)
                            }, r
                        }, b.fn.extend({
                            fadeTo: function (e, t, n, r) {
                                return this.filter(oe).css("opacity", 0).show().end().animate({
                                    opacity: t
                                }, e, n, r)
                            },
                            animate: function (e, t, n, r) {
                                var a = b.isEmptyObject(e),
                                    i = b.speed(t, n, r),
                                    o = function () {
                                        var t = dt(this, b.extend({}, e), i);
                                        (a || Y.get(this, "finish")) && t.stop(!0)
                                    };
                                return o.finish = o, a || !1 === i.queue ? this.each(o) : this.queue(i.queue, o)
                            },
                            stop: function (e, t, n) {
                                var r = function (e) {
                                    var t = e.stop;
                                    delete e.stop, t(n)
                                };
                                return "string" != typeof e && (n = t, t = e, e = void 0), t && this.queue(e || "fx", []), this.each((function () {
                                    var t = !0,
                                        a = null != e && e + "queueHooks",
                                        i = b.timers,
                                        o = Y.get(this);
                                    if (a) o[a] && o[a].stop && r(o[a]);
                                    else
                                        for (a in o) o[a] && o[a].stop && ot.test(a) && r(o[a]);
                                    for (a = i.length; a--;) i[a].elem !== this || null != e && i[a].queue !== e || (i[a].anim.stop(n), t = !1, i.splice(a, 1));
                                    !t && n || b.dequeue(this, e)
                                }))
                            },
                            finish: function (e) {
                                return !1 !== e && (e = e || "fx"), this.each((function () {
                                    var t, n = Y.get(this),
                                        r = n[e + "queue"],
                                        a = n[e + "queueHooks"],
                                        i = b.timers,
                                        o = r ? r.length : 0;
                                    for (n.finish = !0, b.queue(this, e, []), a && a.stop && a.stop.call(this, !0), t = i.length; t--;) i[t].elem === this && i[t].queue === e && (i[t].anim.stop(!0), i.splice(t, 1));
                                    for (t = 0; t < o; t++) r[t] && r[t].finish && r[t].finish.call(this);
                                    delete n.finish
                                }))
                            }
                        }), b.each(["toggle", "show", "hide"], (function (e, t) {
                            var n = b.fn[t];
                            b.fn[t] = function (e, r, a) {
                                return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ct(t, !0), e, r, a)
                            }
                        })), b.each({
                            slideDown: ct("show"),
                            slideUp: ct("hide"),
                            slideToggle: ct("toggle"),
                            fadeIn: {
                                opacity: "show"
                            },
                            fadeOut: {
                                opacity: "hide"
                            },
                            fadeToggle: {
                                opacity: "toggle"
                            }
                        }, (function (e, t) {
                            b.fn[e] = function (e, n, r) {
                                return this.animate(t, e, n, r)
                            }
                        })), b.timers = [], b.fx.tick = function () {
                            var e, t = 0,
                                n = b.timers;
                            for (tt = Date.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1);
                            n.length || b.fx.stop(), tt = void 0
                        }, b.fx.timer = function (e) {
                            b.timers.push(e), b.fx.start()
                        }, b.fx.interval = 13, b.fx.start = function () {
                            nt || (nt = !0, ut())
                        }, b.fx.stop = function () {
                            nt = null
                        }, b.fx.speeds = {
                            slow: 600,
                            fast: 200,
                            _default: 400
                        }, b.fn.delay = function (t, n) {
                            return t = b.fx && b.fx.speeds[t] || t, n = n || "fx", this.queue(n, (function (n, r) {
                                var a = e.setTimeout(n, t);
                                r.stop = function () {
                                    e.clearTimeout(a)
                                }
                            }))
                        }, rt = y.createElement("input"), at = y.createElement("select").appendChild(y.createElement("option")), rt.type = "checkbox", p.checkOn = "" !== rt.value, p.optSelected = at.selected, (rt = y.createElement("input")).value = "t", rt.type = "radio", p.radioValue = "t" === rt.value;
                        var ft, pt = b.expr.attrHandle;
                        b.fn.extend({
                            attr: function (e, t) {
                                return H(this, b.attr, e, t, 1 < arguments.length)
                            },
                            removeAttr: function (e) {
                                return this.each((function () {
                                    b.removeAttr(this, e)
                                }))
                            }
                        }), b.extend({
                            attr: function (e, t, n) {
                                var r, a, i = e.nodeType;
                                if (3 !== i && 8 !== i && 2 !== i) return void 0 === e.getAttribute ? b.prop(e, t, n) : (1 === i && b.isXMLDoc(e) || (a = b.attrHooks[t.toLowerCase()] || (b.expr.match.bool.test(t) ? ft : void 0)), void 0 !== n ? null === n ? void b.removeAttr(e, t) : a && "set" in a && void 0 !== (r = a.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : a && "get" in a && null !== (r = a.get(e, t)) ? r : null == (r = b.find.attr(e, t)) ? void 0 : r)
                            },
                            attrHooks: {
                                type: {
                                    set: function (e, t) {
                                        if (!p.radioValue && "radio" === t && A(e, "input")) {
                                            var n = e.value;
                                            return e.setAttribute("type", t), n && (e.value = n), t
                                        }
                                    }
                                }
                            },
                            removeAttr: function (e, t) {
                                var n, r = 0,
                                    a = t && t.match(L);
                                if (a && 1 === e.nodeType)
                                    for (; n = a[r++];) e.removeAttribute(n)
                            }
                        }), ft = {
                            set: function (e, t, n) {
                                return !1 === t ? b.removeAttr(e, n) : e.setAttribute(n, n), n
                            }
                        }, b.each(b.expr.match.bool.source.match(/\w+/g), (function (e, t) {
                            var n = pt[t] || b.find.attr;
                            pt[t] = function (e, t, r) {
                                var a, i, o = t.toLowerCase();
                                return r || (i = pt[o], pt[o] = a, a = null != n(e, t, r) ? o : null, pt[o] = i), a
                            }
                        }));
                        var ht = /^(?:input|select|textarea|button)$/i,
                            vt = /^(?:a|area)$/i;

                        function yt(e) {
                            return (e.match(L) || []).join(" ")
                        }

                        function mt(e) {
                            return e.getAttribute && e.getAttribute("class") || ""
                        }

                        function gt(e) {
                            return Array.isArray(e) ? e : "string" == typeof e && e.match(L) || []
                        }
                        b.fn.extend({
                            prop: function (e, t) {
                                return H(this, b.prop, e, t, 1 < arguments.length)
                            },
                            removeProp: function (e) {
                                return this.each((function () {
                                    delete this[b.propFix[e] || e]
                                }))
                            }
                        }), b.extend({
                            prop: function (e, t, n) {
                                var r, a, i = e.nodeType;
                                if (3 !== i && 8 !== i && 2 !== i) return 1 === i && b.isXMLDoc(e) || (t = b.propFix[t] || t, a = b.propHooks[t]), void 0 !== n ? a && "set" in a && void 0 !== (r = a.set(e, n, t)) ? r : e[t] = n : a && "get" in a && null !== (r = a.get(e, t)) ? r : e[t]
                            },
                            propHooks: {
                                tabIndex: {
                                    get: function (e) {
                                        var t = b.find.attr(e, "tabindex");
                                        return t ? parseInt(t, 10) : ht.test(e.nodeName) || vt.test(e.nodeName) && e.href ? 0 : -1
                                    }
                                }
                            },
                            propFix: {
                                for: "htmlFor",
                                class: "className"
                            }
                        }), p.optSelected || (b.propHooks.selected = {
                            get: function (e) {
                                var t = e.parentNode;
                                return t && t.parentNode && t.parentNode.selectedIndex, null
                            },
                            set: function (e) {
                                var t = e.parentNode;
                                t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
                            }
                        }), b.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], (function () {
                            b.propFix[this.toLowerCase()] = this
                        })), b.fn.extend({
                            addClass: function (e) {
                                var t, n, r, a, i, o, u, s = 0;
                                if (h(e)) return this.each((function (t) {
                                    b(this).addClass(e.call(this, t, mt(this)))
                                }));
                                if ((t = gt(e)).length)
                                    for (; n = this[s++];)
                                        if (a = mt(n), r = 1 === n.nodeType && " " + yt(a) + " ") {
                                            for (o = 0; i = t[o++];) r.indexOf(" " + i + " ") < 0 && (r += i + " ");
                                            a !== (u = yt(r)) && n.setAttribute("class", u)
                                        } return this
                            },
                            removeClass: function (e) {
                                var t, n, r, a, i, o, u, s = 0;
                                if (h(e)) return this.each((function (t) {
                                    b(this).removeClass(e.call(this, t, mt(this)))
                                }));
                                if (!arguments.length) return this.attr("class", "");
                                if ((t = gt(e)).length)
                                    for (; n = this[s++];)
                                        if (a = mt(n), r = 1 === n.nodeType && " " + yt(a) + " ") {
                                            for (o = 0; i = t[o++];)
                                                for (; - 1 < r.indexOf(" " + i + " ");) r = r.replace(" " + i + " ", " ");
                                            a !== (u = yt(r)) && n.setAttribute("class", u)
                                        } return this
                            },
                            toggleClass: function (e, t) {
                                var n = typeof e,
                                    r = "string" === n || Array.isArray(e);
                                return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : h(e) ? this.each((function (n) {
                                    b(this).toggleClass(e.call(this, n, mt(this), t), t)
                                })) : this.each((function () {
                                    var t, a, i, o;
                                    if (r)
                                        for (a = 0, i = b(this), o = gt(e); t = o[a++];) i.hasClass(t) ? i.removeClass(t) : i.addClass(t);
                                    else void 0 !== e && "boolean" !== n || ((t = mt(this)) && Y.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Y.get(this, "__className__") || ""))
                                }))
                            },
                            hasClass: function (e) {
                                var t, n, r = 0;
                                for (t = " " + e + " "; n = this[r++];)
                                    if (1 === n.nodeType && -1 < (" " + yt(mt(n)) + " ").indexOf(t)) return !0;
                                return !1
                            }
                        });
                        var _t = /\r/g;
                        b.fn.extend({
                            val: function (e) {
                                var t, n, r, a = this[0];
                                return arguments.length ? (r = h(e), this.each((function (n) {
                                    var a;
                                    1 === this.nodeType && (null == (a = r ? e.call(this, n, b(this).val()) : e) ? a = "" : "number" == typeof a ? a += "" : Array.isArray(a) && (a = b.map(a, (function (e) {
                                        return null == e ? "" : e + ""
                                    }))), (t = b.valHooks[this.type] || b.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, a, "value") || (this.value = a))
                                }))) : a ? (t = b.valHooks[a.type] || b.valHooks[a.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(a, "value")) ? n : "string" == typeof (n = a.value) ? n.replace(_t, "") : null == n ? "" : n : void 0
                            }
                        }), b.extend({
                            valHooks: {
                                option: {
                                    get: function (e) {
                                        var t = b.find.attr(e, "value");
                                        return null != t ? t : yt(b.text(e))
                                    }
                                },
                                select: {
                                    get: function (e) {
                                        var t, n, r, a = e.options,
                                            i = e.selectedIndex,
                                            o = "select-one" === e.type,
                                            u = o ? null : [],
                                            s = o ? i + 1 : a.length;
                                        for (r = i < 0 ? s : o ? i : 0; r < s; r++)
                                            if (((n = a[r]).selected || r === i) && !n.disabled && (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))) {
                                                if (t = b(n).val(), o) return t;
                                                u.push(t)
                                            } return u
                                    },
                                    set: function (e, t) {
                                        for (var n, r, a = e.options, i = b.makeArray(t), o = a.length; o--;)((r = a[o]).selected = -1 < b.inArray(b.valHooks.option.get(r), i)) && (n = !0);
                                        return n || (e.selectedIndex = -1), i
                                    }
                                }
                            }
                        }), b.each(["radio", "checkbox"], (function () {
                            b.valHooks[this] = {
                                set: function (e, t) {
                                    if (Array.isArray(t)) return e.checked = -1 < b.inArray(b(e).val(), t)
                                }
                            }, p.checkOn || (b.valHooks[this].get = function (e) {
                                return null === e.getAttribute("value") ? "on" : e.value
                            })
                        })), p.focusin = "onfocusin" in e;
                        var Ct = /^(?:focusinfocus|focusoutblur)$/,
                            bt = function (e) {
                                e.stopPropagation()
                            };
                        b.extend(b.event, {
                            trigger: function (t, n, r, a) {
                                var i, o, u, s, c, d, f, p, m = [r || y],
                                    g = l.call(t, "type") ? t.type : t,
                                    _ = l.call(t, "namespace") ? t.namespace.split(".") : [];
                                if (o = p = u = r = r || y, 3 !== r.nodeType && 8 !== r.nodeType && !Ct.test(g + b.event.triggered) && (-1 < g.indexOf(".") && (g = (_ = g.split(".")).shift(), _.sort()), c = g.indexOf(":") < 0 && "on" + g, (t = t[b.expando] ? t : new b.Event(g, "object" == typeof t && t)).isTrigger = a ? 2 : 3, t.namespace = _.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + _.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = r), n = null == n ? [t] : b.makeArray(n, [t]), f = b.event.special[g] || {}, a || !f.trigger || !1 !== f.trigger.apply(r, n))) {
                                    if (!a && !f.noBubble && !v(r)) {
                                        for (s = f.delegateType || g, Ct.test(s + g) || (o = o.parentNode); o; o = o.parentNode) m.push(o), u = o;
                                        u === (r.ownerDocument || y) && m.push(u.defaultView || u.parentWindow || e)
                                    }
                                    for (i = 0;
                                         (o = m[i++]) && !t.isPropagationStopped();) p = o, t.type = 1 < i ? s : f.bindType || g, (d = (Y.get(o, "events") || Object.create(null))[t.type] && Y.get(o, "handle")) && d.apply(o, n), (d = c && o[c]) && d.apply && G(o) && (t.result = d.apply(o, n), !1 === t.result && t.preventDefault());
                                    return t.type = g, a || t.isDefaultPrevented() || f._default && !1 !== f._default.apply(m.pop(), n) || !G(r) || c && h(r[g]) && !v(r) && ((u = r[c]) && (r[c] = null), b.event.triggered = g, t.isPropagationStopped() && p.addEventListener(g, bt), r[g](), t.isPropagationStopped() && p.removeEventListener(g, bt), b.event.triggered = void 0, u && (r[c] = u)), t.result
                                }
                            },
                            simulate: function (e, t, n) {
                                var r = b.extend(new b.Event, n, {
                                    type: e,
                                    isSimulated: !0
                                });
                                b.event.trigger(r, null, t)
                            }
                        }), b.fn.extend({
                            trigger: function (e, t) {
                                return this.each((function () {
                                    b.event.trigger(e, t, this)
                                }))
                            },
                            triggerHandler: function (e, t) {
                                var n = this[0];
                                if (n) return b.event.trigger(e, t, n, !0)
                            }
                        }), p.focusin || b.each({
                            focus: "focusin",
                            blur: "focusout"
                        }, (function (e, t) {
                            var n = function (e) {
                                b.event.simulate(t, e.target, b.event.fix(e))
                            };
                            b.event.special[t] = {
                                setup: function () {
                                    var r = this.ownerDocument || this.document || this,
                                        a = Y.access(r, t);
                                    a || r.addEventListener(e, n, !0), Y.access(r, t, (a || 0) + 1)
                                },
                                teardown: function () {
                                    var r = this.ownerDocument || this.document || this,
                                        a = Y.access(r, t) - 1;
                                    a ? Y.access(r, t, a) : (r.removeEventListener(e, n, !0), Y.remove(r, t))
                                }
                            }
                        }));
                        var wt = e.location,
                            kt = {
                                guid: Date.now()
                            },
                            St = /\?/;
                        b.parseXML = function (t) {
                            var n;
                            if (!t || "string" != typeof t) return null;
                            try {
                                n = (new e.DOMParser).parseFromString(t, "text/xml")
                            } catch (t) {
                                n = void 0
                            }
                            return n && !n.getElementsByTagName("parsererror").length || b.error("Invalid XML: " + t), n
                        };
                        var xt = /\[\]$/,
                            Tt = /\r?\n/g,
                            At = /^(?:submit|button|image|reset|file)$/i,
                            Et = /^(?:input|select|textarea|keygen)/i;

                        function Pt(e, t, n, r) {
                            var a;
                            if (Array.isArray(t)) b.each(t, (function (t, a) {
                                n || xt.test(e) ? r(e, a) : Pt(e + "[" + ("object" == typeof a && null != a ? t : "") + "]", a, n, r)
                            }));
                            else if (n || "object" !== _(t)) r(e, t);
                            else
                                for (a in t) Pt(e + "[" + a + "]", t[a], n, r)
                        }
                        b.param = function (e, t) {
                            var n, r = [],
                                a = function (e, t) {
                                    var n = h(t) ? t() : t;
                                    r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
                                };
                            if (null == e) return "";
                            if (Array.isArray(e) || e.jquery && !b.isPlainObject(e)) b.each(e, (function () {
                                a(this.name, this.value)
                            }));
                            else
                                for (n in e) Pt(n, e[n], t, a);
                            return r.join("&")
                        }, b.fn.extend({
                            serialize: function () {
                                return b.param(this.serializeArray())
                            },
                            serializeArray: function () {
                                return this.map((function () {
                                    var e = b.prop(this, "elements");
                                    return e ? b.makeArray(e) : this
                                })).filter((function () {
                                    var e = this.type;
                                    return this.name && !b(this).is(":disabled") && Et.test(this.nodeName) && !At.test(e) && (this.checked || !fe.test(e))
                                })).map((function (e, t) {
                                    var n = b(this).val();
                                    return null == n ? null : Array.isArray(n) ? b.map(n, (function (e) {
                                        return {
                                            name: t.name,
                                            value: e.replace(Tt, "\r\n")
                                        }
                                    })) : {
                                        name: t.name,
                                        value: n.replace(Tt, "\r\n")
                                    }
                                })).get()
                            }
                        });
                        var It = /%20/g,
                            Ot = /#.*$/,
                            Dt = /([?&])_=[^&]*/,
                            Bt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                            jt = /^(?:GET|HEAD)$/,
                            Lt = /^\/\//,
                            Nt = {},
                            Rt = {},
                            Ft = "*/".concat("*"),
                            qt = y.createElement("a");

                        function Ut(e) {
                            return function (t, n) {
                                "string" != typeof t && (n = t, t = "*");
                                var r, a = 0,
                                    i = t.toLowerCase().match(L) || [];
                                if (h(n))
                                    for (; r = i[a++];) "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n)
                            }
                        }

                        function Vt(e, t, n, r) {
                            var a = {},
                                i = e === Rt;

                            function o(u) {
                                var s;
                                return a[u] = !0, b.each(e[u] || [], (function (e, u) {
                                    var c = u(t, n, r);
                                    return "string" != typeof c || i || a[c] ? i ? !(s = c) : void 0 : (t.dataTypes.unshift(c), o(c), !1)
                                })), s
                            }
                            return o(t.dataTypes[0]) || !a["*"] && o("*")
                        }

                        function Ht(e, t) {
                            var n, r, a = b.ajaxSettings.flatOptions || {};
                            for (n in t) void 0 !== t[n] && ((a[n] ? e : r || (r = {}))[n] = t[n]);
                            return r && b.extend(!0, e, r), e
                        }
                        qt.href = wt.href, b.extend({
                            active: 0,
                            lastModified: {},
                            etag: {},
                            ajaxSettings: {
                                url: wt.href,
                                type: "GET",
                                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(wt.protocol),
                                global: !0,
                                processData: !0,
                                async: !0,
                                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                                accepts: {
                                    "*": Ft,
                                    text: "text/plain",
                                    html: "text/html",
                                    xml: "application/xml, text/xml",
                                    json: "application/json, text/javascript"
                                },
                                contents: {
                                    xml: /\bxml\b/,
                                    html: /\bhtml/,
                                    json: /\bjson\b/
                                },
                                responseFields: {
                                    xml: "responseXML",
                                    text: "responseText",
                                    json: "responseJSON"
                                },
                                converters: {
                                    "* text": String,
                                    "text html": !0,
                                    "text json": JSON.parse,
                                    "text xml": b.parseXML
                                },
                                flatOptions: {
                                    url: !0,
                                    context: !0
                                }
                            },
                            ajaxSetup: function (e, t) {
                                return t ? Ht(Ht(e, b.ajaxSettings), t) : Ht(b.ajaxSettings, e)
                            },
                            ajaxPrefilter: Ut(Nt),
                            ajaxTransport: Ut(Rt),
                            ajax: function (t, n) {
                                "object" == typeof t && (n = t, t = void 0), n = n || {};
                                var r, a, i, o, u, s, c, l, d, f, p = b.ajaxSetup({}, n),
                                    h = p.context || p,
                                    v = p.context && (h.nodeType || h.jquery) ? b(h) : b.event,
                                    m = b.Deferred(),
                                    g = b.Callbacks("once memory"),
                                    _ = p.statusCode || {},
                                    C = {},
                                    w = {},
                                    k = "canceled",
                                    S = {
                                        readyState: 0,
                                        getResponseHeader: function (e) {
                                            var t;
                                            if (c) {
                                                if (!o)
                                                    for (o = {}; t = Bt.exec(i);) o[t[1].toLowerCase() + " "] = (o[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                                t = o[e.toLowerCase() + " "]
                                            }
                                            return null == t ? null : t.join(", ")
                                        },
                                        getAllResponseHeaders: function () {
                                            return c ? i : null
                                        },
                                        setRequestHeader: function (e, t) {
                                            return null == c && (e = w[e.toLowerCase()] = w[e.toLowerCase()] || e, C[e] = t), this
                                        },
                                        overrideMimeType: function (e) {
                                            return null == c && (p.mimeType = e), this
                                        },
                                        statusCode: function (e) {
                                            var t;
                                            if (e)
                                                if (c) S.always(e[S.status]);
                                                else
                                                    for (t in e) _[t] = [_[t], e[t]];
                                            return this
                                        },
                                        abort: function (e) {
                                            var t = e || k;
                                            return r && r.abort(t), x(0, t), this
                                        }
                                    };
                                if (m.promise(S), p.url = ((t || p.url || wt.href) + "").replace(Lt, wt.protocol + "//"), p.type = n.method || n.type || p.method || p.type, p.dataTypes = (p.dataType || "*").toLowerCase().match(L) || [""], null == p.crossDomain) {
                                    s = y.createElement("a");
                                    try {
                                        s.href = p.url, s.href = s.href, p.crossDomain = qt.protocol + "//" + qt.host != s.protocol + "//" + s.host
                                    } catch (t) {
                                        p.crossDomain = !0
                                    }
                                }
                                if (p.data && p.processData && "string" != typeof p.data && (p.data = b.param(p.data, p.traditional)), Vt(Nt, p, n, S), c) return S;
                                for (d in (l = b.event && p.global) && 0 == b.active++ && b.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !jt.test(p.type), a = p.url.replace(Ot, ""), p.hasContent ? p.data && p.processData && 0 === (p.contentType || "").indexOf("application/x-www-form-urlencoded") && (p.data = p.data.replace(It, "+")) : (f = p.url.slice(a.length), p.data && (p.processData || "string" == typeof p.data) && (a += (St.test(a) ? "&" : "?") + p.data, delete p.data), !1 === p.cache && (a = a.replace(Dt, "$1"), f = (St.test(a) ? "&" : "?") + "_=" + kt.guid++ + f), p.url = a + f), p.ifModified && (b.lastModified[a] && S.setRequestHeader("If-Modified-Since", b.lastModified[a]), b.etag[a] && S.setRequestHeader("If-None-Match", b.etag[a])), (p.data && p.hasContent && !1 !== p.contentType || n.contentType) && S.setRequestHeader("Content-Type", p.contentType), S.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Ft + "; q=0.01" : "") : p.accepts["*"]), p.headers) S.setRequestHeader(d, p.headers[d]);
                                if (p.beforeSend && (!1 === p.beforeSend.call(h, S, p) || c)) return S.abort();
                                if (k = "abort", g.add(p.complete), S.done(p.success), S.fail(p.error), r = Vt(Rt, p, n, S)) {
                                    if (S.readyState = 1, l && v.trigger("ajaxSend", [S, p]), c) return S;
                                    p.async && 0 < p.timeout && (u = e.setTimeout((function () {
                                        S.abort("timeout")
                                    }), p.timeout));
                                    try {
                                        c = !1, r.send(C, x)
                                    } catch (t) {
                                        if (c) throw t;
                                        x(-1, t)
                                    }
                                } else x(-1, "No Transport");

                                function x(t, n, o, s) {
                                    var d, f, y, C, w, k = n;
                                    c || (c = !0, u && e.clearTimeout(u), r = void 0, i = s || "", S.readyState = 0 < t ? 4 : 0, d = 200 <= t && t < 300 || 304 === t, o && (C = function (e, t, n) {
                                        for (var r, a, i, o, u = e.contents, s = e.dataTypes;
                                             "*" === s[0];) s.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                                        if (r)
                                            for (a in u)
                                                if (u[a] && u[a].test(r)) {
                                                    s.unshift(a);
                                                    break
                                                } if (s[0] in n) i = s[0];
                                        else {
                                            for (a in n) {
                                                if (!s[0] || e.converters[a + " " + s[0]]) {
                                                    i = a;
                                                    break
                                                }
                                                o || (o = a)
                                            }
                                            i = i || o
                                        }
                                        if (i) return i !== s[0] && s.unshift(i), n[i]
                                    }(p, S, o)), !d && -1 < b.inArray("script", p.dataTypes) && (p.converters["text script"] = function () {}), C = function (e, t, n, r) {
                                        var a, i, o, u, s, c = {},
                                            l = e.dataTypes.slice();
                                        if (l[1])
                                            for (o in e.converters) c[o.toLowerCase()] = e.converters[o];
                                        for (i = l.shift(); i;)
                                            if (e.responseFields[i] && (n[e.responseFields[i]] = t), !s && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), s = i, i = l.shift())
                                                if ("*" === i) i = s;
                                                else if ("*" !== s && s !== i) {
                                                    if (!(o = c[s + " " + i] || c["* " + i]))
                                                        for (a in c)
                                                            if ((u = a.split(" "))[1] === i && (o = c[s + " " + u[0]] || c["* " + u[0]])) {
                                                                !0 === o ? o = c[a] : !0 !== c[a] && (i = u[0], l.unshift(u[1]));
                                                                break
                                                            } if (!0 !== o)
                                                        if (o && e.throws) t = o(t);
                                                        else try {
                                                            t = o(t)
                                                        } catch (e) {
                                                            return {
                                                                state: "parsererror",
                                                                error: o ? e : "No conversion from " + s + " to " + i
                                                            }
                                                        }
                                                }
                                        return {
                                            state: "success",
                                            data: t
                                        }
                                    }(p, C, S, d), d ? (p.ifModified && ((w = S.getResponseHeader("Last-Modified")) && (b.lastModified[a] = w), (w = S.getResponseHeader("etag")) && (b.etag[a] = w)), 204 === t || "HEAD" === p.type ? k = "nocontent" : 304 === t ? k = "notmodified" : (k = C.state, f = C.data, d = !(y = C.error))) : (y = k, !t && k || (k = "error", t < 0 && (t = 0))), S.status = t, S.statusText = (n || k) + "", d ? m.resolveWith(h, [f, k, S]) : m.rejectWith(h, [S, k, y]), S.statusCode(_), _ = void 0, l && v.trigger(d ? "ajaxSuccess" : "ajaxError", [S, p, d ? f : y]), g.fireWith(h, [S, k]), l && (v.trigger("ajaxComplete", [S, p]), --b.active || b.event.trigger("ajaxStop")))
                                }
                                return S
                            },
                            getJSON: function (e, t, n) {
                                return b.get(e, t, n, "json")
                            },
                            getScript: function (e, t) {
                                return b.get(e, void 0, t, "script")
                            }
                        }), b.each(["get", "post"], (function (e, t) {
                            b[t] = function (e, n, r, a) {
                                return h(n) && (a = a || r, r = n, n = void 0), b.ajax(b.extend({
                                    url: e,
                                    type: t,
                                    dataType: a,
                                    data: n,
                                    success: r
                                }, b.isPlainObject(e) && e))
                            }
                        })), b.ajaxPrefilter((function (e) {
                            var t;
                            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "")
                        })), b._evalUrl = function (e, t, n) {
                            return b.ajax({
                                url: e,
                                type: "GET",
                                dataType: "script",
                                cache: !0,
                                async: !1,
                                global: !1,
                                converters: {
                                    "text script": function () {}
                                },
                                dataFilter: function (e) {
                                    b.globalEval(e, t, n)
                                }
                            })
                        }, b.fn.extend({
                            wrapAll: function (e) {
                                var t;
                                return this[0] && (h(e) && (e = e.call(this[0])), t = b(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map((function () {
                                    for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                                    return e
                                })).append(this)), this
                            },
                            wrapInner: function (e) {
                                return h(e) ? this.each((function (t) {
                                    b(this).wrapInner(e.call(this, t))
                                })) : this.each((function () {
                                    var t = b(this),
                                        n = t.contents();
                                    n.length ? n.wrapAll(e) : t.append(e)
                                }))
                            },
                            wrap: function (e) {
                                var t = h(e);
                                return this.each((function (n) {
                                    b(this).wrapAll(t ? e.call(this, n) : e)
                                }))
                            },
                            unwrap: function (e) {
                                return this.parent(e).not("body").each((function () {
                                    b(this).replaceWith(this.childNodes)
                                })), this
                            }
                        }), b.expr.pseudos.hidden = function (e) {
                            return !b.expr.pseudos.visible(e)
                        }, b.expr.pseudos.visible = function (e) {
                            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
                        }, b.ajaxSettings.xhr = function () {
                            try {
                                return new e.XMLHttpRequest
                            } catch (e) {}
                        };
                        var Mt = {
                                0: 200,
                                1223: 204
                            },
                            $t = b.ajaxSettings.xhr();
                        p.cors = !!$t && "withCredentials" in $t, p.ajax = $t = !!$t, b.ajaxTransport((function (t) {
                            var n, r;
                            if (p.cors || $t && !t.crossDomain) return {
                                send: function (a, i) {
                                    var o, u = t.xhr();
                                    if (u.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)
                                        for (o in t.xhrFields) u[o] = t.xhrFields[o];
                                    for (o in t.mimeType && u.overrideMimeType && u.overrideMimeType(t.mimeType), t.crossDomain || a["X-Requested-With"] || (a["X-Requested-With"] = "XMLHttpRequest"), a) u.setRequestHeader(o, a[o]);
                                    n = function (e) {
                                        return function () {
                                            n && (n = r = u.onload = u.onerror = u.onabort = u.ontimeout = u.onreadystatechange = null, "abort" === e ? u.abort() : "error" === e ? "number" != typeof u.status ? i(0, "error") : i(u.status, u.statusText) : i(Mt[u.status] || u.status, u.statusText, "text" !== (u.responseType || "text") || "string" != typeof u.responseText ? {
                                                binary: u.response
                                            } : {
                                                text: u.responseText
                                            }, u.getAllResponseHeaders()))
                                        }
                                    }, u.onload = n(), r = u.onerror = u.ontimeout = n("error"), void 0 !== u.onabort ? u.onabort = r : u.onreadystatechange = function () {
                                        4 === u.readyState && e.setTimeout((function () {
                                            n && r()
                                        }))
                                    }, n = n("abort");
                                    try {
                                        u.send(t.hasContent && t.data || null)
                                    } catch (a) {
                                        if (n) throw a
                                    }
                                },
                                abort: function () {
                                    n && n()
                                }
                            }
                        })), b.ajaxPrefilter((function (e) {
                            e.crossDomain && (e.contents.script = !1)
                        })), b.ajaxSetup({
                            accepts: {
                                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
                            },
                            contents: {
                                script: /\b(?:java|ecma)script\b/
                            },
                            converters: {
                                "text script": function (e) {
                                    return b.globalEval(e), e
                                }
                            }
                        }), b.ajaxPrefilter("script", (function (e) {
                            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
                        })), b.ajaxTransport("script", (function (e) {
                            var t, n;
                            if (e.crossDomain || e.scriptAttrs) return {
                                send: function (r, a) {
                                    t = b("<script>").attr(e.scriptAttrs || {}).prop({
                                        charset: e.scriptCharset,
                                        src: e.url
                                    }).on("load error", n = function (e) {
                                        t.remove(), n = null, e && a("error" === e.type ? 404 : 200, e.type)
                                    }), y.head.appendChild(t[0])
                                },
                                abort: function () {
                                    n && n()
                                }
                            }
                        }));
                        var Wt, zt = [],
                            Gt = /(=)\?(?=&|$)|\?\?/;
                        b.ajaxSetup({
                            jsonp: "callback",
                            jsonpCallback: function () {
                                var e = zt.pop() || b.expando + "_" + kt.guid++;
                                return this[e] = !0, e
                            }
                        }), b.ajaxPrefilter("json jsonp", (function (t, n, r) {
                            var a, i, o, u = !1 !== t.jsonp && (Gt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Gt.test(t.data) && "data");
                            if (u || "jsonp" === t.dataTypes[0]) return a = t.jsonpCallback = h(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, u ? t[u] = t[u].replace(Gt, "$1" + a) : !1 !== t.jsonp && (t.url += (St.test(t.url) ? "&" : "?") + t.jsonp + "=" + a), t.converters["script json"] = function () {
                                return o || b.error(a + " was not called"), o[0]
                            }, t.dataTypes[0] = "json", i = e[a], e[a] = function () {
                                o = arguments
                            }, r.always((function () {
                                void 0 === i ? b(e).removeProp(a) : e[a] = i, t[a] && (t.jsonpCallback = n.jsonpCallback, zt.push(a)), o && h(i) && i(o[0]), o = i = void 0
                            })), "script"
                        })), p.createHTMLDocument = ((Wt = y.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Wt.childNodes.length), b.parseHTML = function (e, t, n) {
                            return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (p.createHTMLDocument ? ((r = (t = y.implementation.createHTMLDocument("")).createElement("base")).href = y.location.href, t.head.appendChild(r)) : t = y), i = !n && [], (a = E.exec(e)) ? [t.createElement(a[1])] : (a = _e([e], t, i), i && i.length && b(i).remove(), b.merge([], a.childNodes)));
                            var r, a, i
                        }, b.fn.load = function (e, t, n) {
                            var r, a, i, o = this,
                                u = e.indexOf(" ");
                            return -1 < u && (r = yt(e.slice(u)), e = e.slice(0, u)), h(t) ? (n = t, t = void 0) : t && "object" == typeof t && (a = "POST"), 0 < o.length && b.ajax({
                                url: e,
                                type: a || "GET",
                                dataType: "html",
                                data: t
                            }).done((function (e) {
                                i = arguments, o.html(r ? b("<div>").append(b.parseHTML(e)).find(r) : e)
                            })).always(n && function (e, t) {
                                o.each((function () {
                                    n.apply(this, i || [e.responseText, t, e])
                                }))
                            }), this
                        }, b.expr.pseudos.animated = function (e) {
                            return b.grep(b.timers, (function (t) {
                                return e === t.elem
                            })).length
                        }, b.offset = {
                            setOffset: function (e, t, n) {
                                var r, a, i, o, u, s, c = b.css(e, "position"),
                                    l = b(e),
                                    d = {};
                                "static" === c && (e.style.position = "relative"), u = l.offset(), i = b.css(e, "top"), s = b.css(e, "left"), ("absolute" === c || "fixed" === c) && -1 < (i + s).indexOf("auto") ? (o = (r = l.position()).top, a = r.left) : (o = parseFloat(i) || 0, a = parseFloat(s) || 0), h(t) && (t = t.call(e, n, b.extend({}, u))), null != t.top && (d.top = t.top - u.top + o), null != t.left && (d.left = t.left - u.left + a), "using" in t ? t.using.call(e, d) : ("number" == typeof d.top && (d.top += "px"), "number" == typeof d.left && (d.left += "px"), l.css(d))
                            }
                        }, b.fn.extend({
                            offset: function (e) {
                                if (arguments.length) return void 0 === e ? this : this.each((function (t) {
                                    b.offset.setOffset(this, e, t)
                                }));
                                var t, n, r = this[0];
                                return r ? r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, {
                                    top: t.top + n.pageYOffset,
                                    left: t.left + n.pageXOffset
                                }) : {
                                    top: 0,
                                    left: 0
                                } : void 0
                            },
                            position: function () {
                                if (this[0]) {
                                    var e, t, n, r = this[0],
                                        a = {
                                            top: 0,
                                            left: 0
                                        };
                                    if ("fixed" === b.css(r, "position")) t = r.getBoundingClientRect();
                                    else {
                                        for (t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === b.css(e, "position");) e = e.parentNode;
                                        e && e !== r && 1 === e.nodeType && ((a = b(e).offset()).top += b.css(e, "borderTopWidth", !0), a.left += b.css(e, "borderLeftWidth", !0))
                                    }
                                    return {
                                        top: t.top - a.top - b.css(r, "marginTop", !0),
                                        left: t.left - a.left - b.css(r, "marginLeft", !0)
                                    }
                                }
                            },
                            offsetParent: function () {
                                return this.map((function () {
                                    for (var e = this.offsetParent; e && "static" === b.css(e, "position");) e = e.offsetParent;
                                    return e || re
                                }))
                            }
                        }), b.each({
                            scrollLeft: "pageXOffset",
                            scrollTop: "pageYOffset"
                        }, (function (e, t) {
                            var n = "pageYOffset" === t;
                            b.fn[e] = function (r) {
                                return H(this, (function (e, r, a) {
                                    var i;
                                    if (v(e) ? i = e : 9 === e.nodeType && (i = e.defaultView), void 0 === a) return i ? i[t] : e[r];
                                    i ? i.scrollTo(n ? i.pageXOffset : a, n ? a : i.pageYOffset) : e[r] = a
                                }), e, r, arguments.length)
                            }
                        })), b.each(["top", "left"], (function (e, t) {
                            b.cssHooks[t] = He(p.pixelPosition, (function (e, n) {
                                if (n) return n = Ve(e, t), Re.test(n) ? b(e).position()[t] + "px" : n
                            }))
                        })), b.each({
                            Height: "height",
                            Width: "width"
                        }, (function (e, t) {
                            b.each({
                                padding: "inner" + e,
                                content: t,
                                "": "outer" + e
                            }, (function (n, r) {
                                b.fn[r] = function (a, i) {
                                    var o = arguments.length && (n || "boolean" != typeof a),
                                        u = n || (!0 === a || !0 === i ? "margin" : "border");
                                    return H(this, (function (t, n, a) {
                                        var i;
                                        return v(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (i = t.documentElement, Math.max(t.body["scroll" + e], i["scroll" + e], t.body["offset" + e], i["offset" + e], i["client" + e])) : void 0 === a ? b.css(t, n, u) : b.style(t, n, a, u)
                                    }), t, o ? a : void 0, o)
                                }
                            }))
                        })), b.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], (function (e, t) {
                            b.fn[t] = function (e) {
                                return this.on(t, e)
                            }
                        })), b.fn.extend({
                            bind: function (e, t, n) {
                                return this.on(e, null, t, n)
                            },
                            unbind: function (e, t) {
                                return this.off(e, null, t)
                            },
                            delegate: function (e, t, n, r) {
                                return this.on(t, e, n, r)
                            },
                            undelegate: function (e, t, n) {
                                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
                            },
                            hover: function (e, t) {
                                return this.mouseenter(e).mouseleave(t || e)
                            }
                        }), b.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), (function (e, t) {
                            b.fn[t] = function (e, n) {
                                return 0 < arguments.length ? this.on(t, null, e, n) : this.trigger(t)
                            }
                        }));
                        var Qt = /^[\s﻿ ]+|[\s﻿ ]+$/g;
                        b.proxy = function (e, t) {
                            var n, r, i;
                            if ("string" == typeof t && (n = e[t], t = e, e = n), h(e)) return r = a.call(arguments, 2), (i = function () {
                                return e.apply(t || this, r.concat(a.call(arguments)))
                            }).guid = e.guid = e.guid || b.guid++, i
                        }, b.holdReady = function (e) {
                            e ? b.readyWait++ : b.ready(!0)
                        }, b.isArray = Array.isArray, b.parseJSON = JSON.parse, b.nodeName = A, b.isFunction = h, b.isWindow = v, b.camelCase = z, b.type = _, b.now = Date.now, b.isNumeric = function (e) {
                            var t = b.type(e);
                            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
                        }, b.trim = function (e) {
                            return null == e ? "" : (e + "").replace(Qt, "")
                        }, "function" == typeof define && define.amd && define("jquery", [], (function () {
                            return b
                        }));
                        var Yt = e.jQuery,
                            Xt = e.$;
                        return b.noConflict = function (t) {
                            return e.$ === b && (e.$ = Xt), t && e.jQuery === b && (e.jQuery = Yt), b
                        }, void 0 === t && (e.jQuery = e.$ = b), b
                    }, "object" == typeof module && "object" == typeof module.exports ? module.exports = p.document ? h(p, !0) : function (e) {
                        if (!e.document) throw new Error("jQuery requires a window with a document");
                        return h(e)
                    } : h(p);
                    var b = $.noConflict(!0),
                        w = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "jsonGetPromise",
                                value: function (t, n, r) {
                                    return new Promise((function (a, i) {
                                        var o = {
                                            dataType: "json",
                                            url: t,
                                            cache: !0,
                                            headers: r || {},
                                            data: n || {},
                                            timeout: e.HTTP_TIMEOUT_MS,
                                            success: function (e) {
                                                return a(e)
                                            },
                                            error: function (e) {
                                                return i("Failed call to " + t + " : " + e.statusText + " " + e.status)
                                            }
                                        };
                                        b.ajax(o)
                                    }))
                                }
                            }]), e
                        }();
                    a(w, "HTTP_TIMEOUT_MS", 3e4);
                    var k = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "isMobile",
                            value: function () {
                                var t = navigator.userAgent || navigator.vendor || window.opera;
                                return e.MOBILE_FULL_PATTERN.test(t) || e.MOBILE_SHORT_PATTERN.test(t.substr(0, 4))
                            }
                        }, {
                            key: "isSafari",
                            value: function () {
                                return /Safari/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Edg\/\d/.test(navigator.userAgent)
                            }
                        }, {
                            key: "isIE",
                            value: function () {
                                return navigator.appVersion && (navigator.appVersion.indexOf("MSIE") > 0 || navigator.appVersion.indexOf("Trident") > 0)
                            }
                        }, {
                            key: "getLanguage",
                            value: function () {
                                return window.navigator.language
                            }
                        }]), e
                    }();
                    a(k, "MOBILE_FULL_PATTERN", /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i), a(k, "MOBILE_SHORT_PATTERN", /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i);
                    var S = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "isPreviewAndHasParam",
                                value: function (t) {
                                    return e.isPreview() && g.hasParameterInUrl(t)
                                }
                            }, {
                                key: "isPreview",
                                value: function () {
                                    return g.hasParameterInUrl("previewCollectionsApp")
                                }
                            }]), e
                        }(),
                        x = function () {
                            function e(n) {
                                n.theme = window.BOOMR.themeName || theme.settings.themeName || '';
                                t(this, e), this.customCss = n.custom_css, this.customJs = n.custom_js, this.theme = n.theme, this.moneyFormat = n.money_format;

                                var r = {
                                    "align": true,
                                    "theme": window.Shopify?.theme?.schema_name || window.Shopify?.theme?.name || theme?.settings?.themeName || document.documentElement.getAttribute('data-theme-name') || window.theme?.name || '',
                                    "target" : ".st-product-inner.grid-product",
                                    "target_placement" : "LAST_CHILD",
                                    "mobile_target" : "",
                                    "mobile_target_placement" : "LAST_CHILD",
                                    "show_on_homepage" : data.showOnHomepage,
                                    "show_on_search_results_page" : data.showOnSearchResultsPage,
                                    "show_on_product_page" : data.showOnProductPage,
                                    "show_on_collection_page" : data.showOnCollectionPage,
                                    "show_on_cart_page" : false,
                                    "redirect_policy" : data.redirectPolicy,
                                    "show_drawer_cart" : true,
                                    "lazy_loading" : true,
                                    "align" : true,
                                    "button_text" : data.buttonText,
                                    "button_added_text" : data.buttonAddedText,
                                    "button_recovery" : true,
                                    "button_border_size" : data.buttonBorderSize+'px',
                                    "button_border_color" : data.buttonBorderColor,
                                    "button_border_radius" : data.buttonBorderRadius+'px',
                                    "button_background_color" :data.buttonBackgroundColor,
                                    "button_font_size" : data.buttonFontSize+'px',
                                    "button_font_color" : data.buttonFontColor,
                                    "button_font_style" : data.buttonFontStyle,
                                    "button_font_family" : data.buttonFontFamily,
                                    "show_variant_selector" : data.showVariantSelector,
                                    "variant_selector_border_size" : data.advancedBorderSize+'px' || data.variantSelectorBorderSize+'px',
                                    "variant_selector_border_color" : data.advancedBorderColor || data.variantSelectorBorderColor,
                                    "variant_selector_border_radius" : data.variantSelectorBorderRadius+'px' || data.variantSelectorBorderRadius+'px',
                                    "variant_selector_background_color" : data.advancedBackgroundColor || data.variantSelector,
                                    "variant_selector_font_size" : data.advancedFontSize+'px' || data.variantSelectorFontSize+'px',
                                    "variant_selector_font_color" : data.advancedFontColor || data.variantSelectorFontColor,
                                    "variant_selector_font_style" : data.advancedFontStyle || data.variantSelectorFontStyle,
                                    "variant_selector_font_family" : data.advancedFontFamily || data.variantSelectorFontFamily,
                                    "show_variant_price" :data.showVariantPrice,
                                    "update_variant_image" : data.updateVariant,
                                    "showAllVariants" : data.showAllVariants,
                                    "enable_multiple_variant_selectors" : data.enableMultipleVariantSelectors,
                                    "show_quantity_selector" : data.showQuantitySelector,
                                    "show_variant_selector_label" : data.showVariantSelectorLabel,
                                    "variant_selector_label_font_size" : data.variantSelectorLabelFontSize+'px',
                                    "variant_selector_label_font_color" : data.variantSelectorLabelFontColor,
                                    "variant_selector_label_font_style" : data.variantSelectorLabelFontStyle,
                                    "variant_selector_label_font_family" : data.variantSelectorLabelFontFamily,
                                    "quantity_selector_border_size" : data.quantitySelectorBorderSize+'px',
                                    "quantity_selector_border_color" : data.quantitySelectorBorderColor,
                                    "quantity_selector_border_radius" : data.quantitySelectorBorderRadius+'px',
                                    "quantity_selector_background_color" : data.quantitySelectorBackgroundColor,
                                    "quantity_selector_font_size" : data.quantitySelectorFontSize+'px',
                                    "quantity_selector_font_color" : data.quantitySelectorFontColor,
                                    "quantity_selector_font_style" : data.quantitySelectorFontStyle,
                                    "quantity_selector_font_family" : data.quantitySelectorFontFamily,
                                    "quantity_selector_default_quantity" : data.quantitySelectorDefaultQuantity,
                                    "show_sold_out_button" : data.showSoldOutButton,
                                    "sold_out_button_text" : data.showSoldOutButtonText || "Sold Out",
                                    "sold_out_button_border_size" : 1,
                                    "sold_out_button_border_color" : "#333333",
                                    "sold_out_button_border_radius" : 0,
                                    "sold_out_button_background_color" : "#000000",
                                    "sold_out_button_font_size" : 14,
                                    "sold_out_button_font_color" : "#FFFFFF",
                                    "sold_out_button_font_style" : "NORMAL",
                                    "sold_out_button_font_family" : ""


                                }
                                this.target = e._target(r), this.targetPlacement = e._targetPlacement(r), this.showOnHomepage = r.show_on_homepage, this.showOnSearchResultsPage = r.show_on_search_results_page, this.showOnProductPage = r.show_on_product_page, this.showOnCartPage = r.show_on_cart_page, this.redirectPolicy = e._valuePreferences("redirectPolicy", r.redirect_policy), this.showDrawerCart = e._booleanPreferences("showDrawerCart", "true"), this.alignWidgets = e._booleanPreferences("align", r.align), this.buttonText = e._valuePreferences("buttonText", r.button_text), this.buttonAddedText = e._valuePreferences("buttonAddedText", r.button_added_text), this.buttonRecovery = e._valuePreferences("buttonRecovery", r.button_recovery), this.buttonBorderSize = e._valuePreferences("buttonBorderSize", r.button_border_size), this.buttonBorderColor = e._valuePreferences("buttonBorderColor", r.button_border_color), this.buttonBorderRadius = e._valuePreferences("buttonBorderRadius", r.button_border_radius), this.buttonBackgroundColor = e._valuePreferences("buttonBackgroundColor", r.button_background_color), this.buttonFontSize = e._valuePreferences("buttonFontSize", r.button_font_size), this.buttonFontColor = e._valuePreferences("buttonFontColor", r.button_font_color), this.buttonFontStyle = e._valuePreferences("buttonFontStyle", r.button_font_style), this.buttonFontFamily = e._valuePreferences("buttonFontFamily", r.button_font_family), this.showSoldOutButton = e._booleanPreferences("showSoldOutButton", r.show_sold_out_button), this.showSoldOutButtonText = e._valuePreferences("showSoldOutButtonText", r.sold_out_button_text), this.soldOutButtonBorderSize = e._valuePreferences("soldOutButtonBorderSize", r.sold_out_button_border_size), this.soldOutButtonBorderColor = e._valuePreferences("soldOutButtonBorderColor", r.sold_out_button_border_color), this.soldOutButtonBorderRadius = e._valuePreferences("soldOutButtonBorderRadius", r.sold_out_button_border_radius), this.soldOutButtonBackgroundColor = e._valuePreferences("soldOutButtonBackgroundColor", r.sold_out_button_background_color), this.soldOutButtonFontSize = e._valuePreferences("soldOutButtonFontSize", r.sold_out_button_font_size), this.soldOutButtonFontColor = e._valuePreferences("soldOutButtonFontColor", r.sold_out_button_font_color), this.soldOutButtonFontStyle = e._valuePreferences("soldOutButtonFontStyle", r.sold_out_button_font_style), this.soldOutButtonFontFamily = e._valuePreferences("soldOutButtonFontFamily", r.sold_out_button_font_family), this.showVariantSelector = e._booleanPreferences("showVariantSelector", r.show_variant_selector), this.variantSelectorBorderSize = e._valuePreferences("variantSelectorBorderSize", r.variant_selector_border_size), this.variantSelectorBorderColor = e._valuePreferences("variantSelectorBorderColor", r.variant_selector_border_color), this.variantSelectorBorderRadius = e._valuePreferences("variantSelectorBorderRadius", r.variant_selector_border_radius), this.variantSelectorBackgroundColor = e._valuePreferences("variantSelectorBackgroundColor", r.variant_selector_background_color), this.variantSelectorFontSize = e._valuePreferences("variantSelectorFontSize", r.variant_selector_font_size), this.variantSelectorFontColor = e._valuePreferences("variantSelectorFontColor", r.variant_selector_font_color), this.variantSelectorFontStyle = e._valuePreferences("variantSelectorFontStyle", r.variant_selector_font_style), this.variantSelectorFontFamily = e._valuePreferences("variantSelectorFontFamily", r.variant_selector_font_family), this.showVariantPrice = e._booleanPreferences("showVariantPrice", r.show_variant_price), this.updateVariantImage = e._booleanPreferences("updateVariantImage", r.update_variant_image), this.showAllVariants = e._booleanPreferences("showAllVariants", r.show_all_variants), this.enableMultipleVariantSelectors = e._booleanPreferences("enableMultipleVariantSelectors", r.enable_multiple_variant_selectors), this.showVariantSelectorLabel = e._booleanPreferences("showVariantSelectorLabel", r.show_variant_selector_label), this.variantSelectorLabelFontSize = e._valuePreferences("variantSelectorLabelFontSize", r.variant_selector_label_font_size), this.variantSelectorLabelFontColor = e._valuePreferences("variantSelectorLabelFontColor", r.variant_selector_label_font_color), this.variantSelectorLabelFontStyle = e._valuePreferences("variantSelectorLabelFontStyle", r.variant_selector_label_font_style), this.variantSelectorLabelFontFamily = e._valuePreferences("variantSelectorLabelFontFamily", r.variant_selector_label_font_family), this.showQuantitySelector = e._booleanPreferences("showQuantitySelector", r.show_quantity_selector), this.quantitySelectorBorderSize = e._valuePreferences("quantitySelectorBorderSize", r.quantity_selector_border_size), this.quantitySelectorBorderColor = e._valuePreferences("quantitySelectorBorderColor", r.quantity_selector_border_color), this.quantitySelectorBorderRadius = e._valuePreferences("quantitySelectorBorderRadius", r.quantity_selector_border_radius), this.quantitySelectorBackgroundColor = e._valuePreferences("quantitySelectorBackgroundColor", r.quantity_selector_background_color), this.quantitySelectorFontSize = e._valuePreferences("quantitySelectorFontSize", r.quantity_selector_font_size), this.quantitySelectorFontColor = e._valuePreferences("quantitySelectorFontColor", r.quantity_selector_font_color), this.quantitySelectorFontStyle = e._valuePreferences("quantitySelectorFontStyle", r.quantity_selector_font_style), this.quantitySelectorFontFamily = e._valuePreferences("quantitySelectorFontFamily", r.quantity_selector_font_family), this.quantitySelectorDefaultQuantity = e._valuePreferences("quantitySelectorDefaultQuantity", r.quantity_selector_default_quantity)
                            }
                            return r(e, null, [{
                                key: "_target",
                                value: function (t) {
                                    var n = e._valuePreferences("mobileTarget", t.mobile_target),
                                        r = e._valuePreferences("target", t.target);
                                    return k.isMobile() && f.isNotEmpty(n) ? n : r
                                }
                            }, {
                                key: "_targetPlacement",
                                value: function (t) {
                                    var n = e._valuePreferences("mobileTarget", t.mobile_target_placement),
                                        r = e._valuePreferences("target", t.target_placement);
                                    return k.isMobile() && f.isNotEmpty(t.mobile_target) ? n : r
                                }
                            }, {
                                key: "fromJson",
                                value: function (t) {
                                    return t.error ? null : new e(t)
                                }
                            }, {
                                key: "_valuePreferences",
                                value: function (e, t) {
                                    if (S.isPreviewAndHasParam(e)) {
                                        var n = g.getParameterInUrl(e);
                                        return decodeURIComponent(n)
                                    }
                                    return t
                                }
                            }, {
                                key: "_booleanPreferences",
                                value: function (e, t) {
                                    if (S.isPreviewAndHasParam(e)) {
                                        var n = g.getParameterInUrl(e);
                                        return decodeURIComponent(n)
                                    }
                                    return !S.isPreviewAndHasParam("_" + e) && t
                                }
                            }]), e
                        }(),
                        T = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "load",
                                value: function () {
                                    e = {
                                        "custom_js" : "",
                                        "custom_css" : null,
                                        "theme": window.Shopify?.theme?.schema_name || window.Shopify?.theme?.name || theme?.settings?.themeName || document.documentElement.getAttribute('data-theme-name') || window.theme?.name || '',
                                        "money_format" : "",
                                        "preferences" : [{
                                            "target" : ".st-product-inner.grid-product",
                                            "target_placement" : "LAST_CHILD",
                                            "mobile_target" : "",
                                            "mobile_target_placement" : "LAST_CHILD",
                                            "show_on_homepage" : data.showOnHomepage,
                                            "show_on_search_results_page" : data.showOnSearchResultsPage,
                                            "show_on_product_page" : data.showOnProductPage,
                                            "show_on_collection_page" : data.showOnCollectionPage,
                                            "show_on_cart_page" : false,
                                            "redirect_policy" : data.redirectPolicy,
                                            "show_drawer_cart" : true,
                                            "lazy_loading" : true,
                                            "align" : true,
                                            "button_text" : data.buttonText,
                                            "button_added_text" : data.buttonAddedText,
                                            "button_recovery" : true,
                                            "button_border_size" : data.buttonBorderSize+'px',
                                            "button_border_color" : data.buttonBorderColor,
                                            "button_border_radius" : data.buttonBorderRadius+'px',
                                            "button_background_color" :data.buttonBackgroundColor,
                                            "button_font_size" : data.buttonFontSize+'px',
                                            "button_font_color" : data.buttonFontColor,
                                            "button_font_style" : data.buttonFontStyle,
                                            "button_font_family" : data.buttonFontFamily,
                                            "show_variant_selector" : data.showVariantSelector,
                                            "variant_selector_border_size" : data.advancedBorderSize+'px' || data.variantSelectorBorderSize+'px' ,
                                            "variant_selector_border_color" : data.advancedBorderColor || data.variantSelectorBorderColor,
                                            "variant_selector_border_radius" : data.variantSelectorBorderRadius+'px' || data.variantSelectorBorderRadius+'px',
                                            "variant_selector_background_color" : data.advancedBackgroundColor || data.variantSelectorBackgroundColor,
                                            "variant_selector_font_size" : data.advancedFontSize+'px' || data.variantSelectorFontSize+'px',
                                            "variant_selector_font_color" : data.advancedFontColor || data.variantSelectorFontColor,
                                            "variant_selector_font_style" : data.advancedFontStyle || data.variantSelectorFontStyle,
                                            "variant_selector_font_family" : data.advancedFontFamily || data.variantSelectorFontFamily,
                                            "show_variant_price" :data.showVariantPrice,
                                            "update_variant_image" : data.updateVariantImage,
                                            "showAllVariants" : data.showAllVariants,
                                            "enable_multiple_variant_selectors" : data.enableMultipleVariantSelectors,
                                            "show_quantity_selector" : data.showQuantitySelector,
                                            "show_variant_selector_label" : (data.showVariantSelectorLabel !== undefined),
                                            "variant_selector_label_font_size" : data.variantSelectorLabelFontSize+'px',
                                            "variant_selector_label_font_color" : data.variantSelectorLabelFontColor,
                                            "variant_selector_label_font_style" : data.variantSelectorLabelFontStyle,
                                            "variant_selector_label_font_family" : data.variantSelectorLabelFontFamily,
                                            "quantity_selector_border_size" : data.quantitySelectorBorderSize+'px',
                                            "quantity_selector_border_color" : data.quantitySelectorBorderColor,
                                            "quantity_selector_border_radius" : data.quantitySelectorBorderRadius+'px',
                                            "quantity_selector_background_color" : data.quantitySelectorBackgroundColor,
                                            "quantity_selector_font_size" : data.quantitySelectorFontSize+'px',
                                            "quantity_selector_font_color" : data.quantitySelectorFontColor,
                                            "quantity_selector_font_style" : data.quantitySelectorFontStyle,
                                            "quantity_selector_font_family" : data.quantitySelectorFontFamily,
                                            "quantity_selector_default_quantity" : data.quantitySelectorDefaultQuantity,
                                            "show_sold_out_button" : (data.showSoldOutButton !== undefined),
                                            "sold_out_button_text" : data.showSoldOutButtonText || "Sold Out",
                                            "sold_out_button_border_size" : 1,
                                            "sold_out_button_border_color" : "#333333",
                                            "sold_out_button_border_radius" : 0,
                                            "sold_out_button_background_color" : "#000000",
                                            "sold_out_button_font_size" : 14,
                                            "sold_out_button_font_color" : "#FFFFFF",
                                            "sold_out_button_font_style" : "NORMAL",
                                            "sold_out_button_font_family" : ""
                                        }]
                                    };
                                    return x.fromJson(e)
                                }
                            }]), e
                        }(),
                        A = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "setProperty",
                                value: function (t, n) {
                                    e._setGlobalProperty(t, n)
                                }
                            }, {
                                key: "getProperty",
                                value: function (t) {
                                    return e._getGlobalProperty(t)
                                }
                            }, {
                                key: "_getGlobalProperty",
                                value: function (t) {
                                    return e._createGlobalCLEVERIfRequired(), void 0 === window.CLEVER[t] && (window.CLEVER[t] = {}), window.CLEVER[t]
                                }
                            }, {
                                key: "_setGlobalProperty",
                                value: function (t, n) {
                                    e._createGlobalCLEVERIfRequired(), window.CLEVER[t] = n
                                }
                            }, {
                                key: "_createGlobalCLEVERIfRequired",
                                value: function () {
                                    window.CLEVER || (window.CLEVER = {})
                                }
                            }]), e
                        }(),
                        E = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "hasLoadedBefore",
                                value: function () {
                                    return !!e._hasLoadedBefore() || (e._markAsLoaded(), !1)
                                }
                            }, {
                                key: "_hasLoadedBefore",
                                value: function () {
                                    return !0 === A.getProperty(e.FLAG)
                                }
                            }, {
                                key: "_markAsLoaded",
                                value: function () {
                                    A.setProperty(e.FLAG, !0)
                                }
                            }]), e
                        }();
                    a(E, "FLAG", C.appId() + "-loaded");
                    var P = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "isRightPage",
                            value: function (t) {
                                return g.isDemoPage() || e._isPagesAndPreferenceEnabled(t)|| e._isCollectionPageAndCollectionIsNotDisabled(t) || e._isHomePageAndPreferenceEnabled(t) || e._isSearchPageAndPreferenceEnabled(t) || e._isProductPageAndPreferenceEnabled(t) || e._isCartPageAndPreferenceEnabled(t) || e.isWidgetForced()
                            }
                        }, {
                            key: "isWidgetForced",
                            value: function () {
                                return b(e.FORCE_WIDGET_SELECTOR).length > 0
                            }
                        }, {
                            key: "_isCollectionPageAndCollectionIsNotDisabled",
                            value: function () {
                                return g.isCollectionPage() && e._isCollectionAllowed()
                            }
                        }, {
                            key: "_isHomePageAndPreferenceEnabled",
                            value: function (e) {
                                return e.showOnHomepage && g.isHomePage()
                            }
                        }, {
                            key: "_isPagesAndPreferenceEnabled",
                            value: function (e) {
                                return true && m.isPages();;
                            }
                        },
                            {
                                key: "_isSearchPageAndPreferenceEnabled",
                                value: function (e) {
                                    return e.showOnSearchResultsPage && g.isSearchResultsPage()
                                }
                            }, {
                                key: "_isProductPageAndPreferenceEnabled",
                                value: function (e) {
                                    return e.showOnProductPage && g.isProductPage()
                                }
                            }, {
                                key: "_isCartPageAndPreferenceEnabled",
                                value: function (e) {
                                    return e.showOnCartPage && g.isCartPage()
                                }
                            }, {
                                key: "_isCollectionAllowed",
                                value: function () {
                                    return !e._isCollectionDisabled()
                                }
                            }, {
                                key: "_isCollectionDisabled",
                                value: function () {
                                    return b(e.COLLECTION_DISABLED_SELECTOR).length > 0
                                }
                            }]), e
                    }();
                    a(P, "COLLECTION_DISABLED_SELECTOR", "." + C.AVOID_WIDGET_TAG), a(P, "FORCE_WIDGET_SELECTOR", "." + C.FORCE_WIDGET_TAG);
                    var I = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "shouldStartApp",
                                value: function () {
                                    return e._doesPageEnforceAppLoading() && e._notInsideThemeEditor() && e._isRightPage()
                                }
                            }, {
                                key: "_doesPageEnforceAppLoading",
                                value: function () {
                                    return e._notLoadedBefore() || e._pageContentHasBeenReloadedInsteadOfNavigatingToADifferentPage()
                                }
                            }, {
                                key: "_notLoadedBefore",
                                value: function () {
                                    return !E.hasLoadedBefore()
                                }
                            }, {
                                key: "_notInsideThemeEditor",
                                value: function () {
                                    return !l.isInsideThemeEditor()
                                }
                            }, {
                                key: "_isRightPage",
                                value: function () {
                                    return g.isDemoPage() || g.isCollectionPage() || g.isHomePage() || g.isSearchResultsPage() || g.isProductPage() || g.isCartPage() || P.isWidgetForced() || m.isPages()
                                }
                            }, {
                                key: "_pageContentHasBeenReloadedInsteadOfNavigatingToADifferentPage",
                                value: function () {
                                    var e;
                                    return performance && performance.getEntriesByType("navigation") && performance.getEntriesByType("navigation")[0] && (e = performance.getEntriesByType("navigation")[0].name), e && e !== location.href
                                }
                            }]), e
                        }(),
                        O = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "publishCLEVERJqueryIfRequired",
                                value: function () {
                                    window.CLEVERJquery || (window.CLEVERJquery = b)
                                }
                            }]), e
                        }(),
                        D = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "href",
                                value: function (e) {
                                    return b(e).attr("href")
                                }
                            }, {
                                key: "hrefPathname",
                                value: function (t) {
                                    return g.removeParameters(e.href(t))
                                }
                            }, {
                                key: "isVisible",
                                value: function (e) {
                                    return b(e).is(":visible")
                                }
                            }]), e
                        }(),
                        B = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "isValid",
                                value: function (t) {
                                    return e._isNotSocialNetworkUrl(t) && e._isNotImage(t)
                                }
                            }, {
                                key: "_isNotSocialNetworkUrl",
                                value: function (e) {
                                    return !e.startsWith("//www.facebook.com") && !e.startsWith("//twitter.com") && !e.startsWith("//pinterest.com")
                                }
                            }, {
                                key: "_isNotImage",
                                value: function (e) {
                                    var t = g.removeParameters(e);
                                    return !t.endsWith(".jpg") && !t.endsWith(".png") && !t.endsWith(".jpeg")
                                }
                            }]), e
                        }(),
                        j = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "findUnprocessedProductLinks",
                                value: function () {
                                    return e._productLinkElements().not(C.PROCESSED_BY_CLEVER_SELECTOR).toArray().filter((function (t) {
                                        return e._isProductLinkElementValid(t)
                                    }))
                                }
                            }, {
                                key: "_productLinkElements",
                                value: function () {
                                    var t = b(e.COLLECTION_PRODUCT_LINK_SELECTORS.join(","));
                                    return 0 === t.length && (t = b(e.COLLECTION_DEFAULT_PRODUCT_LINK_SELECTOR)), t
                                }
                            }, {
                                key: "_isProductLinkElementValid",
                                value: function (e) {
                                    var t = D.href(e);
                                    return D.isVisible(e) && B.isValid(t)
                                }
                            }]), e
                        }();
                    a(j, "COLLECTION_PRODUCT_LINK_SELECTORS", ['#shopify-section-collection-template a[href*="/products/"]', '#shopify-section-static-collection a[href*="/products/"]', '#shopify-section-collection a[href*="/products/"]', '.cleverapps-collections-add-to-cart-section a[href*="/products/"]']), a(j, "COLLECTION_DEFAULT_PRODUCT_LINK_SELECTOR", 'a[href*="/products/"]');
                    var L = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "getDefaultCss",
                                value: function () {
                                    return {
                                        "word-wrap": "break-word",
                                        "white-space": "normal",
                                        "text-decoration": "none",
                                        "line-height": "1.2",
                                        "letter-spacing": "0px"
                                    }
                                }
                            }, {
                                key: "applyFontStyle",
                                value: function (e, t) {
                                    "NORMAL" === t ? (e.css("font-weight", "normal"), e.css("font-style", "normal")) : "BOLD" === t ? (e.css("font-weight", "bold"), e.css("font-style", "normal")) : "ITALIC" === t ? (e.css("font-weight", "normal"), e.css("font-style", "italic")) : "BOLD_ITALIC" === t && (e.css("font-weight", "bold"), e.css("font-style", "italic"))
                                }
                            }, {
                                key: "applyFontFamily",
                                value: function (e, t) {
                                    var n = t ? t + ",Lato,'Helvetica Neue',Arial,Helvetica,sans-serif" : "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif";
                                    e.css("font-family", n)
                                }
                            }]), e
                        }(),
                        N = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "getCart",
                                value: function (t) {
                                    if (!g.isDemoPage()) {
                                        return w.jsonGetPromise(e.CART_API_URL, null)
                                    }
                                    setTimeout((function () {
                                        return t()
                                    }), 1e3)
                                }
                            }, {
                                key: "addVariant",
                                value: function (t, n, r, a, i) {
                                    if (g.isDemoPage()) setTimeout((function () {
                                        return a()
                                    }), 1e3);
                                    else {
                                        var o = {
                                            items: [{
                                                id: t,
                                                quantity: n
                                            }]
                                        };
                                        o = e._addStoreCustomParametersToCartItems(o), b.post(e.CART_API_ADD_URL, o, (function (t) {
                                            return e._handleSuccess(a, t)
                                        }), "json").fail((function (t) {
                                            return e._handleError(t.responseJSON, i)
                                        }))
                                    }
                                }
                            }, {
                                key: "findLastAddedProduct",
                                value: function (e, t) {
                                    for (var n in e.items)
                                        if (e.items[n].id === t) return e.items[n];
                                    return e.items[0]
                                }
                            }, {
                                key: "_handleSuccess",
                                value: function (e, t) {
                                    e && e(t)
                                }
                            }, {
                                key: "_handleError",
                                value: function (e, t) {
                                    e && e.status ? t(e.description) : t("An error happened while adding products to the shopping cart")
                                }
                            }, {
                                key: "_addStoreCustomParametersToCartItems",
                                value: function (e) {
    
    return window.CLEVER && window.CLEVER.addStoreCustomParametersToCartItems ? window.CLEVER.addStoreCustomParametersToCartItems(e) : e;
}
                            }]), e
                        }();
                    a(N, "CART_API_URL", g.getInternationalContext() + "/cart.js"), a(N, "CART_API_ADD_URL", g.getInternationalContext() + "/cart/add.js");
                    var R = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "ajaxCart",
                            value: function (t, n, r) {
                                true;
                                e._updateCartIcon(), r && e._isCompatibleVersion() && e._refreshCartPopup(t, n)
                            }
                        }, {
                            key: "_isCompatibleVersion",
                            value: function () {
                                return window.theme && window.theme.Product && window.theme.Product.prototype._setupCartPopup
                            }
                        }, {
                            key: "_refreshCartPopup",
                            value: function (t, n) {
                                N.getCart().then((function (r) {
                                    var a = b(e.DEBUT_FAKE_CONTAINER_HTML);
                                    b("body").append(a);
                                    var i = N.findLastAddedProduct(r, t),
                                        o = document.querySelector("#cleverapps-debut-fake-container"),
                                        u = new window.theme.Product(o);
                                    try {
                                        u._hideCartPopup({
                                            detail: 1
                                        })
                                    } catch (e) {}
                                    b("[data-cart-popup-image-wrapper]").html(""), document.querySelector("[data-cart-routes]") && (u.cartRoutes = JSON.parse(document.querySelector("[data-cart-routes]").innerHTML)), u._setupCartPopup(i), b("span[data-cart-popup-quantity]").html(n), a.remove()
                                }))
                            }
                        }, {
                            key: "_updateCartIcon",
                            value: function () {
                                N.getCart().then(e._updateCartBubble)
                            }
                        }, {
                            key: "_updateCartBubble",
                            value: function (e) {
                                var t = e.item_count;
                                b(".site-header__cart-count span").first().html(t), t > 0 && b(".site-header__cart-count").removeClass("hide")
                            }
                        }]), e
                    }();
                    a(R, "DEBUT_FAKE_CONTAINER_HTML", '\n        <div id="cleverapps-debut-fake-container" style="display: none">\n            <p data-loader-status=""></p>\n            <div data-image-loading-animation></div>\n            <form data-product-form="">\n                <button data-add-to-cart="">\n                    <span data-add-to-cart-text=""> Add to cart </span>\n                    <span class="hide" data-loader=""> </span>\n                </button>\n            </form>\n        </div>');
                    var F = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    true;
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    window.ajaxCart && window.ajaxCart.load()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    e.item_count > 0 && b(".cart-link__bubble").addClass("cart-link__bubble--visible")
                                }
                            }]), e
                        }(),
                        q = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t ? e._loadCart() : e._updateCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    window.ajaxCart ? window.ajaxCart.load() : window.HsCartDrawer && (window.HsCartDrawer.updateSlideCart(), window.HsCartDrawer.showCartPopup(1, window.$))
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    window.HsCartDrawer && window.HsCartDrawer.updateSlideCart()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    e.item_count > 0 && b(".site-header__cart").addClass("cart-bubble--visible")
                                }
                            }]), e
                        }(),
                        U = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    t ? e._isNewVersionDrawerCart() ? e._loadNewDrawerCart() : e._isOldVersionDrawerCart() && e._loadOldDrawerCart() : e._isNewVersionDrawerCart() && e._updateNewDrawerCart()
                                }
                            }, {
                                key: "_isNewVersionDrawerCart",
                                value: function () {
                                    return "object" == typeof window.wetheme && "object" == typeof window.wetheme.cartDrawer && "function" == typeof window.wetheme.updateCartDrawer
                                }
                            }, {
                                key: "_isOldVersionDrawerCart",
                                value: function () {
                                    return "function" == typeof window.Product && null !== document.querySelector("#product-box")
                                }
                            }, {
                                key: "_loadNewDrawerCart",
                                value: function () {
                                    N.getCart().then((function (e) {
                                        window.wetheme.updateCartDrawer(e), window.wetheme.cartDrawer.element.dispatchEvent(new CustomEvent("cart:open"))
                                    }))
                                }
                            }, {
                                key: "_loadOldDrawerCart",
                                value: function () {
                                    new window.Product(document.querySelector("#product-box")).update_cart()
                                }
                            }, {
                                key: "_updateNewDrawerCart",
                                value: function () {
                                    N.getCart().then((function (e) {
                                        window.wetheme.updateCartDrawer(e)
                                    }))
                                }
                            }]), e
                        }(),
                        V = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t, n, r) {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_ajaxCartEnabled",
                                value: function () {
                                    var e = null !== document.querySelector("[data-header-cart]"),
                                        t = window.headerCartBuildProduct && "function" == typeof window.headerCartBuildProduct;
                                    return e && t
                                }
                            }, {
                                key: "_refreshAjaxCart",
                                value: function (e, t) {
                                    var n = null !== document.querySelector('[data-header-cart-item="' + e + '"]');
                                    N.getCart().then((function (r) {
                                        var a = N.findLastAddedProduct(r, e);
                                        window.headerCartBuildProduct(r, n, a, t)
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("span#cartItemCount").html(e.item_count)
                                }
                            }]), e
                        }(),
                        H = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    true;
                                }
                            }, {
                                key: "_showNotification",
                                value: function () {
                                    window.theme && window.theme.Notify && window.theme.Notify.open("success", !1, !0)
                                }
                            }, {
                                key: "_isNotificationEnabled",
                                value: function () {
                                    var t = document.querySelector(e.PRODUCT_SECTION_SELECTOR);
                                    return t && "true" === t.getAttribute("data-ajax")
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    e.item_count > 0 && b(".site-header__cart-indicator").removeClass("hide")
                                }
                            }]), e
                        }();
                    a(H, "PRODUCT_SECTION_SELECTOR", "#ProductSection-product-template");
                    var M = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("span#CartCount").html(e.item_count)
                                }
                            }]), e
                        }(),
                        W = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t ? e._openDrawerCart() : e._updateCart()
                                }
                            }, {
                                key: "_openDrawerCart",
                                value: function () {
                                    if (window.theme && window.theme.sections && window.theme.sections.instances) {
                                        var e = window.theme.sections.instances[0];
                                        e.refresh(), e.drawerOpen(), e.$ajaxCart.removeClass("cart-drawer--empty")
                                    }
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    window.theme && window.theme.sections && window.theme.sections.instances && window.theme.sections.instances[0].refresh()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    e.item_count > 0 && b(".site-header__cart-bubble").addClass("site-header__cart-bubble--visible")
                                }
                            }]), e
                        }(),
                        z = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t ? e._loadCart() : e._updateCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    b("#ajaxifyCart").load('/cart form[action="/cart"]', (function () {
                                        document.querySelectorAll(".cart-toggle") && document.querySelectorAll(".cart-toggle")[0].click()
                                    }))
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    b("#ajaxifyCart").load('/cart form[action="/cart"]')
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = e.item_count;
                                    b(".cart-toggle .cart-count").html(t), t > 0 && b(".cart-toggle .cart-count").removeClass("hidden-count")
                                }
                            }]), e
                        }(),
                       G = function() {
        function t() {
            e(this, t)
        }
        return r(t, null, [{
            key: "ajaxCart",
            value: function(e) {
                t._updateCartInfo(),
                e ? t._triggerProductAddedEvent() : t._updateCart()
            }
        }, {
            key: "_triggerProductAddedEvent",
            value: function() {
                document.dispatchEvent(new CustomEvent("product:added",{
                    bubbles: !0,
                    detail: {
                        variant: 123,
                        quantity: 1
                    }
                }))
            }
        }, {
            key: "_updateCart",
            value: function() {
                document.dispatchEvent(new CustomEvent("cart:refresh",{
                    bubbles: !0
                }))
            }
        }, {
            key: "_updateCartInfo",
            value: function() {
                var t = this;
                N.getCart().then((function(e) {
                    t._updateCartInfoWithCart(e)
                }
                ))
            }
        }, {
            key: "_updateCartInfoWithCart",
            value: function(t) {
                var e = t.item_count;
                this._updateCartCount(e),
                this._updateCartDot(e)
            }
        }, {
            key: "_updateCartCount",
            value: function(t) {
                var e = document.querySelector(".Header__CartCount");
                e && (e.textContent = t)
            }
        }, {
            key: "_updateCartDot",
            value: function(t) {
                for (var e = document.querySelectorAll(".Header__CartDot, .header__cart-dot"), n = 0; n < e.length; n++) {
                    e[n].classList.toggle("is-visible", t > 0)
                }
            }
        }])
    }()
                        Q = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then((function (t) {
                                        e._updateCartSummary(t), e._triggerCurrencyConversion()
                                    }))
                                }
                            }, {
                                key: "_updateCartSummary",
                                value: function (t) {
                                    e._updateCartCount(t.item_count), e._updateCartTotal(t.total_price)
                                }
                            }, {
                                key: "_updateCartCount",
                                value: function (e) {
                                    b("#CartCount").html(e)
                                }
                            }, {
                                key: "_updateCartTotal",
                                value: function (e) {
                                    var t = b("#CartCost"),
                                        n = window.theme.Currency.formatMoney(e, window.theme.moneyFormat);
                                    t.html(n)
                                }
                            }, {
                                key: "_triggerCurrencyConversion",
                                value: function () {
                                    "function" == typeof convertCurrencies && convertCurrencies()
                                }
                            }]), e
                        }(),
                        Y = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    true;
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    e._drawerCartExists() && (e._openDrawerCart(), N.getCart().then((function () {
                                        return window.timber.cartUpdatePopup
                                    })))
                                }
                            }, {
                                key: "_drawerCartExists",
                                value: function () {
                                    return window.timber && window.timber.RightDrawer && window.timber.RightDrawer.config
                                }
                            }, {
                                key: "_openDrawerCart",
                                value: function () {
                                    window.timber.RightDrawer.config.onDrawerOpen()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = e.item_count;
                                    b(".CartCount").html(t)
                                }
                            }]), e
                        }(),
                        X = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = e.item_count,
                                        n = b(".site-header-cart--count");
                                    0 === t ? n.removeClass("visible") : n.attr("data-header-cart-count", t).addClass("visible")
                                }
                            }]), e
                        }(),
                        K = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t, n) {
                                    e._updateCartIcon(), n && e._displayAjaxCart(t)
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then((function (t) {
                                        e._updateCartSummary(t), e._triggerCurrencyConversion()
                                    }))
                                }
                            }, {
                                key: "_displayAjaxCart",
                                value: function (t) {
                                    N.getCart().then((function (n) {
                                        e._updateCartSummary(n), e._showCartPreview(n, t), e._triggerCurrencyConversion()
                                    }))
                                }
                            }, {
                                key: "_updateCartSummary",
                                value: function (t) {
                                    e._updateCartTotal(t.total_price), e._updateCartCount(t.item_count)
                                }
                            }, {
                                key: "_showCartPreview",
                                value: function (t, n) {
                                    e._cartPreviewEnabled() && e._triggerCartPreview(t, n)
                                }
                            }, {
                                key: "_triggerCurrencyConversion",
                                value: function () {
                                    if (e._themeCurrencyConverterEnabled()) {
                                        var t = window.StyleHatch.shopCurrency,
                                            n = b("[name=currencies]");
                                        window.Currency.convertAll(t, n.val())
                                    }
                                }
                            }, {
                                key: "_updateCartTotal",
                                value: function (e) {
                                    var t = window.StyleHatch.currencyFormat,
                                        n = window.theme.Currency.formatMoney(e, t),
                                        r = b("#CartCost");
                                    r.empty(), r.html('<span class="money">' + n + "</span>")
                                }
                            }, {
                                key: "_updateCartCount",
                                value: function (e) {
                                    b("#CartCount").html(e)
                                }
                            }, {
                                key: "_cartPreviewEnabled",
                                value: function () {
                                    return "function" == typeof window.StyleHatch.AjaxCart.showCartPreview
                                }
                            }, {
                                key: "_triggerCartPreview",
                                value: function (e, t) {
                                    var n = N.findLastAddedProduct(e, t);
                                    if (n) {
                                        var r = JSON.stringify(n);
                                        window.StyleHatch.AjaxCart.showCartPreview(r, e)
                                    }
                                }
                            }, {
                                key: "_themeCurrencyConverterEnabled",
                                value: function () {
                                    return window.StyleHatch && window.StyleHatch.currencyConverter && window.Currency
                                }
                            }]), e
                        }(),
                        Jae = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b(".icon_cart .tcount").html(e.item_count)
                                }
                            }]), e
                        }();
                    a(Jae, "ajaxCart", (function (e) {
                        Jae._updateCartIcon(), e && Jae._ajaxCartEnabled() && Jae._refreshAjaxCart()
                    })), a(Jae, "_ajaxCartEnabled", (function () {
                        return window.geckoShopify && "object" == typeof window.geckoShopify && window.geckoShopify.onCartUpdate && "function" == typeof window.geckoShopify.onCartUpdate
                    })), a(Jae, "_refreshAjaxCart", (function () {
                        window.geckoShopify.onCartUpdate(1, 1)
                    }));
                    var Z = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t ? (e._loadCart(), e._updateCart()) : e._updateCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
                                        detail: {
                                            addToCartBtn: null
                                        }
                                    })), window.$ && (window.$(document.body).trigger("added.ajaxProduct"), window.theme.cart.getCart().then((function (e) {
                                        window.$(document.body).trigger("updateCart", e)
                                    })))
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    window.theme && window.theme.cart && window.theme.cart.getCart && window.theme.cart.getCart().then((function (t) {
                                        e._updateCartBubble(t), document.dispatchEvent(new CustomEvent("updateCart.ajaxcart", {
                                            detail: {
                                                items: t.items
                                            }
                                        }))
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = document.querySelector(".cart-link__bubble"),
                                        n = e.item_count,
                                        r = "cart-link__bubble--visible";
                                    0 == n ? t.classList.remove(r) : t.classList.add(r);
                                    var a = document.querySelector(".cart-link__count");
                                    a && (a.textContent = n)
                                }
                            }]), e
                        }(),
                        ee = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && e._loadCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    window.Shopify && window.Shopify.updateQuickCart && N.getCart().then(window.Shopify.updateQuickCart)
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartCount)
                                }
                            }, {
                                key: "_updateCartCount",
                                value: function (e) {
                                    var t = b(".cart-icon .count"),
                                        n = e.item_count;
                                    0 === n ? t.addClass("hidden") : t.html(n).removeClass("hidden")
                                }
                            }]), e
                        }(),
                        te = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && e._loadCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    var t = e._getLoadFunction();
                                    t && t()
                                }
                            }, {
                                key: "_getLoadFunction",
                                value: function () {
                                    return window.ajaxCart && window.ajaxCart.load && "function" == typeof window.ajaxCart.load ? window.ajaxCart.load : window.theme.ajaxCart && window.theme.ajaxCart.update && "function" == typeof window.theme.ajaxCart.update ? window.theme.ajaxCart.update : null
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = e.item_count;
                                    $(".cart-link .cart-count").html(t);
                                    var n = $(".cart-link .cart-link__bubble"),
                                        r = "cart-bubble--visible";
                                    0 == t ? n.removeClass(r) : n.addClass(r)
                                }
                            }]), e
                        }(),
                        ne = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t ? e._loadCart() : e._renderCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    e._renderCart(), document.dispatchEvent(new CustomEvent("productAddedToCart"))
                                }
                            }, {
                                key: "_renderCart",
                                value: function () {
                                    window.carts.forEach((function (e) {
                                        e.onCartUpdated()
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = e.item_count;
                                    b(".header__cart-count-bubble span[data-cart-count]").html(t), t > 0 && b(".header__cart-count-bubble").removeClass("hide")
                                }
                            }]), e
                        }(),
                       re = function () {
    function e() {
        t(this, e)
    }
    return r(e, null, [{
        key: "ajaxCart",
        value: function (t) {
            console.log('Warehouse theme - ajaxCart called - success!');
            e._updateCartIcon();
            if (t) {
                e._triggerProductAddedEvent();
            }
        }
    }, {
        key: "_triggerProductAddedEvent",
        value: function () {
            var customEvent = new CustomEvent("product:added", {
                bubbles: !0,
                detail: { quantity: 1 }
            });
            document.documentElement.dispatchEvent(customEvent);
        }
    }, {
        key: "_updateCartIcon",
        value: function () {
            N.getCart().then(e._updateCartBubble);
        }
    }, {
        key: "_updateCartBubble",
        value: function (cartData) {
            var cartCountElement = document.querySelector('.header__cart-count');
            if (cartCountElement) {
                cartCountElement.textContent = cartData.item_count;
            }
        }
    }]), e
}(),
                        ae = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_getThemeInstance",
                                value: function () {
                                    return window.f && "object" == typeof window.f && "function" == typeof window.f.getPopupShoppingCart ? window.f : window.ella && "object" == typeof window.ella && "function" == typeof window.ella.getPopupShoppingCart ? window.ella : null
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b(".header-bottom span.cartCount").html(e.item_count)
                                }
                            }]), e
                        }(),
                        ie = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (e) {}
                            }, {
                                key: "_refreshAjaxCart",
                                value: function () {
                                    N.getCart().then((function (t) {
                                        window.refreshCart(t), e._manualShowAjaxCart()
                                    }))
                                }
                            }, {
                                key: "_manualShowAjaxCart",
                                value: function () {
                                    b("#header").is(":visible") ? b("#header .cart-container, #header .cart_container").addClass("active_link") : b(".sticky_nav--stick").length ? b(".sticky_nav .cart-container, .sticky_nav .cart_container").addClass("active_link") : b(".top-bar .cart-container, .top-bar .cart_container, .top_bar .cart_container").addClass("active_link")
                                }
                            }]), e
                        }();
                    a(ie, "_ajaxCartEnabled", (function () {
                        return window.refreshCart && "function" == typeof window.refreshCart
                    }));
                    var oe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && e._ajaxCartEnabled() && e._showAjaxCart()
                                }
                            }, {
                                key: "_ajaxCartEnabled",
                                value: function () {
                                    return window.ajaxCart && "object" == typeof window.ajaxCart && window.theme && "object" == typeof window.theme && "function" == typeof window.theme.mfpOpen
                                }
                            }, {
                                key: "_showAjaxCart",
                                value: function () {
                                    window.ajaxCart.load(), setTimeout((function () {
                                        window.theme.mfpOpen("cart")
                                    }), 100)
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("span#CartCount").html(e.item_count)
                                }
                            }]), e
                        }(),
                        ue = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && e._ajaxCartEnabled() ? e._refreshAjaxCart() : e._updateAjaxCart()
                                }
                            }, {
                                key: "_ajaxCartEnabled",
                                value: function () {
                                    return window.Shopify.theme.jsAjaxCart && window.Shopify.theme.jsAjaxCart.cart_action && ("drawer" === window.Shopify.theme.jsAjaxCart.cart_action || "mini_cart" === window.Shopify.theme.jsAjaxCart.cart_action) && window.Shopify.theme.jsAjaxCart.showDrawer && "function" == typeof window.Shopify.theme.jsAjaxCart.showDrawer && window.Shopify.theme.jsAjaxCart.updateView && "function" == typeof window.Shopify.theme.jsAjaxCart.updateView
                                }
                            }, {
                                key: "_refreshAjaxCart",
                                value: function () {
                                    Shopify.theme.jsAjaxCart.updateView(), Shopify.theme.jsAjaxCart.showDrawer(), e._showMiniCart()
                                }
                            }, {
                                key: "_updateAjaxCart",
                                value: function () {
                                    window.Shopify.theme.jsAjaxCart && window.Shopify.theme.jsAjaxCart.updateView && Shopify.theme.jsAjaxCart.updateView()
                                }
                            }, {
                                key: "_showMiniCart",
                                value: function () {
                                    b(".header-cart").addClass("show-mini-cart")
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = b("span.header-cart__count--badge");
                                    e.item_count > 0 ? b("div.header-cart").addClass("has-cart-count") : b("div.header-cart").removeClass("has-cart-count"), t.html(e.item_count)
                                }
                            }]), e
                        }(),
                        se = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t, n) {
                                    e._updateCartIcon(), n && e._isDrawerCart() ? e._loadDrawerCartSections(t) : n && e._isCartNotification() && e._loadCartNotificationSections(t)
                                }
                            }, {
                                key: "_isDrawerCart",
                                value: function () {
                                    return !!e._getDrawerCart()
                                }
                            }, {
                                key: "_isCartNotification",
                                value: function () {
                                    return window.customElements && window.customElements.get("cart-notification") && "function" == typeof window.customElements.get("cart-notification")
                                }
                            }, {
                                key: "_getDrawerCart",
                                value: function () {
                                    return document.querySelector("cart-drawer")
                                }
                            }, {
                                key: "_getCartNotification",
                                value: function () {
                                    var e = document.querySelector("cart-notification");
                                    return e || new CartNotification
                                }
                            }, {
                                key: "_getNotificationParams",
                                value: function () {
                                    return "sections=" + e.HEADER_ICON_SECTION + ",cart-notification-product,cart-notification-button"
                                }
                            }, {
                                key: "_getDrawerParams",
                                value: function () {
                                    return "sections=" + e.HEADER_ICON_SECTION + ",cart-drawer"
                                }
                            }, {
                                key: "_loadDrawerCartSections",
                                value: function (t) {
                                    var n = e._getDrawerParams();
                                    w.jsonGetPromise("/", n).then((function (n) {
                                        e._loadDrawer(t, n)
                                    }))
                                }
                            }, {
                                key: "_loadCartNotificationSections",
                                value: function (t) {
                                    var n = e._getNotificationParams();
                                    w.jsonGetPromise("/", n).then((function (n) {
                                        e._loadNotification(t, n)
                                    }))
                                }
                            }, {
                                key: "_loadNotification",
                                value: function (t, n) {
                                    N.getCart().then((function (r) {
                                        var a = N.findLastAddedProduct(r, t);
                                        e._getCartNotification().renderContents({
                                            id: t,
                                            key: a.key,
                                            sections: n
                                        })
                                    }))
                                }
                            }, {
                                key: "_loadDrawer",
                                value: function (t, n) {
                                    N.getCart().then((function (r) {
                                        var a = N.findLastAddedProduct(r, t),
                                            i = e._getDrawerCart();
                                        i.classList.remove("is-empty"), i.renderContents({
                                            id: t,
                                            key: a.key,
                                            sections: n
                                        })
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = b("#cart-icon-bubble .cart-count-bubble span");
                                    0 === b("#cart-icon-bubble .cart-count-bubble").length && b("#cart-icon-bubble").append(b('<div class="cart-count-bubble"><span aria-hidden="true">0</span><span class="visually-hidden">0 items</span></div>')), t.html(e.item_count), b("#cart-icon-bubble .cart-count-bubble span.visually-hidden").html(e.item_count + "items")
                                }
                            }]), e
                        }();
                    a(se, "HEADER_ICON_SECTION", "cart-icon-bubble");
                    var ce = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t, n) {
                                    n && e._hasAddedCallback() && e._fireAddedCallback(t)
                                }
                            }, {
                                key: "_hasAddedCallback",
                                value: function () {
                                    return window.Shopify.onItemAdded && "function" == typeof window.Shopify.onItemAdded
                                }
                            }, {
                                key: "_fireAddedCallback",
                                value: function (e) {
                                    N.getCart().then((function (t) {
                                        var n = N.findLastAddedProduct(t, e);
                                        window.Shopify.onItemAdded(n)
                                    }))
                                }
                            }]), e
                        }(),
                        le = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && e._isDrawerCart() && e._showDrawer()
                                }
                            }, {
                                key: "_isDrawerCart",
                                value: function () {
                                    return e._is2xVersion() || e._is5xVersion() || e._isNewVersion()
                                }
                            }, {
                                key: "_is2xVersion",
                                value: function () {
                                    return window.addToCartSuccessCallback && "function" == typeof window.addToCartSuccessCallback
                                }
                            }, {
                                key: "_is5xVersion",
                                value: function () {
                                    return window.theme && window.theme.partials && window.theme.partials.cart && window.theme.partials.cart.recentCartItemPopUp && "function" == typeof window.theme.partials.cart.recentCartItemPopUp
                                }
                            }, {
                                key: "_isNewVersion",
                                value: function () {
                                    return window.theme && window.theme.partials && window.theme.partials.Cart && window.theme.partials.Cart.updateAllHtml && "function" == typeof window.theme.partials.Cart.updateAllHtml && window.theme.partials.Product && window.theme.partials.Product.addProductComplete && "function" == typeof window.theme.partials.Product.addProductComplete
                                }
                            }, {
                                key: "_showDrawer",
                                value: function () {
                                    e._is2xVersion() ? window.addToCartSuccessCallback() : e._is5xVersion() ? window.theme.partials.cart.recentCartItemPopUp() : e._isNewVersion() && window.theme.partials.Cart.updateAllHtml((function () {
                                        window.theme.partials.Product.addProductComplete()
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("span.cart--external--total-items").html(e.item_count), b(".header--cart-link .number-wrapper").attr("data-item-count", e.item_count), b(".header--cart-link .number-wrapper").attr("style", ""), b("span.header--cart-number").attr("data-item-count", e.item_count)
                                }
                            }]), e
                        }(),
                        de = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && (e._isNewVersion() || e._isOldVersion()) && e._loadCart()
                                }
                            }, {
                                key: "_isNewVersion",
                                value: function () {
                                    var t = e._findConfig();
                                    return !!t && (e._isDrawerCart(t) || e._isModalCart(t))
                                }
                            }, {
                                key: "_findConfig",
                                value: function () {
                                    var e = document.getElementById("cart-config");
                                    return e ? JSON.parse(e.innerHTML) : null
                                }
                            }, {
                                key: "_isDrawerCart",
                                value: function (e) {
                                    return "drawer" === e.cart_action
                                }
                            }, {
                                key: "_isModalCart",
                                value: function (e) {
                                    return "modal_cart" === e.cart_action
                                }
                            }, {
                                key: "_isOldVersion",
                                value: function () {
                                    return window.ajaxCart && window.ajaxCart.load && "function" == typeof window.ajaxCart.load
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    e._isNewVersion() ? e._showNewVersion() : e._isOldVersion() && window.ajaxCart.load()
                                }
                            }, {
                                key: "_showNewVersion",
                                value: function () {
                                    N.getCart().then((function (t) {
                                        var n = e._findConfig();
                                        window.Shopify.theme.ajaxCart.updateView(n, t), e._isDrawerCart(n) ? window.Shopify.theme.ajaxCart.showDrawer(n) : e._isModalCart(n) && window.Shopify.theme.ajaxCart.showModal(n)
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("span.js-cart-count").html(e.item_count)
                                }
                            }]), e
                        }(),
                        fe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && e._isDrawerCart() && e._loadCart()
                                }
                            }, {
                                key: "_isDrawerCart",
                                value: function () {
                                    return window.ajaxifyShopify && window.ajaxifyShopify.cartUpdateCallback && "function" == typeof window.ajaxifyShopify.cartUpdateCallback
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    N.getCart().then((function (e) {
                                        window.ajaxifyShopify.cartUpdateCallback(e)
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = b("span.cart-count");
                                    e.item_count > 0 ? b("span.hidden-count").removeClass("hidden-count") : b("span.hidden-count").addClass("hidden-count"), t.html(e.item_count)
                                }
                            }]), e
                        }(),
                        pe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t, n) {
                                    e._updateCartIcon(), t && e._isAjaxCart() && e._loadAjaxCart(n)
                                }
                            }, {
                                key: "_isAjaxCart",
                                value: function () {
                                    var t = e._isOldVersion(),
                                        n = e._isNewVersion();
                                    return t || n
                                }
                            }, {
                                key: "_isOldVersion",
                                value: function () {
                                    return window.addToCartOkay && "function" == typeof window.addToCartOkay
                                }
                            }, {
                                key: "_isNewVersion",
                                value: function () {
                                    return window.cart && window.cart.getCart && "function" == typeof window.cart.getCart && window.cart.openCartDropdown && "function" == typeof window.cart.openCartDropdown
                                }
                            }, {
                                key: "_loadOldNotification",
                                value: function (e) {
                                    N.getCart().then((function (t) {
                                        var n = N.findLastAddedProduct(t, e);
                                        window.addToCartOkay(n)
                                    }))
                                }
                            }, {
                                key: "_loadAjaxCart",
                                value: function (t) {
                                    e._isOldVersion() ? e._loadOldNotification(t) : e._isNewVersion() && (window.cart.getCart(), window.cart.openCartDropdown())
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = b("span.header__cart__status");
                                    t.html(e.item_count), t.attr("data-header-cart-count", e.item_count)
                                }
                            }]), e
                        }(),
                         MavonCart = function () {
    function e() {
        // Empty constructor
    }

    // Main method for your switch statement
    e.ajaxCart = function (variantId, quantity, showCart) {
        // Just update the cart icon - no drawer functionality
        e._updateCartIcon();
    };
    
    // Update cart icon with current count
    e._updateCartIcon = function() {
        fetch('/cart.js?t=' + Date.now())
            .then(response => response.json())
            .then(cart => {
                var itemCount = cart.item_count;
                
                // Update the visible count number
                var countElement = document.getElementById('cart-notification-count');
                if (countElement) {
                    countElement.textContent = itemCount;
                }
                
                // Update the visually hidden text for accessibility
                var hiddenText = countElement?.nextElementSibling;
                if (hiddenText && hiddenText.classList.contains('visually-hidden')) {
                    hiddenText.textContent = itemCount + ' items';
                }
                
                // Show/hide the bubble based on count
                var countBubble = document.querySelector('.cart-count-bubble');
                if (countBubble) {
                    if (itemCount > 0) {
                        countBubble.style.display = '';
                        countBubble.classList.remove('hide');
                    } else {
                        countBubble.style.display = 'none';
                        countBubble.classList.add('hide');
                    }
                }
            })
            .catch(error => {
                console.error("Error updating cart icon:", error);
            });
    };

    return e;
}(),


                        he = function () {
    function e() {
        t(this, e)
    }
    
    // Store a reference to the class
    var self = e;
    
    // Track last known cart state
    var lastKnownItemCount = 0;
    
    return r(e, null, [{
        key: "ajaxCart",
        value: function (t, n) {
            e._updateCartIcon(), t ? e._triggerAjaxCart(n) : e._updateCart()
        }
    }, {
        key: "_triggerAjaxCart",
        value: function (e) {
            // Store a reference to the fetchCartDrawerContent method
            var fetchCart = this._fetchCartDrawerContent;
            
            N.getCart().then(function (t) {
                var n = N.findLastAddedProduct(t, e);
                var isFirstItem = lastKnownItemCount === 0 && t.item_count > 0;
                
                // Update tracking
                lastKnownItemCount = t.item_count;
                
                // Call the function directly using the stored reference
                fetchCart();
                
                // Then dispatch the event
                document.dispatchEvent(new CustomEvent("theme:cart:popdown", {
                    detail: {
                        variant: n,
                        cart: t
                    },
                    bubbles: true
                }));
                
                // Force trigger the drawer manually if event listener fails
                setTimeout(function() {
                    // Try to find any drawer elements
                    var drawer = document.querySelector('.drawer-cart, .cart-drawer, [data-drawer="cart"]');
                    if (drawer && typeof drawer.classList !== 'undefined') {
                        drawer.classList.add('is-active', 'is-visible', 'drawer--is-open');
                    }
                    
                    // If this was the first item added to cart, do a page refresh
                    // but only after showing the drawer briefly
                    if (isFirstItem) {
                        setTimeout(function() {
                            window.location.reload();
                        }, 1000);
                    }
                }, 100);
            })
        }
    }, {
        key: "_updateCartIcon",
        value: function () {
            N.getCart().then(function(cart) {
                // Update tracking
                lastKnownItemCount = cart.item_count;
                // Call original method
                e._updateCartBubble(cart);
            });
        }
    }, {
        key: "_updateCartBubble",
        value: function (e) {
            b("span[data-header-cart-count]").html("(" + e.item_count + ")");
            var t = b("span[data-header-cart-price]"),
                n = window.theme.Currency && window.theme.Currency.formatMoney ? window.theme.Currency.formatMoney(e.total_price, window.theme.moneyFormat) : e.total_price;
            t.html(n)
        }
    }, {
        key: "_updateCart",
        value: function () {
            // Store a reference to the fetchCartDrawerContent method
            var fetchCart = this._fetchCartDrawerContent;
            
            N.getCart().then(function (t) {
                // Update tracking
                lastKnownItemCount = t.item_count;
                
                // Call the function directly using the stored reference
                fetchCart();
                
                document.dispatchEvent(new CustomEvent("theme:cart:change", {
                    detail: {
                        cart: t
                    },
                    bubbles: true
                }))
            })
        }
    }, {
        key: "_fetchCartDrawerContent",
        value: function () {
            // Try multiple template views that might exist in the theme
            var viewUrl = '/cart?view=drawer';
            
            // First try with a specific drawer view
            fetch(viewUrl, {
                credentials: 'same-origin',
                method: 'GET'
            })
            .then(function(response) {
                if (!response.ok) {
                    // If drawer view doesn't exist, try ajaxcart view
                    viewUrl = '/cart?view=ajaxcart';
                    return fetch(viewUrl, {
                        credentials: 'same-origin',
                        method: 'GET'
                    });
                }
                return response;
            })
            .then(function(response) {
                if (!response.ok) {
                    // If ajaxcart view doesn't exist, try normal cart
                    viewUrl = '/cart';
                    return fetch(viewUrl, {
                        credentials: 'same-origin',
                        method: 'GET'
                    });
                }
                return response;
            })
            .then(function(response) {
                return response.text();
            })
            .then(function(html) {
                // Find cart drawer content areas - expanded selector list for Pipeline theme
                var cartDrawerContent = document.querySelector('.drawer__inner-cart, .drawer-cart__content, .cart-drawer__content, .cart__items, .ajaxcart__inner, #CartContainer, .cart-drawer, #CartDrawer .drawer__inner, .drawer__contents');
                
                if (!cartDrawerContent) {
                    // Try finding the drawer first, then look for content inside
                    var drawer = document.querySelector('.drawer-cart, .cart-drawer, #CartDrawer, [data-section-id="cart-drawer"]');
                    if (drawer) {
                        cartDrawerContent = drawer.querySelector('.drawer__inner, .drawer__contents, .ajaxcart__inner, .cart__items');
                    }
                    
                    if (!cartDrawerContent) {
                        console.warn('Cart drawer content element not found - trying more generic approach');
                        // Last resort - get any element that looks like it might be the cart drawer
                        cartDrawerContent = document.querySelector('[id*="cart" i], [class*="cart" i]');
                    }
                    
                    if (!cartDrawerContent) {
                        console.warn('Cart drawer content element not found - cannot update cart contents');
                        return;
                    }
                }
                
                // Some themes may wrap the response in additional elements
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                
                // Try different selector combinations to find the cart content in the response
                var cartContent = tempDiv.querySelector('.drawer__inner-cart, .drawer-cart__content, .cart-drawer__content, .cart__items, .ajaxcart__inner, #CartContainer');
                
                if (cartContent) {
                    cartDrawerContent.innerHTML = cartContent.innerHTML;
                } else {
                    // If we can't find a specific cart content section, look for items
                    var cartItems = tempDiv.querySelectorAll('.cart__item, .ajaxcart__product, .cart-item, .line-item');
                    
                    if (cartItems && cartItems.length > 0) {
                        // We found cart items, let's use the parent element
                        var parent = cartItems[0].parentElement;
                        while (parent && parent !== tempDiv && !parent.classList.contains('cart__items') && !parent.classList.contains('ajaxcart__inner')) {
                            parent = parent.parentElement;
                        }
                        
                        if (parent && parent !== tempDiv) {
                            cartDrawerContent.innerHTML = parent.innerHTML;
                        } else {
                            // Just use the items directly
                            cartDrawerContent.innerHTML = '';
                            cartItems.forEach(function(item) {
                                cartDrawerContent.appendChild(item.cloneNode(true));
                            });
                        }
                    } else {
                        // Otherwise just use the whole response
                        cartDrawerContent.innerHTML = html;
                    }
                }
                
                // Re-initialize any quantity selectors or other interactive elements
                // Try multiple possible cart initialization functions
                if (typeof theme !== 'undefined') {
                    // Pipeline theme might use various function names
                    if (theme.cartDrawer && typeof theme.cartDrawer.init === 'function') {
                        theme.cartDrawer.init();
                    }
                    if (theme.ajaxCart && typeof theme.ajaxCart.init === 'function') {
                        theme.ajaxCart.init();
                    }
                    if (theme.cart && typeof theme.cart.init === 'function') {
                        theme.cart.init();
                    }
                }
                
                // Force refresh the cart totals
                N.getCart().then(function(cart) {
                    // Try to update the cart totals everywhere they might appear
                    var totalElements = document.querySelectorAll('.cart__total, .ajaxcart__total, .cart-total, .cart-subtotal__price');
                    if (totalElements.length > 0) {
                        var totalFormatted = window.theme.Currency && window.theme.Currency.formatMoney ? 
                            window.theme.Currency.formatMoney(cart.total_price, window.theme.moneyFormat) : 
                            cart.total_price;
                        
                        totalElements.forEach(function(el) {
                            el.textContent = totalFormatted;
                        });
                    }
                });
            })
            .catch(function(error) {
                console.error('Error updating cart contents:', error);
            });
        }
    }]), e
}(),
                        ve = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    t ? e._showDrawer() : e._updateCart()
                                }
                            }, {
                                key: "_showDrawer",
                                value: function () {
                                    window.wetheme && window.wetheme.toggleRightDrawer && N.getCart().then((function (e) {
                                        return window.wetheme.toggleRightDrawer("cart", !0, {
                                            cart: e
                                        })
                                    }))
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    window.wetheme && window.wetheme.updateCartDrawer && N.getCart().then((function (e) {
                                        return window.wetheme.updateCartDrawer(e)
                                    }))
                                }
                            }]), e
                        }(),
                        ye = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "debug",
                                value: function (t) {
                                    e.DEBUG && e.log(t)
                                }
                            }, {
                                key: "log",
                                value: function (e) {
                                    try {
                                        console.log(e)
                                    } catch (e) {}
                                }
                            }, {
                                key: "enableDebug",
                                value: function () {
                                    e.DEBUG = !0
                                }
                            }, {
                                key: "disableDebug",
                                value: function () {
                                    e.DEBUG = !1
                                }
                            }]), e
                        }();
                    a(ye, "DEBUG", !1);
                    var me = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCart(), t && e._loadCart()
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    window.Avatar && window.Avatar.theme && window.Avatar.theme.sections && window.Avatar.theme.sections.SliderCart && window.Avatar.theme.sections.SliderCart.instance && window.Avatar.theme.sections.SliderCart.instance.refreshCartSlider && window.Avatar.theme.sections.SliderCart.instance.refreshCartSlider()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    window.Avatar && window.Avatar.theme && window.Avatar.theme.sections && window.Avatar.theme.sections.SliderCart && window.Avatar.theme.sections.SliderCart.instance && window.Avatar.theme.sections.SliderCart.instance.openSliderCart && window.Avatar.theme.sections.SliderCart.instance.openSliderCart()
                                }
                            }]), e
                        }(),
                        ge = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && e._loadCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    b(".icon-cart").length > 0 && b(".icon-cart")[0].click()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    if (b("header a.icon-cart span.cart_count").length > 0) {
                                        var t = e.items.length;
                                        b("header a.icon-cart span.cart_count").html(t)
                                    }
                                }
                            }]), e
                        }(),
                        _e = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t && e._loadCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    window.ajaxCart && window.ajaxCart.load && window.ajaxCart.load()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b(".num-items-in-cart .number").html(e.item_count)
                                }
                            }]), e
                        }(),
                        Ce = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    t ? e._loadCart() : e._updateCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    window.$ && window.$.magnificPopup && Shopify.loadQuickCart && N.getCart().then((function (e) {
                                        Shopify.loadQuickCart(e), window.$.magnificPopup.close()
                                    }))
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    Shopify.loadQuickCart && N.getCart().then((function (e) {
                                        Shopify.loadQuickCart(e)
                                    }))
                                }
                            }]), e
                        }(),
                        be = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t ? e._loadCart() : e._updateCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    setTimeout((function () {
                                        return window.$("a.icon-cart.cart-button").click()
                                    }), 300)
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    window.refreshCart && N.getCart().then((function (e) {
                                        return window.refreshCart(e)
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b(".cart .icon-cart > span").html(e.item_count)
                                }
                            }]), e
                        }(),
                        we = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t, n) {
                                    e._updateCartIcon(), n && e._loadCart(t)
                                }
                            }, {
                                key: "_loadCart",
                                value: function (e) {
                                    window.theme && window.theme.Nav && window.theme.Shopify && window.theme.Shopify.formatImage && window.showThemeModal && N.getCart().then((function (t) {
                                        var n = N.findLastAddedProduct(t, e),
                                            r = "inline" !== window.theme.Nav().bar.getPositionSetting() ? window.theme.Nav().bar.height() : 25,
                                            a = window.theme.Shopify.formatImage(n.image, "300x");
                                        window.showThemeModal(['<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">', '<div class="inner" style="top:'.concat(r, 'px">'), '<a href="#" data-modal-close class="modal-close">×</a>', '<h4 id="added-to-cart-title">' + window.theme.icons.tick + window.theme.strings.productAddedToCart + "</h4>", '<div class="cart-product">', '<div class="cart-product__image"><img src="'.concat(a, '" alt="').concat(n.featured_image.alt, '"/></div>'), '<div class="cart-product__content"><p class="cart-product__content__title">', n.product_title, "</p>" + "".concat("") + "</div>", "</div>", '<p class="links '.concat("", '">'), '<a href="' + window.theme.routes.cart_url + '" class="button '.concat("alt", '">') + window.theme.strings.viewCart + "</a>", '<a href="' + window.theme.routes.checkout + '" class="button button--checkout" [data-cc-checkout-button]>' + window.theme.strings.popupCheckout + "</a> ", "</p>", "</div>", "</div>"].join(""), null, null, !1, !0)
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("a.cart-icon--basket1 > div").html(e.item_count), b("div.nav-right-side a.cart div").html(e.item_count)
                                }
                            }]), e
                        }(),
                        ke = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    t ? e._loadCart() : e._updateCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    if (window.theme && window.theme.CartDrawer && window.theme.CartDrawer.prototype.buildCart) {
                                        var e = new window.theme.CartDrawer;
                                        N.getCart().then((function (t) {
                                            return e.buildCart(t, !0)
                                        }))
                                    }
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    if (window.theme && window.theme.CartDrawer && window.theme.CartDrawer.prototype.buildCart) {
                                        var e = new window.theme.CartDrawer;
                                        N.getCart().then((function (t) {
                                            return e.buildCart(t, !1)
                                        }))
                                    }
                                }
                            }]), e
                        }(),
                        Se = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t ? e._loadCart() : e._updateCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    window.$ && window.$("#cartTotal").click()
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    window.Cart && window.Cart.getCart && window.Cart.buildCart && window.Cart.getCart(window.Cart.buildCart)
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    e.item_count > 0 && b(".header-icons .cartToggle--empty .icon-cart path:last-child").css("opacity", 1)
                                }
                            }]), e
                        }(),
                        xe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = e.item_count;
                                    b("a.sidebar__cart-handle>span.count").html(t)
                                }
                            }]), e
                        }(),
                        Te = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = e.item_count;
                                    b(".header-cart__count").html(t)
                                }
                            }]), e
                        }(),
                        Ae = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b(".cartsummary__inner span.numitems").length > 0 && b(".cartsummary__inner span.numitems").html("(" + e.item_count + ")")
                                }
                            }]), e
                        }(),
                        Ee = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    e.item_count > 0 && b("span.header-cart-count").addClass("active")
                                }
                            }]), e
                        }(),
                        Pe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    e.item_count > 0 && (b(".cart-page-link .cart-count").removeClass("hidden-count"), b(".cart-page-link .cart-count").html(e.item_count))
                                }
                            }]), e
                        }(),
                        Ie = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    e.item_count > 0 && (b("a.cart span.item-count").removeClass("empty"), b("a.cart span.item-count").html(e.item_count))
                                }
                            }]), e
                        }(),
                        Oe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("a.cart_button span.cart_count").html(e.item_count)
                                }
                            }]), e
                        }(),
                        De = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("div.header__cart-count span").html(e.item_count)
                                }
                            }]), e
                        }(),
                        Be = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("span.enj-cartcount").html(e.item_count)
                                }
                            }]), e
                        }(),
                        je = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("div.cart-info a em").html(e.item_count)
                                }
                            }]), e
                        }(),
                        Le = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    b("a.cart-count .beside-svg").length > 0 ? N.getCart().then(e._updateCartBubble) : N.getCart().then(e._updateNewCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("a.cart-count .beside-svg").length > 0 && (b("a.cart-count .beside-svg").html("(" + e.item_count + ")"), b("a.cart-count .cart-count__text").html("(" + e.item_count + ")"))
                                }
                            }, {
                                key: "_updateNewCartBubble",
                                value: function (e) {
                                    if (b(".cart-link__count").length > 0) b(".cart-link__count").html(e.item_count);
                                    else {
                                        var t = b('<span class="cart-link__count">' + e.item_count + "</span>");
                                        b(".cart-link__icon").append(t)
                                    }
                                }
                            }]), e
                        }(),
                        Ne = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function () {
                                    e._updateCartIcon()
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("span.cartCountSelector").html(e.item_count), window.theme && window.Shopify && window.Shopify.formatMoney && window.theme.moneyFormat && b(".cartTotalSelector").html(window.Shopify.formatMoney(e.total_price, window.theme.moneyFormat))
                                }
                            }]), e
                        }(),
                        Re = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), t ? e._loadCart() : e._updateCart()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    fetch("?section_id=cart-helper").then((function (e) {
                                        return e.text()
                                    })).then((function (e) {
                                        var t = (new DOMParser).parseFromString(e, "text/html"),
                                            n = t.getElementById("AjaxCartForm").innerHTML,
                                            r = t.getElementById("AjaxCartSubtotal").innerHTML,
                                            a = document.getElementById("AjaxCartForm");
                                        a.innerHTML = n, a.ajaxifyCartItems(), document.getElementById("AjaxCartSubtotal").innerHTML = r, window.preloadImages(a), document.querySelector("[data-header-cart-count]").textContent = document.querySelector("#AjaxCartForm [data-cart-count]").textContent;
                                        var i = document.getElementById("site-cart");
                                        document.getElementById("site-cart-handle").setAttribute("aria-expanded", "true"), i.show()
                                    }))
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    fetch("?section_id=cart-helper").then((function (e) {
                                        return e.text()
                                    })).then((function (e) {
                                        var t = (new DOMParser).parseFromString(e, "text/html"),
                                            n = t.getElementById("AjaxCartForm").innerHTML,
                                            r = t.getElementById("AjaxCartSubtotal").innerHTML,
                                            a = document.getElementById("AjaxCartForm");
                                        a.innerHTML = n, a.ajaxifyCartItems(), document.getElementById("AjaxCartSubtotal").innerHTML = r, window.preloadImages(a), document.querySelector("[data-header-cart-count]").textContent = document.querySelector("#AjaxCartForm [data-cart-count]").textContent
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    b("span [data-header-cart-count]").html(e.item_count)
                                }
                            }]), e
                        }(),
                        Fe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    e._updateCartIcon(), e._updateCart(), t && e._loadCart()
                                }
                            }, {
                                key: "_isCompatibleVersion",
                                value: function () {
                                    return window.theme && window.theme.partials && window.theme.partials.Cart && window.theme.partials.Cart
                                }
                            }, {
                                key: "_updateCart",
                                value: function () {
                                    e._isCompatibleVersion() && "function" == typeof window.theme.partials.Cart.updateTotals && window.theme.partials.Cart.updateTotals()
                                }
                            }, {
                                key: "_loadCart",
                                value: function () {
                                    var t = this;
                                    e._isCompatibleVersion() && "function" == typeof window.theme.partials.Cart.updateAllHtml && window.theme.partials.Cart.updateAllHtml((function () {
                                        window.theme.partials.OffCanvas.right_sidebar.attr("data-active", "cart"), "closed" === window.theme.partials.OffCanvas.state && (window.theme.partials.OffCanvas.right_sidebar_view = "cart", window.theme.partials.OffCanvas.openRight(), window.theme.partials.OffCanvas.last_trigger = t.primary_button)
                                    }))
                                }
                            }, {
                                key: "_updateCartIcon",
                                value: function () {
                                    N.getCart().then(e._updateCartBubble)
                                }
                            }, {
                                key: "_updateCartBubble",
                                value: function (e) {
                                    var t = e.item_count;
                                    b(".header--cart-number").setAttribute("data-item-count", t), b(".header--cart-number .cart--external--total-items").html("(" + t + ")")
                                }
                            }]), e
                        }(),
                        qe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (e) {
                                    theme && theme.updateCartSummaries && theme.updateCartSummaries(e, !0, void 0)
                                }
                            }]), e
                        }(),
                        Ue = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "afterAddingToCart",
                                value: function (e, t, n) {
                                    window.CLEVER && window.CLEVER.afterAddingToCart && window.CLEVER.afterAddingToCart(e, t, n)
                                }
                            }, {
                                key: "ajaxCart",
                                value: function (t, n, r, a) {
                                    var i = e._normalizeTheme(t);
                                    e._triggerAjaxCart(i, a, n, r)
                                }
                            }, {
                                key: "_triggerAjaxCart",
                                value: function (t, n, r, a) {
                                    try {
                                        switch (t) {
                                            case "avatar":
                                                me.ajaxCart(n);
                                                break;
                                            case "avenue":
                                                Ne.ajaxCart(n);
                                                break;
                                            case "debut":
                                                R.ajaxCart(r, a, n);
                                                break;
                                            case "unsen":  UnsenHandler.ajaxCart(n); break;
                                                case "mavon":
    MavonCart.ajaxCart(r, a, n);
    break;
                                            case "brooklyn":
                                                F.ajaxCart(n);
                                                break;
                                            case "boundless":
                                                q.ajaxCart(n);
                                                break;
                                           
                                            case "envy":
                                                U.ajaxCart(n);
                                                break;
                                            case "fastlane":
                                                V.ajaxCart(r, a, n);
                                                break;
                                            case "venture":
                                                H.ajaxCart(n);
                                                break;
                                            case "simple":
                                                M.ajaxCart();
                                                break;
                                            case "narrative":
                                                W.ajaxCart(n);
                                                break;
                                            case "supply":
                                                z.ajaxCart(n);
                                                break;
                                            case "split":
                                                Re.ajaxCart(n);
                                                break;
                                            case "prestige":
                                                G.ajaxCart(n);
                                                break;
                                            case "booster":
                                                Q.ajaxCart();
                                                break;
                                            case "shoptimized":
                                                Y.ajaxCart(n);
                                                break;
                                            case "empire":
                                                X.ajaxCart();
                                                break;
                                            case "district":
                                                K.ajaxCart(r, n);
                                                break;
                                            case "gecko":
                                            case "kalles":
                                                Jae.ajaxCart(n);
                                                break;
                                            case "impulse":
                                            case "motion":
                                            case "streamline":
                                            case "expanse":
                                                Z.ajaxCart(n);
                                                    document.dispatchEvent(new CustomEvent("xboost-need-refresh-and-open-cart"));

                                                break;
                                            case "showtime":
                                                ee.ajaxCart(n);
                                                break;
                                            case "debutify":
                                                te.ajaxCart(n);
                                                break;
                                            case "express":
                                                ne.ajaxCart(n);
                                                break;
                                            case "warehouse":
                                                re.ajaxCart(n);
                                                break;
                                            case "ella":
                                                ae.ajaxCart(n);
                                                break;
                                            case "turbo":
                                                ie.ajaxCart(n);
                                                break;
                                            case "venue":
                                                oe.ajaxCart(n);
                                                break;
                                            case "flex":
                                                ue.ajaxCart(n);
                                                break;
                                            case "dawn":
                                            case "crave":
                                            case "sense":
                                            case "craft":
                                            case "taste":
                                            case "studio":
                                            case "ride":
                                            case "colorblock":
                                            case "refresh":
                                                case "trade":
                                                se.ajaxCart(r, n);
                                                break;
                                            case "wokiee":
                                                ce.ajaxCart(r, n);
                                                break;
                                            case "blockshop":
                                                le.ajaxCart(n);
                                                break;
                                            case "icon":
                                            case "testament":
                                                de.ajaxCart(n);
                                                break;
                                            case "speedfly theme":
                                                fe.ajaxCart(n);
                                                break;
                                            case "broadcast":
                                                pe.ajaxCart(n, r);
                                                break;
                                            case "pipeline":
                                                he.ajaxCart(n, r);
                                                break;
                                            case "flow":
                                                ve.ajaxCart(n);
                                                break;
                                            case "exotic":
                                                ge.ajaxCart(n);
                                                break;
                                            case "galleria":
                                                Ce.ajaxCart(n);
                                                break;
                                            case "oars":
                                                _e.ajaxCart(n);
                                                break;
                                            case "parallax":
                                                be.ajaxCart(n);
                                                break;
                                            case "showcase":
                                                we.ajaxCart(r, n);
                                                break;
                                            case "wonify":
                                                ke.ajaxCart(n);
                                                break;
                                            case "modular":
                                                Se.ajaxCart(n);
                                                break;
                                            case "boost":
                                                Te.ajaxCart();
                                                break;
                                            case "kingdom":
                                                xe.ajaxCart();
                                                break;
                                            case "launch":
                                                Ee.ajaxCart();
                                                break;
                                            case "mansory":
                                                Ae.ajaxCart();
                                                break;
                                            case "minimal":
                                                Pe.ajaxCart();
                                                break;
                                            case "providence":
                                                Ie.ajaxCart();
                                                break;
                                            case "responsive":
                                                Oe.ajaxCart();
                                                break;
                                            case "spark":
                                                De.ajaxCart();
                                                break;
                                            case "sunmi":
                                                Be.ajaxCart();
                                                break;
                                            case "sunrise":
                                                je.ajaxCart();
                                                break;
                                            case "symmetry":
                                                Le.ajaxCart();
                                                break;
                                            case "maker":
                                                Fe.ajaxCart(n);
                                                break;
                                                case "palo alto":
                                                    if(window.opusOpen) {
                                            window.opusOpen();
                                            }
                                           
                                            e._paloAltoCart(r, n);
                                            break;
                                        case "canopy":
                                            e._canopyCart(r, n);
                                            break;
                                             case "mandolin":
                                            e._mandolinCart(r, n);
                                            break;
                                        case "starlite":
                                            e._starliteCart(r, n);
                                            break;
                                             case "capital":
                                            e._capitalCart(r, n);
                                            break;

                                            default:
                                                e._otherAjaxCarts()
                                        }
                                    } catch (e) {
                                        ye.log("Failed to display the Ajax cart in " + t + " (Error:" + e.message + ").")
                                    }
                                }
                            },
                            {
    key: "_capitalCart",
    value: function(variantId, showDrawer) {
        // Get the cart data
        N.getCart().then(function(cartData) {
            console.log("Capital cart update - items count:", cartData.item_count);
            
            // Update cart count in Capital theme selectors
            b("[data-header-cart-count]").text(cartData.item_count);
            b(".slide-menu-cart .cart-count").text(cartData.item_count);
            b("[data-cart-count]").text(cartData.item_count);
            
            // Show/hide cart count based on items
            if (cartData.item_count > 0) {
                b("[data-header-cart-count]").removeClass("hidden");
                b(".slide-menu-cart").addClass("has-items");
            }
            
            // Handle cart drawer update using Capital's RightDrawer system
            if (window.wetheme && window.wetheme.drawer) {
                // Use Capital's built-in drawer system
                window.wetheme.drawer.updateCartDrawer(cartData);
                
                // Open drawer if requested
                if (showDrawer) {
                    // Use Capital's toggle method with cart data
                    window.wetheme.drawer._toggleRightDrawer("cart", true, { cart: cartData });
                }
            } else {
                // Fallback method - trigger cart update event
                var cartEvent = new CustomEvent("wetheme-cart-update", {
                    bubbles: true,
                    detail: { cart: cartData }
                });
                document.dispatchEvent(cartEvent);
                
                // Try to find and click cart drawer trigger if we need to show drawer
                if (showDrawer) {
                    var cartDrawerTrigger = document.querySelector(".slide-menu-cart");
                    if (cartDrawerTrigger) {
                        cartDrawerTrigger.click();
                    }
                }
            }
            
            // Update cart total if elements exist
            var cartTotal = cartData.total_price;
            if (cartTotal) {
                var formattedTotal = "$" + (cartTotal/100).toFixed(2);
                b(".cart-total-price").text(formattedTotal);
                b("[data-cart-total]").text(formattedTotal);
            }
        });
    }
}
                            ,
                            {
    key: "_starliteCart",
    value: function(variantId, showDrawer) {
        // Store this for use in callbacks
        var self = this;

        // Define helper functions to work specifically with Starlite cart
        function updateStarliteCartVisibility(cartData) {
            // Update cart counters
            let cartCountSelectors = document.querySelectorAll("[data-header-cart-count]");
            const cartWrapper = document.querySelector("[data-cart-wrapper]");
            
            if (cartWrapper) {
                cartWrapper.setAttribute("data-item-count", cartData.item_count);
                
                // Update all cart count indicators
                Array.from(cartCountSelectors).forEach(function(cartCountSelector) {
                    if (cartData.item_count > 0) {
                        if (cartData.item_count > 99) {
                            cartCountSelector.textContent = "";
                            const cartLink = cartCountSelector.closest(".cart.header-icons-link");
                            if (cartLink) cartLink.classList.add("dot-icon");
                        } else {
                            cartCountSelector.textContent = cartData.item_count;
                            const cartLink = cartCountSelector.closest(".cart.header-icons-link");
                            if (cartLink) cartLink.classList.remove("dot-icon");
                        }
                        cartCountSelector.classList.remove("hidden");
                    } else {
                        cartCountSelector.textContent = "";
                        cartCountSelector.classList.add("hidden");
                    }
                });
                
                // Update cart item count text
                const cartItemCountElement = document.querySelector("[data-cart-item-count]");
                if (cartItemCountElement && cartData.item_count > 0) {
                    cartItemCountElement.innerHTML = cartData.item_count === 1 ? 
                        `${cartData.item_count} artículo` : 
                        `${cartData.item_count} artículos`;
                }
                
                // Update cart price if elements exist
                const cartTotalPriceElement = document.querySelector("[data-header-cart-total]");
                if (cartTotalPriceElement && cartData.item_count > 0) {
                    const cartPriceElement = document.querySelector("[data-cart-prices] [data-cart-final-price]");
                    if (cartPriceElement) {
                        const cartPrice = cartPriceElement.textContent;
                        cartWrapper.setAttribute("data-item-total", cartPrice);
                        cartTotalPriceElement.textContent = cartPrice;
                        cartTotalPriceElement.classList.remove("hidden");
                    }
                } else if (cartTotalPriceElement) {
                    cartTotalPriceElement.textContent = "";
                    cartTotalPriceElement.classList.add("hidden");
                }
            }
        }

        function forceStarliteCartRefresh(cartData, showDrawer) {
            // Get the section ID for cart rendering
            let sectionId = "ajax-cart-drawer";
            let section = "";
            var baseUrl = window.location.pathname;
            
            if (baseUrl.indexOf("/cart") > -1) {
                let cartSection = document.querySelector("[data-cart-wrapper]");
                section = cartSection;
                if (cartSection) {
                    sectionId = cartSection.dataset.section;
                }
            }

            // Fetch the updated cart HTML
            fetch(`/cart?section_id=${sectionId}`)
                .then(response => response.text())
                .then(html => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, 'text/html');
                    let updatedSection = doc.querySelector(".shopify-section");
                    
                    if (updatedSection) {
                        if (baseUrl.indexOf("/cart") > -1) {
                            // We're on the cart page
                            let updatedCartContent = updatedSection.querySelector("[data-cart-wrapper]");
                            if (updatedCartContent && section) {
                                let cartCount = parseInt(updatedCartContent.getAttribute("data-item-count"));
                                section.innerHTML = updatedSection.innerHTML;
                                
                                // Initialize cart elements
                                setTimeout(() => {
                                    if (cartCount > 0) {
                                        getQuantityElement(section);
                                        cartNoteUpdate(section);
                                        getCartItemRemoveElements(section);
                                        cartGiftWrapElement(section);
                                        cartTotalprice(section);
                                        if (typeof shippingEstimates === 'function') {
                                            shippingEstimates();
                                        }
                                    }
                                }, 500);
                                
                                // Scroll to cart
                                let scrollDiv = section.offsetTop;
                                window.scrollTo({
                                    top: scrollDiv,
                                    behavior: "smooth"
                                });
                            }
                        } else {
                            // We're on a product page or other page with the cart drawer
                            let cartBody = document.querySelector("[data-cart-drwaer-body]");
                            let cartItemCount = 0;
                            
                            if (cartBody) {
                                let updatedCartContent = updatedSection.innerHTML;
                                cartBody.innerHTML = updatedCartContent;
                                
                                let cartWrapper = document.querySelector("[data-cart-wrapper]");
                                if (cartWrapper) {
                                    cartItemCount = parseInt(cartWrapper.getAttribute("data-item-count"));
                                }
                                
                                // Initialize cart elements
                                if (cartItemCount > 0) {
                                    getQuantityElement(cartBody);
                                }
                                
                                // Update cart counters and price
                                cartCountUpdate(cartItemCount);
                                cartNoteUpdate();
                                
                                let cartDrawer = document.querySelector("#ajax-cart-drawer[data-side-drawer]");
                                if (cartDrawer) {
                                    getCartItemRemoveElements(cartDrawer);
                                    cartGiftWrapElement(cartDrawer);
                                }
                                
                                // Handle other UI elements that might need updating
                                if (typeof cartTermhandlerClick === 'function') {
                                    cartTermhandlerClick();
                                }
                                if (typeof cartTermsHandler === 'function') {
                                    cartTermsHandler();
                                }
                                
                                // Close other drawers if open
                                setTimeout(function() {
                                    let quickviewDrawer = document.querySelector(".quickview-drawer");
                                    let compareModel = document.querySelector("[data-compare-model]");
                                    
                                    if (quickviewDrawer) {
                                        quickviewDrawer.classList.remove("sidebar-visible");
                                        setTimeout(function() {
                                            quickviewDrawer.style.display = "none";
                                        }, 300);
                                    }
                                    
                                    if (compareModel && cartDrawer.classList.contains("sidebar-visible") && 
                                        compareModel.querySelector(".compare-modal-content")) {
                                        compareModel.querySelector(".compare-modal-content").classList.remove("popup-visible");
                                    }
                                }, 100);
                                
                                // Open cart drawer
                                if (showDrawer) {
                                    setTimeout(function() {
                                        cartDrawer.classList.add("sidebar-visible");
                                        cartDrawer.style.display = "flex";
                                        document.querySelector("body").classList.add("no-scroll");
                                    }, 200);
                                }
                                
                                // Handle recommendation products if they exist
                                let recommendProducts = cartDrawer.querySelector("[data-recommendation-popup]");
                                if (recommendProducts && !recommendProducts.classList.contains("active")) {
                                    setTimeout(() => {
                                        recommendProducts.classList.add("active");
                                    }, 1000);
                                    
                                    if (typeof slideshowElements === 'function') {
                                        slideshowElements();
                                    }
                                }
                            }
                        }
                        
                        // Check for free shipping threshold
                        let shippingBar = document.querySelector("[data-cart-shipping]");
                        if (shippingBar && shippingBar.getAttribute("data-barwidth") == "100%" && 
                            document.querySelector(".confetti-container-wrapper")) {
                            
                            if (localStorage.confettiEffect == "false" || localStorage.confettiEffect == null) {
                                window.confettiful = new Confettiful(document.querySelector(".confetti-container-wrapper"));
                                localStorage.confettiEffect = "true";
                                setTimeout(function() {
                                    clearInterval(confettiInterval);
                                }, 3000);
                            }
                        }
                    }
                })
                .catch(error => {
                    console.error("Error refreshing cart:", error);
                });
        }

        function openStarliteCartDrawer() {
            let cartDrawer = document.querySelector("#ajax-cart-drawer[data-side-drawer]");
            
            if (cartDrawer) {
                cartDrawer.style.display = "flex";
                cartDrawer.classList.add("sidebar-visible");
                document.querySelector("body").classList.add("no-scroll");
            }
        }

        // Get current cart data to determine what to do
        fetch("/cart.js")
            .then(response => response.json())
            .then(cartData => {
                console.log("Starlite cart update - items count:", cartData.item_count);
                
                // Force a refresh of the cart
                forceStarliteCartRefresh(cartData, showDrawer);
                
                // If we don't want to show the drawer, make sure it's properly updated anyway
                if (!showDrawer) {
                    updateStarliteCartVisibility(cartData);
                }
            })
            .catch(error => {
                console.error("Error fetching cart:", error);
            });
    }
}
                            ,

{
    key: "_mandolinCart",
    value: function(variantId, showDrawer) {
        // Store this for use in callbacks
        var self = this;
        
        // Define helper functions inside this function scope
        // so they're accessible within the promise callbacks
        function updateMandolinCartVisibility(cartData) {
            if (cartData.item_count > 0) {
                // Update cart count bubbles
                const cartCountBubbles = document.querySelectorAll('.CartCountBubble');
                const cartCountTexts = document.querySelectorAll('.CartCountText');
                const cartCountNumbers = document.querySelectorAll('.CartCountBubble__Count');
                
                // Update count bubbles visibility
                cartCountBubbles.forEach(function(item) {
                    item.classList.add('Visible');
                });
                
                // Update text visibility (hide "Cart is empty" text)
                cartCountTexts.forEach(function(item) {
                    item.classList.remove('Visible');
                });
                
                // Update count numbers
                cartCountNumbers.forEach(function(item) {
                    item.textContent = cartData.item_count;
                });
                
                // Update free shipping notice if present
                const cartDrawer = document.querySelector('section-cart-drawer');
                if (cartDrawer) {
                    const options = JSON.parse(cartDrawer.getAttribute('data-section-settings') || '{}');
                    if (options.freeShippingThreshold) {
                        const freeShippingElement = document.querySelector('.CartDrawer__ShippingAmountNotice');
                        if (freeShippingElement) {
                            const cartTotalPrice = parseInt(cartData.total_price);
                            const cartCurrencySymbol = freeShippingElement.getAttribute('data-cart-currency-symbol') || '$';
                            const freeShippingAmount = Math.round(options.freeShippingAmount * (Shopify.currency.rate || 1));
                            
                            if (cartTotalPrice >= freeShippingAmount) {
                                freeShippingElement.innerHTML = options.freeShippingString;
                            } else {
                                let freeShippingAmountString = options.freeShippingAmountString;
                                freeShippingAmountString = freeShippingAmountString.replace(
                                    'remaining__amount', 
                                    '' + cartCurrencySymbol + ((freeShippingAmount - cartTotalPrice) / 100)
                                );
                                freeShippingElement.innerHTML = freeShippingAmountString;
                            }
                        }
                    }
                }
                
                // Trigger cart refresh event for theme components
                try {
                    document.dispatchEvent(new CustomEvent('cart:refresh', { 
                        bubbles: true
                    }));
                } catch(e) {
                    console.log("Error dispatching event:", e);
                }
            }
        }
        
        function forceMandolinCartRefresh(cartData, showDrawer) {
            // Method 1: Try to use the built-in cart drawer refresh
            const cartDrawer = document.querySelector('section-cart-drawer');
            if (cartDrawer && typeof cartDrawer._rerenderCart === 'function') {
                console.log("Using theme's native cart refresh method");
                cartDrawer._rerenderCart().then(function() {
                    if (showDrawer) {
                        cartDrawer.sidebarDrawer.show();
                    }
                });
                return;
            }
            
            // Method 2: Use the cart:refresh event method
            if (cartDrawer) {
                console.log("Using cart:refresh event");
                document.dispatchEvent(new CustomEvent('cart:refresh', { 
                    bubbles: true
                }));
                
                // Open drawer if needed
                if (showDrawer && cartDrawer.sidebarDrawer && typeof cartDrawer.sidebarDrawer.show === 'function') {
                    cartDrawer.sidebarDrawer.show();
                }
                return;
            }
            
            // Method 3: Manual refresh via section rendering
            console.log("Using section rendering API");
            const sectionId = document.querySelector('section-cart-drawer')?.getAttribute('data-section-settings');
            let parsedSettings = {};
            try {
                parsedSettings = JSON.parse(sectionId || '{}');
            } catch (e) {
                console.error("Error parsing section settings", e);
            }
            
            const fetchUrl = window.routes.cartUrl + 
                "?section_id=" + (parsedSettings.sectionId || 'cart-drawer') + 
                "&timestamp=" + Date.now();
            
            fetch(fetchUrl, {
                credentials: "same-origin",
                method: "GET"
            })
            .then(function(response) {
                return response.text();
            })
            .then(function(html) {
                // Create a temporary element to parse the response
                const tempElement = document.createElement("div");
                tempElement.innerHTML = html;
                
                // Find the cart form element
                const newCartForm = tempElement.querySelector(".Form--cart");
                if (newCartForm) {
                    const currentCartForm = document.querySelector(".Form--cart");
                    if (currentCartForm && currentCartForm.parentNode) {
                        currentCartForm.parentNode.replaceChild(newCartForm, currentCartForm);
                    }
                }
                
                // Extract cart data from the response
                const cartDrawerElement = tempElement.querySelector(".CartDrawer");
                if (cartDrawerElement) {
                    try {
                        const cartResult = JSON.parse(cartDrawerElement.getAttribute("data-section-settings") || '{}');
                        cartData.item_count = cartResult.itemCount;
                    } catch (e) {
                        console.error("Error parsing cart data", e);
                    }
                }
                
                // Update visibility and open drawer if needed
                updateMandolinCartVisibility(cartData);
                
                if (showDrawer) {
                    openMandolinCartDrawer();
                }
            })
            .catch(function(error) {
                console.error("Error refreshing cart:", error);
                
                // As a fallback, just update visibility
                updateMandolinCartVisibility(cartData);
                
                if (showDrawer) {
                    openMandolinCartDrawer();
                }
            });
        }
        
        function openMandolinCartDrawer() {
            const cartDrawerElement = document.querySelector('section-cart-drawer');
            
            if (cartDrawerElement && cartDrawerElement.sidebarDrawer && 
                typeof cartDrawerElement.sidebarDrawer.show === 'function') {
                cartDrawerElement.sidebarDrawer.show();
            } else {
                // Fallback method - using themegoal components directly
                const drawerElement = document.querySelector('.CartDrawer');
                if (drawerElement && window.themegoal && window.themegoal.components && 
                    window.themegoal.components.Drawer) {
                    const drawer = new window.themegoal.components.Drawer(drawerElement);
                    drawer.show();
                }
            }
        }
        
        // Get the cart data
        fetch(window.routes.cartUrl + '.js')
            .then(function(response) {
                return response.json();
            })
            .then(function(cartData) {
                console.log("Mandolin cart update - items count:", cartData.item_count);
                
                // Force a cart refresh when items exist
                if (cartData.item_count > 0) {
                    forceMandolinCartRefresh(cartData, showDrawer);
                } else {
                    // Even with empty cart, we may need to update counters and show the drawer
                    updateMandolinCartVisibility(cartData);
                    
                    if (showDrawer) {
                        openMandolinCartDrawer();
                    }
                }
                
                // Always update standard cart counters
                const cartCountBubbles = document.querySelectorAll('.CartCountBubble');
                const cartCountTexts = document.querySelectorAll('.CartCountText');
                const cartCountNumbers = document.querySelectorAll('.CartCountBubble__Count');
                
                // Set visibility based on item count
                cartCountBubbles.forEach(function(item) {
                    if (cartData.item_count === 0) {
                        item.classList.remove('Visible');
                    } else {
                        item.classList.add('Visible');
                    }
                });
                
                cartCountTexts.forEach(function(item) {
                    if (cartData.item_count === 0) {
                        item.classList.add('Visible');
                    } else {
                        item.classList.remove('Visible');
                    }
                });
                
                cartCountNumbers.forEach(function(item) {
                    item.textContent = cartData.item_count;
                });
            })
            .catch(function(error) {
                console.error("Error fetching cart:", error);
            });
    }
}
                            ,{
    key: "_canopyCart",
    value: function(variantId, showDrawer) {
        // Store this for use in callbacks
        var self = this;
        
        // Define helper functions inside this function scope
        // so they're accessible within the promise callbacks
        function updateCanopyCartVisibility(cartData) {
            if (cartData.item_count > 0) {
                // Update the cart-items component state
                const cartItems = document.querySelector('cart-items');
                if (cartItems) {
                    cartItems.dataset.empty = "false";
                }
                
                // Update cart drawer content visibility
                const cartDrawer = document.getElementById('cart-drawer');
                if (cartDrawer) {
                    const cartDrawerContent = cartDrawer.querySelector('.drawer__content');
                    if (cartDrawerContent) {
                        cartDrawerContent.classList.remove('drawer__content--flex');
                    }
                }
                
                // Update cart count displays
                const cartIcon = document.getElementById('cart-icon-bubble');
                if (cartIcon) {
                    const countElement = cartIcon.querySelector('.header__cart-count-number');
                    if (countElement) {
                        countElement.textContent = cartData.item_count;
                    }
                }
                
                const drawerCount = document.getElementById('cart-drawer__count');
                if (drawerCount) {
                    drawerCount.innerHTML = `(${cartData.item_count})`;
                }
                
                // Trigger custom event for theme compatibility
                try {
                    document.dispatchEvent(new CustomEvent('on:line-item:change', {
                        bubbles: true,
                        detail: { cart: cartData }
                    }));
                } catch(e) {
                    console.log("Error dispatching event:", e);
                }
            }
        }
        
        function forceCanopyCartRefresh(cartData, showDrawer) {
            // Method 1: Try the theme's custom element dispatch method
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                console.log("Using Canopy theme's cart-drawer element");
                
                // Create a custom event to refresh the cart drawer
                const refreshEvent = new CustomEvent('dispatch:cart-drawer:refresh');
                document.dispatchEvent(refreshEvent);
                
                // If we need to open the drawer, dispatch that event too
                if (showDrawer) {
                    const openEvent = new CustomEvent('dispatch:cart-drawer:open');
                    document.dispatchEvent(openEvent);
                }
                
                updateCanopyCartVisibility(cartData);
                return;
            }
            
            // Method 2: Try using section rendering API
            if (window.Shopify && window.Shopify.section) {
                console.log("Using Shopify section rendering");
                const sectionId = document.querySelector('cart-drawer')?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
                
                if (sectionId) {
                    fetch(`?sections=${sectionId}`)
                        .then(response => response.json())
                        .then(data => {
                            const cartDrawer = document.querySelector('cart-drawer');
                            if (cartDrawer && data[sectionId]) {
                                const tempDiv = document.createElement('div');
                                tempDiv.innerHTML = data[sectionId];
                                
                                const newCartDrawer = tempDiv.querySelector('cart-drawer');
                                if (newCartDrawer) {
                                    cartDrawer.innerHTML = newCartDrawer.innerHTML;
                                }
                                
                                // Update icon bubble separately
                                fetch('?sections=cart-icon-bubble')
                                    .then(response => response.json())
                                    .then(data => {
                                        const iconBubble = document.getElementById('cart-icon-bubble');
                                        if (iconBubble && data['cart-icon-bubble']) {
                                            const tempDiv = document.createElement('div');
                                            tempDiv.innerHTML = data['cart-icon-bubble'];
                                            const newIconBubble = tempDiv.querySelector('.shopify-section');
                                            if (newIconBubble) {
                                                iconBubble.innerHTML = newIconBubble.innerHTML;
                                            }
                                        }
                                    });
                            }
                            
                            updateCanopyCartVisibility(cartData);
                            
                            if (showDrawer) {
                                openCanopyCartDrawer();
                            }
                        });
                    return;
                }
            }
            
            // Method 3: Fallback - Direct DOM manipulation
            console.log("Using direct DOM manipulation");
            
            // Update cart items
            const cartItems = document.querySelector('cart-items');
            if (cartItems && cartItems.refreshCartItems && typeof cartItems.refreshCartItems === 'function') {
                cartItems.refreshCartItems();
            }
            
            // Update cart count displays
            const countElements = document.querySelectorAll('.header__cart-count-number');
            countElements.forEach(element => {
                element.textContent = cartData.item_count;
            });
            
            const drawerCount = document.getElementById('cart-drawer__count');
            if (drawerCount) {
                drawerCount.innerHTML = `(${cartData.item_count})`;
            }
            
            updateCanopyCartVisibility(cartData);
            
            if (showDrawer) {
                openCanopyCartDrawer();
            }
        }
        
        function openCanopyCartDrawer() {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                // Use the theme's native open method if available
                if (cartDrawer.open && typeof cartDrawer.open === 'function') {
                    const cartIcon = document.getElementById('cart-icon');
                    cartDrawer.open(cartIcon);
                } else {
                    // Dispatch the open event
                    const openEvent = new CustomEvent('dispatch:cart-drawer:open');
                    document.dispatchEvent(openEvent);
                }
            }
        }
        
        // Get the cart data
        fetch('/cart.js')
            .then(response => response.json())
            .then(cartData => {
                console.log("Canopy cart update - items count:", cartData.item_count);
                
                // Handle empty to non-empty transition
                if (cartData.item_count > 0) {
                    // Force a full reload of the cart drawer
                    forceCanopyCartRefresh(cartData, showDrawer);
                }
                
                // Always update standard cart counters
                const countElements = document.querySelectorAll('.header__cart-count-number');
                countElements.forEach(element => {
                    element.textContent = cartData.item_count;
                });
                
                // Update the icon bubble visibility
                if (cartData.item_count > 0) {
                    const cartIconBubble = document.getElementById('cart-icon-bubble');
                    if (cartIconBubble) {
                        cartIconBubble.classList.remove('hidden');
                    }
                }
                
                // If we should show the drawer, open it
                if (showDrawer) {
                    openCanopyCartDrawer();
                }
            })
            .catch(error => {
                console.error("Error fetching cart:", error);
            });
    }
}

                            ,{
    key: "_paloAltoCart",
    value: function(variantId, showDrawer) {
        // Store this for use in callbacks
        var self = this;
        
        // Define helper functions inside this function scope
        // so they're accessible within the promise callbacks
        function updatePaloAltoCartVisibility(cartData) {
            if (cartData.item_count > 0) {
                // Update cart count
                b("[data-cart-items-qty]").text(cartData.item_count === 1 ? 
                    cartData.item_count + " item" : 
                    cartData.item_count + " items").removeClass("hidden");
                
                // Hide empty states
                b("[data-empty-message]").addClass("hidden");
                b("[data-empty-message-bottom]").addClass("hidden");
                
                // Show item-related elements
                b("[data-items-holder]").removeClass("hidden");
                b("[data-cart-form]").removeClass("hidden");
                b("[data-cart-price-holder]").removeClass("hidden");
                
                // Update prices
                var formattedPrice = theme.settings.currency_code_enable ? 
                    themeVendor.themeCurrency.formatMoney(cartData.total_price, theme.moneyWithCurrencyFormat) :
                    themeVendor.themeCurrency.formatMoney(cartData.total_price, theme.moneyFormat);
                
                b("[data-cart-total]").html(formattedPrice);
                b("[data-cart-total-price]").html(formattedPrice);
                
                // Add class to body if needed for theme styling
                b("body").addClass("cart-has-items");
                
                // Try to trigger a custom event that the theme might listen for
                try {
                    document.dispatchEvent(new CustomEvent('theme:cart:added', {
                        bubbles: true
                    }));
                } catch(e) {
                    console.log("Error dispatching event:", e);
                }
            }
        }
        
        function forcePaloAltoCartRefresh(cartData, showDrawer) {
            // Method 1: Try to find and trigger the theme's native cart refresh method
            if (window.cart && typeof window.cart.getCart === 'function') {
                console.log("Using theme's native cart method");
                window.cart.getCart();
                
                if (showDrawer && typeof window.cart.openCartDrawer === 'function') {
                    window.cart.openCartDrawer();
                }
                return;
            }
            
            // Method 2: Try using section rendering API for cart refreshes
            if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections) {
                console.log("Using Shopify section rendering");
                var cartSections = document.querySelectorAll('[data-section-type="cart-template"]');
                if (cartSections.length > 0) {
                    var sectionId = cartSections[0].getAttribute('data-section-id');
                    if (sectionId) {
                        window.Shopify.theme.sections.render(sectionId);
                        updatePaloAltoCartVisibility(cartData);
                        
                        if (showDrawer) {
                            openPaloAltoCartDrawer();
                        }
                        return;
                    }
                }
            }
            
            // Method 3: Use AJAX to fetch and update the cart drawer content
            console.log("Using AJAX to refresh cart");
            b.ajax({
                url: theme.routes.cart_url + '?section_id=api-cart-items',
                cache: false,
                success: function(html) {
                    // Try to parse the updated cart content
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    
                    var apiContent = tempDiv.querySelector('[data-api-content]');
                    if (apiContent) {
                        // Update the items container
                        var apiLineItems = apiContent.querySelector('[data-api-line-items]');
                        if (apiLineItems) {
                            b('[data-items-wrapper]').html(apiLineItems.innerHTML);
                        }
                        
                        // Update the price info
                        var apiCartPrice = apiContent.querySelector('[data-api-cart-price]');
                        if (apiCartPrice) {
                            b('[data-cart-price-holder]').html(apiCartPrice.innerHTML);
                        }
                        
                        // Initialize any new quantity inputs
                        document.querySelectorAll('[data-quantity-field]').forEach(function(field) {
                            new window.theme.QuantityCounter(field.closest('[data-cart-item]'), true).init();
                        });
                    }
                    
                    // Force proper visibility state
                    updatePaloAltoCartVisibility(cartData);
                    
                    // Open the drawer if requested
                    if (showDrawer) {
                        openPaloAltoCartDrawer();
                    }
                },
                error: function() {
                    // As a fallback, at least try to fix the visibility
                    updatePaloAltoCartVisibility(cartData);
                    
                    if (showDrawer) {
                        openPaloAltoCartDrawer();
                    }
                }
            });
        }
        
        function openPaloAltoCartDrawer() {
            var cartDrawer = document.querySelector('[data-cart-drawer]');
            var cartDrawerBody = document.querySelector('[data-cart-drawer-body]');
            
            if (cartDrawer && !document.body.classList.contains('js-drawer-open-cart')) {
                // Lock scroll and prepare drawer
                document.dispatchEvent(new CustomEvent('theme:scroll:lock', { 
                    bubbles: true, 
                    detail: cartDrawer 
                }));
                
                document.dispatchEvent(new CustomEvent('theme:scroll:lock', { 
                    bubbles: true, 
                    detail: cartDrawerBody 
                }));
                
                // Add open classes
                document.body.classList.add('js-drawer-open', 'js-drawer-open-cart');
                cartDrawer.classList.add('is-open');
                
                // Update toggle buttons
                var toggleButtons = document.querySelectorAll('[data-cart-drawer-toggle]');
                toggleButtons.forEach(function(button) {
                    button.setAttribute('aria-expanded', true);
                });
                
                // Focus management
                setTimeout(function() {
                    if (window.theme.a11y) {
                        window.theme.a11y.trapFocus({
                            container: cartDrawer
                        });
                    }
                }, 100);
            }
        }
        
        // Get the cart data from Shopify's API
        fetch('/cart.js')
            .then(function(response) { return response.json(); })
            .then(function(cartData) {
                console.log("Palo Alto cart update - items count:", cartData.item_count);
                
                // Handle updating the cart
                if (cartData.item_count > 0) {
                    // Force a full reload of the cart drawer for consistency
                    forcePaloAltoCartRefresh(cartData, showDrawer);
                }
                
                // Always update standard cart counters regardless
                b("[data-cart-count]").text(cartData.item_count);
                b("[data-cart-toggle]").attr("data-cart-count", cartData.item_count);
                
                // Update cart toggle buttons to indicate items
                if (cartData.item_count > 0) {
                    b("[data-cart-drawer-toggle]").addClass("cart__toggle--has-items");
                }
            })
            .catch(function(error) {
                console.error("Error fetching cart:", error);
            });
    }
}
                                 ,{
    key: "_otherAjaxCarts",
    value: function () {
        // Store reference to preferences
        var self = this;
        
        // Get current cart data
        N.getCart().then(function (cartData) {
            // 1. Update basic cart counts (keep original functionality)
            b("div#atharva_minicart_count span").html(cartData.item_count);
            b("a span.floating-cart-bubble").html(cartData.item_count);
            b(".cart-count").html(cartData.item_count);
            b(".cart-count").removeClass("tw-hidden");
            
            // 2. Try to detect the cart mechanism instead of trying everything
            var cartUpdated = false;
            
            // Check for Shopify Section Rendering API (most modern approach)
            if (window.Shopify && window.Shopify.sections) {
                try {
                    // Find cart sections
                    var cartSections = document.querySelectorAll('[data-section-type*="cart"], [data-section-id*="cart"]');
                    if (cartSections.length > 0) {
                        // Use Shopify's section rendering
                        fetch('?sections=cart-drawer,cart-items,cart-notification')
                            .then(response => response.json())
                            .then(sections => {
                                for (var id in sections) {
                                    var selector = '[data-section-id="' + id + '"]';
                                    var section = document.querySelector(selector);
                                    if (section) {
                                        // Only update inner content to prevent layout shifts
                                        var tempDiv = document.createElement('div');
                                        tempDiv.innerHTML = sections[id];
                                        section.innerHTML = tempDiv.querySelector(selector)?.innerHTML || sections[id];
                                        cartUpdated = true;
                                    }
                                }
                            });
                    }
                } catch (e) {
                    console.log("Section rendering method failed:", e);
                }
            }
            
            // Try common cart update method if section rendering failed
            if (!cartUpdated) {
                // Look for a global cart update function
                if (window.updateCart && typeof window.updateCart === 'function') {
                    window.updateCart(cartData);
                    cartUpdated = true;
                } else if (window.theme && window.theme.cart) {
                    // Try theme-specific cart update
                    if (typeof window.theme.cart.updateCart === 'function') {
                        window.theme.cart.updateCart(cartData);
                        cartUpdated = true;
                    }
                }
            }
            
            // As a last resort, dispatch a general cart update event
            if (!cartUpdated) {
                // Dispatch a standard cart update event that many themes listen for
                var cartEvent = new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: { cart: cartData }
                });
                document.dispatchEvent(cartEvent);
            }
            
            // Get styling information from existing buttons or app settings
            var buttonStyles = {};
            
            // First, try to access settings via global variable
            if (window.CLEVER && window.CLEVER.settings) {
                buttonStyles = {
                    bgColor: window.CLEVER.settings.buttonBackgroundColor || "#000000",
                    textColor: window.CLEVER.settings.buttonFontColor || "#FFFFFF",
                    borderRadius: window.CLEVER.settings.buttonBorderRadius || "4px",
                    fontSize: window.CLEVER.settings.buttonFontSize || "14px",
                    fontFamily: window.CLEVER.settings.buttonFontFamily || "inherit",
                    addedText: window.CLEVER.settings.buttonAddedText || "Added to cart"
                };
            } else {
                // If global settings not available, get styles from an existing button
                var existingButton = b("." + C.cssClassPrefix() + "add-to-cart-button").first();
                if (existingButton.length > 0) {
                    buttonStyles = {
                        bgColor: existingButton.css("background-color") || "#000000",
                        textColor: existingButton.css("color") || "#FFFFFF",
                        borderRadius: existingButton.css("border-radius") || "4px",
                        fontSize: existingButton.css("font-size") || "14px",
                        fontFamily: existingButton.css("font-family") || "inherit",
                        addedText: existingButton.text() || "Added to cart"
                    };
                } else {
                    // Default styles if no button found
                    buttonStyles = {
                        bgColor: "#000000",
                        textColor: "#FFFFFF",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontFamily: "inherit",
                        addedText: "Added to cart"
                    };
                }
            }
            
            // Use the collected styles to create a notification
            if (!cartUpdated) {
                // Create a styled notification that shows cart count
                var notification = b('<div>' +
                    '<div style="display: flex; align-items: center;">' +
                    '<span style="flex-grow: 1;">' + buttonStyles.addedText + ' (' + cartData.item_count + ')</span>' +
                    '<a href="/cart" style="margin-left: 10px; text-decoration: none; color: inherit;">View cart</a>' +
                    '</div>' +
                    '</div>');
                
                // Apply button-like styling
                notification.css({
                    'position': 'fixed',
                    'bottom': '20px',
                    'right': '20px',
                    'z-index': '9999',
                    'padding': '10px 20px',
                    'background-color': buttonStyles.bgColor,
                    'color': buttonStyles.textColor,
                    'border-radius': buttonStyles.borderRadius,
                    'font-size': buttonStyles.fontSize,
                    'font-family': buttonStyles.fontFamily,
                    'box-shadow': '0 2px 10px rgba(0,0,0,0.2)',
                    'min-width': '200px',
                    'text-align': 'center'
                });
                
                b('body').append(notification);
                // Make it disappear faster (2500ms instead of 4000ms)
                setTimeout(function() {
                    notification.fadeOut(function() { notification.remove(); });
                }, 2500);
            }
        });
    }
}, {
                                key: "_normalizeTheme",
                                value: function (e) {
                                    return f.isNotEmpty(e) ? e.toLowerCase() : ""
                                }
                            }]), e
                        }(),
                         UnsenHandler = function() {
    function e() {
        t(this, e)
    }
    
    return r(e, null, [{
        key: "ajaxCart",
        value: function(t) {
            e._updateCartIcon();
            if (t) {
                // First refresh the cart data, then open drawer
                N.getCart().then(function(cart) {
                    // Force a page reload to ensure cart is properly updated
                    // This is the most reliable way to ensure the drawer works correctly
                    if (window.location.href.indexOf('cart') === -1) {
                        // Add a parameter to the URL to indicate we should open the cart drawer after reload
                        window.location.href = window.location.href + 
                            (window.location.href.indexOf('?') > -1 ? '&' : '?') + 
                            'open_cart=true';
                    }
                });
            }
        }
    }, {
        key: "_updateCartIcon",
        value: function() {
            N.getCart().then(e._updateCartBubble);
        }
    }, {
        key: "_updateCartBubble",
        value: function(cart) {
            // Update count in various places
            var cartCount = cart.item_count;
            
            // Update the specific cart count element for this theme
            var countElements = document.querySelectorAll('[data-cart-count], .t4s-count-box, .t4s-pa.t4s-op-0.t4s-ts-op');
            countElements.forEach(function(element) {
                if (element) {
                    element.textContent = cartCount;
                }
            });
        }
    }]), e
}(),
                        Ve = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "defaultButtonTextOrTextFromTag",
                                value: function (t, n) {
                                    var r = e._findDifferentButtonTextTag(n);
                                    if (r) {
                                        var a = r.replace(C.DIFFERENT_BUTTON_TEXT_TAG, "").trim();
                                        return a || t
                                    }
                                    return t
                                }
                            }, {
                                key: "_findDifferentButtonTextTag",
                                value: function (e) {
                                    return e && Array.isArray(e) && e.find((function (e) {
                                        return e.includes(C.DIFFERENT_BUTTON_TEXT_TAG)
                                    }))
                                }
                            }]), e
                        }(),
                        He = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "ajaxCart",
                                value: function (t) {
                                    t= "false";
                                    e._updateDrawerCartSafely()
                                }
                            }, {
                                key: "_updateDrawerCartSafely",
                                value: function () {
                                    try {
                                        e._updateDrawerCart()
                                    } catch (e) {}
                                }
                            }, {
                                key: "_showDrawerCartSafely",
                                value: function () {
                                    try {
                                        e._showDrawerCart(), setTimeout((function () {
                                            e._updateDrawerCart()
                                        }), 600)
                                    } catch (e) {}
                                }
                            }, {
                                key: "_updateDrawerCart",
                                value: function () {
                                    window.SLIDECART_UPDATE && window.SLIDECART_UPDATE()
                                }
                            }, {
                                key: "_showDrawerCart",
                                value: function () {
                                    window.SLIDECART_OPEN && window.SLIDECART_OPEN()
                                }
                            }]), e
                        }(),
                        Me = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "defaultButtonRedirectPolicyOrRedirectPolicyFromTag",
                                value: function (t, n) {
                                    var r = e._hasAnotherRedirectTag(n);
                                    return r ? e._normalizeRedirectTag(r) : t
                                }
                            }, {
                                key: "_hasAnotherRedirectTag",
                                value: function (e) {
                                    return e && Array.isArray(e) && e.find((function (e) {
                                        return e.includes(C.BUTTON_REDIRECT_TO_PRODUCT_PAGE_TAG) || e.includes(C.BUTTON_REDIRECT_TO_CHECKOUT_TAG) || e.includes(C.BUTTON_REDIRECT_TO_CART_TAG) || e.includes(C.BUTTON_REMAIN_ON_PAGE_TAG)
                                    }))
                                }
                            }, {
                                key: "_normalizeRedirectTag",
                                value: function (e) {
                                    return e.replace("cleverapps-add-to-cart-button-", "").replace(/-/g, "_").toUpperCase()
                                }
                            }]), e
                        }(),
                        $e = function () {
                            function e(n, r, a, i, o, u) {
                                t(this, e), this.selectedVariantId = n, this.errorUI = r, this.preferences = i, this.quantitySelectorUI = a, this.buttonText = Ve.defaultButtonTextOrTextFromTag(this.preferences.buttonText, o), this.productHandle = u, this.redirectPolicy = Me.defaultButtonRedirectPolicyOrRedirectPolicyFromTag(this.preferences.redirectPolicy, o), this._build()
                            }
                            return r(e, [{
                                key: "addToCartButton",
                                value: function () {
                                    return this.$addToCartButton
                                }
                            }, {
                                key: "updateSelectedVariantId",
                                value: function (e) {
                                    this.selectedVariantId = e
                                }
                            }, {
                                key: "_build",
                                value: function () {
                                    this.$addToCartButton = new b("<button></button>"), this.$addToCartButton.addClass(e.ADD_TO_CART_BUTTON_CLASS), this.$addToCartButton.text(this.buttonText), this._setStyles(), this._setClickCallback()
                                }
                            }, {
                                key: "_setClickCallback",
                                value: function () {
                                    var e = this;
                                    this.$addToCartButton.click((function (t) {
                                        e._isValidForm() ? e._clickFunction(t) : e._showValidationMessages()
                                    }))
                                }
                            }, {
                                key: "_isValidForm",
                                value: function () {
                                    return this.quantitySelectorUI.isValidQuantity()
                                }
                            }, {
                                key: "_showValidationMessages",
                                value: function () {
                                    this.quantitySelectorUI.reportValidity()
                                }
                            }, {
                                key: "_clickFunction",
                                value: function (e) {
                                    var t = this;
                                    e.preventDefault(), e.stopPropagation(), this._disableAndStartAnimation();
                                    var n = this._addProductCallback(this.selectedVariantId);
                                    N.addVariant(this.selectedVariantId, this.quantitySelectorUI.quantity(), this.preferences.theme, n, (function (e) {
                                        return t._restoreAfterErrorMessage(e)
                                    }))
                                }
                            }, {
                                key: "_addProductCallback",
                                value: function () {
                                    var e = this;
                                    e.preferences.showDrawerCart = "true";
                                    return "REDIRECT_TO_CHECKOUT" === this.redirectPolicy ? function () {
                                        return document.location.href = g.isDemoPage() ? location.href : g.getCheckoutPage()
                                    } : "REDIRECT_TO_PRODUCT_PAGE" === this.redirectPolicy ? function () {
                                        return document.location.href = g.isDemoPage() ? location.href : g.getProductPage(e.productHandle)
                                    } : "REDIRECT_TO_CART" === this.redirectPolicy || g.isCartPage() ? function () {
                                        return document.location.href = g.isDemoPage() ? location.href : g.getCartPage()
                                    } : function (t) {
                                        Ue.afterAddingToCart(e.selectedVariantId, e.quantitySelectorUI.quantity(), e.preferences.showDrawerCart), Ue.ajaxCart(e.preferences.theme, e.selectedVariantId, e.quantitySelectorUI.quantity(), e.preferences.showDrawerCart), He.ajaxCart(e.preferences.showDrawerCart), e._changeToAddedButtonAndResetAfterACertainTimeIfRequired()
                                    }
                                }
                            }, {
                                key: "_setStyles",
                                value: function () {
                                    this.preferences = {
                                        "customCss" : ".js-drawer-open .main-content:after { display: none !important; } html.js-drawer-open { overflow: visible !important; }.product-block__detail.align-ltr-left { margin-bottom: 0px !important; } cleverapps-collections-add-to-cart-variant-label { text-align: left; } ul.cbb-frequently-bought-selector-list > li > .cleverapps-collections-add-to-cart-widget { display: none; } div.cleverapps-collections-add-to-cart-widget { position: relative; } button.cleverapps-collections-add-to-cart-sold-out-button { border-radius: 10px; } .aos-init.aos-animate > .grid-product__content { margin-bottom: 0px !important; } .grid__item.grid-product.medium-up--one-half.grid-product__has-quick-shop.aos-init.aos-animate { margin-bottom: 30px; } #CollectionSwitcher1-template--18096174104825__featured_collection_switcher_BdidzJ .flickity-viewport { height: 415px !important; } #CollectionSwitcher1-template--18096174104825__featured-collection-switcher > .flickity-viewport { height: 480px !important; } li.mobile-nav__item > .cleverapps-collections-add-to-cart-widget { display: none; } @media only screen and (max-width: 767px) {#CollectionSwitcher1-template--22782545199428__featured_collection_switcher_FXhBY3 .flickity-viewport , #CollectionSwitcher1-template--22782545199428__featured_collection_switcher_Vhkatd .flickity-viewport { height: 320px !important; } } @media only screen and (min-width: 768px) { #CollectionSwitcher1-template--22782545199428__featured_collection_switcher_FXhBY3 .flickity-viewport , #CollectionSwitcher1-template--22782545199428__featured_collection_switcher_Vhkatd .flickity-viewport { height: 378px !important; } } .card__heading a:after{bottom:50% !important;}.cleverapps-collections-cart-button-widget { padding-top: 0px !important; } button.cleverapps-collections-add-to-cart-add-to-cart-button { text-align: center; } .slideshow__slide > .cleverapps-collections-add-to-cart-widget { display: none; }",
                                        "customJs" : "",
                                        "theme": window.Shopify?.theme?.schema_name || window.Shopify?.theme?.name || theme?.settings?.themeName || document.documentElement.getAttribute('data-theme-name') || window.theme?.name || '',
                                        "moneyFormat" : "",
                                        "target" : ".st-product-inner.grid-product",
                                        "targetPlacement" : "LAST_CHILD",
                                        "showOnHomepage" : data.showOnHomepage,
                                        "showOnSearchResultsPage" : data.showOnSearchResultsPage,
                                        "showOnProductPage" : data.showOnProductPage,
                                        "showOnCollectionPage" : true,
                                        "showOnCartPage" : false,
                                        "redirectPolicy" : data.redirectPolicy,
                                        "showDrawerCart" : "true",
                                        "lazyLoading" : "true",
                                        "alignWidgets" : "true",
                                        "buttonText" : data.buttonText,
                                        "buttonAddedText" : data.buttonAddedText,
                                        "buttonRecovery" :  "true",
                                        "buttonBorderSize" : data.buttonBorderSize+'px',
                                        "buttonBorderColor" : data.buttonBorderColor,
                                        "buttonBorderRadius" : data.buttonBorderRadius+'px',
                                        "buttonBackgroundColor" : data.buttonBackgroundColor,
                                        "buttonFontSize" : data.buttonFontSize+'px',
                                        "buttonFontColor" : data.buttonFontColor,
                                        "buttonFontStyle" : data.buttonFontStyle,
                                        "buttonFontFamily" : data.buttonFontFamily,
                                        "showSoldOutButton" : "true",
                                        "showSoldOutButtonText" : data.showSoldOutButtonText || "Sold Out",
                                        "soldOutButtonBorderSize" : data.soldOutButtonBorderSize+'px',
                                        "soldOutButtonBorderColor" : data.soldOutButtonBorderColor,
                                        "soldOutButtonBorderRadius" : data.soldOutButtonBorderRadius+'px',
                                        "soldOutButtonBackgroundColor" : '#000000',
                                        "soldOutButtonFontSize" : data.soldOutButtonFontSize+'px',
                                        "soldOutButtonFontColor" :'#FFFFFF',
                                        "soldOutButtonFontStyle" : data.soldOutButtonFontStyle,
                                        "soldOutButtonFontFamily" : data.soldOutButtonFontFamily,
                                        "showVariantSelector" : data.showVariantSelector,
                                        "variantSelectorBorderSize" : data.soldOutButtonBorderSize+'px',
                                        "variantSelectorBorderColor" : data.advancedBorderColor || data.variantSelectorBorderColor,
                                        "variantSelectorBorderRadius" : data.advancedBorderRadius+'px' || data.variantSelectorBorderRadius+'px',
                                        "variantSelectorBackgroundColor" : data.advancedBackgroundColor || data.variantSelectorBackgroundColor,
                                        "variantSelectorFontSize" : data.advancedFontSize+'px' || data.variantSelectorFontSize,
                                        "variantSelectorFontColor" :data.advancedFontColor || data.variantSelectorFontColor,
                                        "variantSelectorFontStyle" : data.advancedFontStyle || data.variantSelectorFontStyle,
                                        "variantSelectorFontFamily" : data.advancedFontFamily || data.variantSelectorFontFamily,
                                        "showVariantPrice" : data.showVariantPrice,
                                        "updateVariantImage" : data.updateVariantImage,
                                        "showAllVariants" : data.showAllVariants,
                                        "enableMultipleVariantSelectors" : data.enableMultipleVariantSelectors,
                                        "showVariantSelectorLabel" : data.showVariantSelectorLabel,
                                        "variantSelectorLabelFontSize" : data.variantSelectorLabelFontSize+'px',
                                        "variantSelectorLabelFontColor" : data.variantSelectorLabelFontColor,
                                        "variantSelectorLabelFontStyle" : data.variantSelectorLabelFontStyle,
                                        "variantSelectorLabelFontFamily" : data.variantSelectorLabelFontSiz,
                                        "showQuantitySelector" : data.showQuantitySelector,
                                        "quantitySelectorBorderSize" : data.quantitySelectorBorderSize+'px',
                                        "quantitySelectorBorderColor" : data.quantitySelectorBorderColor,
                                        "quantitySelectorBorderRadius" : data.quantitySelectorBorderRadius+'px',
                                        "quantitySelectorBackgroundColor" : data.quantitySelectorBackgroundColor,
                                        "quantitySelectorFontSize" : data.quantitySelectorFontSize+'px',
                                        "quantitySelectorFontColor" : data.quantitySelectorFontColor,
                                        "quantitySelectorFontStyle" : data.quantitySelectorFontStyle,
                                        "quantitySelectorFontFamily" : data.quantitySelectorFontFamily,
                                        "quantitySelectorDefaultQuantity" : data.quantitySelectorDefaultQuantity
                                    };
                                    this.$addToCartButton.css(L.getDefaultCss()), this.$addToCartButton.css("width", "100%"), this.$addToCartButton.css("height", "40px"), this.$addToCartButton.css("min-height", "40px"), L.applyFontStyle(this.$addToCartButton, this.preferences.buttonFontStyle), L.applyFontFamily(this.$addToCartButton, this.preferences.buttonFontFamily), this.$addToCartButton.css("font-size", this.preferences.buttonFontSize), this.$addToCartButton.css("color", this.preferences.buttonFontColor), this.$addToCartButton.css("background-color", this.preferences.buttonBackgroundColor ? this.preferences.buttonBackgroundColor : "transparent"), this.$addToCartButton.css("border-width", this.preferences.buttonBorderSize), this.$addToCartButton.css("border-color", this.preferences.buttonBorderColor ? this.preferences.buttonBorderColor : "transparent"), this.$addToCartButton.css("border-radius", this.preferences.buttonBorderRadius), this.$addToCartButton.css("border-style", "solid"), this.$addToCartButton.css("cursor", "pointer"), this.$addToCartButton.css("margin", "10px 0 0 0"), this.$addToCartButton.css("padding", "0px"), this.$addToCartButton.hover((function (e) {
                                        return b(b(e.currentTarget)).css("opacity", "0.7")
                                    }), (function (e) {
                                        return b(b(e.currentTarget)).css("opacity", "1")
                                    }))
                                }
                            }, {
                                key: "_disableAndStartAnimation",
                                value: function () {
                                    this.buttonText = this.$addToCartButton.text(), this.$addToCartButton.prop("disabled", !0), this.$addToCartButton.css("cursor", "wait"), this.$addToCartButton.text(this.preferences.buttonAddedText)
                                }
                            }, {
                                key: "_changeToAddedButtonAndResetAfterACertainTimeIfRequired",
                                value: function () {
                                    var t = this;
                                    this._changeToAddedButton(), this.preferences.buttonRecovery && setTimeout((function () {
                                        return t._resetWithAnimation()
                                    }), e.ADDED_TEXT_TIME)
                                }
                            }, {
                                key: "_changeToAddedButton",
                                value: function () {
                                    this.$addToCartButton.css("cursor", "default"), this.$addToCartButton.text(this.preferences.buttonAddedText)
                                }
                            }, {
                                key: "_resetWithAnimation",
                                value: function () {
                                    var e = this;
                                    this.$addToCartButton.text(this.buttonText), this.$addToCartButton.animate({
                                        opacity: 1
                                    }, 300, (function () {
                                        return e._reset()
                                    }))
                                }
                            }, {
                                key: "_reset",
                                value: function () {
                                    this.$addToCartButton.prop("disabled", !1), this.$addToCartButton.css("cursor", "pointer"), this.$addToCartButton.css("opacity", "1")
                                }
                            }, {
                                key: "_restoreAfterErrorMessage",
                                value: function (e) {
                                    this.errorUI.flash(e), this.$addToCartButton.prop("disabled", !1), this.$addToCartButton.css("cursor", "pointer"), this.$addToCartButton.css("opacity", "1"), this.$addToCartButton.text(this.buttonText)
                                }
                            }]), e
                        }();
                    a($e, "ADD_TO_CART_BUTTON_CLASS", C.cssClassPrefix() + "add-to-cart-button"), a($e, "ADDED_TEXT_TIME", 1500);
                    var We = function () {
                        function e() {
                            t(this, e), this._build()
                        }
                        return r(e, [{
                            key: "errorBox",
                            value: function () {
                                return this.$error
                            }
                        }, {
                            key: "flash",
                            value: function (t) {
                                var n = this;
                                this._show(t), setTimeout((function () {
                                    return n._hide()
                                }), e.FLASH_MESSAGE_MILLIS)
                            }
                        }, {
                            key: "_build",
                            value: function () {
                                this.$error = b("<div></div>"), this.$error.addClass(e.CLASS), this.$error.css({
                                    display: "none",
                                    "background-color": "#ffb6c1",
                                    "border-radius": "4px",
                                    padding: "1em",
                                    "margin-top": "10px"
                                })
                            }
                        }, {
                            key: "_show",
                            value: function (e) {
                                this.$error.html(e), this.$error.fadeIn()
                            }
                        }, {
                            key: "_hide",
                            value: function () {
                                this.$error.fadeOut()
                            }
                        }]), e
                    }();
                    a(We, "CLASS", C.cssClassPrefix() + "error"), a(We, "FLASH_MESSAGE_MILLIS", 5e3);
                    var ze = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "isAvailable",
                                value: function (e) {
                                    return e && e.available
                                }
                            }, {
                                key: "hasMoreThanOneVariants",
                                value: function (e) {
                                    return e && e.variants && e.variants.length > 1
                                }
                            }, {
                                key: "availableVariants",
                                value: function (e) {
                                    return e && e.variants ? e.variants.filter((function (e) {
                                        return e.available
                                    })) : []
                                }
                            }, {
                                key: "allVariants",
                                value: function (e) {
                                    return e && e.variants ? e.variants : []
                                }
                            }, {
                                key: "isVariantAvailable",
                                value: function (t, n) {
                                    return e.availableVariants(t).find((function (e) {
                                        return e.id == n
                                    }))
                                }
                            }, {
                                key: "hasTag",
                                value: function (e, t) {
                                    return e && e.tags && e.tags.includes(t)
                                }
                            }, {
                                key: "getVariantImage",
                                value: function (e, t) {
                                    var n = e && e.variants && e.variants.find((function (e) {
                                        return e.id == t
                                    }));
                                    return n && n.featured_image && n.featured_image.src ? n.featured_image.src : null
                                }
                            }, {
                                key: "getFirstVariantImage",
                                value: function (e) {
                                    var t = e && e.variants && e.variants[0];
                                    return t && t.featured_image && t.featured_image.src ? t.featured_image.src : null
                                }
                            }, {
                                key: "getFeatureImage",
                                value: function (e) {
                                    return e && e.featured_image ? e.featured_image : null
                                }
                            }, {
                                key: "getFirstImageInProductImagesArray",
                                value: function (e) {
                                    return e && e.images && e.images[0] ? e.images[0] : null
                                }
                            }]), e
                        }(),
                        Ge = function () {
                            function e(n) {
                                t(this, e), this.preferences = n
                            }
                            return r(e, [{
                                key: "build",
                                value: function () {
                                    this.$quantitySelectorContainer = this._quantitySelectorContainer(), this.$quantityInput = this._quantityInput(), this.$minusButton = this._minusButton(), this.$plusButton = this._plusButton(), this.$quantitySelectorContainer.append(this.$minusButton), this.$quantitySelectorContainer.append(this.$quantityInput), this.$quantitySelectorContainer.append(this.$plusButton)
                                }
                            }, {
                                key: "quantitySelector",
                                value: function () {
                                    return this.$quantitySelectorContainer
                                }
                            }, {
                                key: "quantity",
                                value: function () {
                                    return this.preferences.showQuantitySelector ? parseInt(this.$quantityInput.val()) : 1
                                }
                            }, {
                                key: "isValidQuantity",
                                value: function () {
                                    return !this.preferences.showQuantitySelector || this.$quantityInput[0].checkValidity()
                                }
                            }, {
                                key: "reportValidity",
                                value: function () {
                                    this.$quantityInput[0].reportValidity()
                                }
                            }, {
                                key: "_quantitySelectorContainer",
                                value: function () {
                                    var t = new b("<div></div>");
                                    return t.addClass(e.QUANTITY_SELECTOR_CONTAINER_CLASS), t.css(L.getDefaultCss()), t.css("height", "40px"), t.css("min-height", "40px"), L.applyFontStyle(t, this.preferences.quantitySelectorFontStyle), L.applyFontFamily(t, this.preferences.quantitySelectorFontFamily), t.css("font-size", this.preferences.quantitySelectorFontSize), t.css("color", this.preferences.quantitySelectorFontColor), t.css("background-color", this.preferences.quantitySelectorBackgroundColor ? this.preferences.quantitySelectorBackgroundColor : "transparent"), t.css("border-width", this.preferences.quantitySelectorBorderSize), t.css("border-color", this.preferences.quantitySelectorBorderColor ? this.preferences.quantitySelectorBorderColor : "transparent"), t.css("border-radius", this.preferences.quantitySelectorBorderRadius), t.css("border-style", "solid"), t.css("margin", "10px 10px 0 0"), t.css("display", "flex"), t.css("align-items", "center"), t.click((function (e) {
                                        return e.preventDefault()
                                    })), t
                                }
                            }, {
                                key: "_quantityInput",
                                value: function () {
                                    var t = this,
                                        n = new b('<input type="text" required/>');
                                    return n.addClass(e.QUANTITY_SELECTOR_INPUT_CLASS), n.val(this.preferences.quantitySelectorDefaultQuantity), n.css("border-width", "0"), n.css("padding", "0px"), n.css("width", "30px"), n.css("text-align", "center"), n.css("outline", "none"), n.css("margin", "0px"), L.applyFontStyle(n, this.preferences.quantitySelectorFontStyle), L.applyFontFamily(n, this.preferences.quantitySelectorFontFamily), n.css("font-size", this.preferences.quantitySelectorFontSize), n.css("color", this.preferences.quantitySelectorFontColor), n.css("background-color", this.preferences.quantitySelectorBackgroundColor ? this.preferences.quantitySelectorBackgroundColor : "transparent"), n.keypress((function (e) {
                                        return t._onlyNumbers(e)
                                    })), n
                                }
                            }, {
                                key: "_minusButton",
                                value: function () {
                                    var t = this,
                                        n = new b("<span>-</span>");
                                    return n.addClass(e.QUANTITY_SELECTOR_MINUS_BUTTON_CLASS), this._addQuantityButtonStyles(n), n.click((function () {
                                        return t._updateInputValue(-1)
                                    })), n.css("padding-right", "0px"), n
                                }
                            }, {
                                key: "_plusButton",
                                value: function () {
                                    var t = this,
                                        n = new b("<span>+</span>");
                                    return n.addClass(e.QUANTITY_SELECTOR_PLUS_BUTTON_CLASS), this._addQuantityButtonStyles(n), n.click((function () {
                                        return t._updateInputValue(1)
                                    })), n.css("padding-left", "0px"), n
                                }
                            }, {
                                key: "_addQuantityButtonStyles",
                                value: function (e, t) {
                                    e.css("padding", "0 10px"), e.css("cursor", "pointer"), e.css("opacity", "0.7"), e.css("margin", "0px"), e.hover((function (e) {
                                        return b(b(e.currentTarget)).css("opacity", "1.0")
                                    }), (function (e) {
                                        return b(b(e.currentTarget)).css("opacity", "0.7")
                                    }))
                                }
                            }, {
                                key: "_updateInputValue",
                                value: function (e) {
                                    var t = this.quantity() + e;
                                    this.$quantityInput.val(t >= 1 ? t : 1)
                                }
                            }, {
                                key: "_onlyNumbers",
                                value: function (e) {
                                    return !(8 != e.which && 0 != e.which && (e.which < 48 || e.which > 57))
                                }
                            }]), e
                        }();
                    a(Ge, "QUANTITY_SELECTOR_CONTAINER_CLASS", C.cssClassPrefix() + "quantity-selector-container"), a(Ge, "QUANTITY_SELECTOR_INPUT_CLASS", C.cssClassPrefix() + "quantity-selector-input"), a(Ge, "QUANTITY_SELECTOR_MINUS_BUTTON_CLASS", C.cssClassPrefix() + "quantity-selector-minus-button"), a(Ge, "QUANTITY_SELECTOR_PLUS_BUTTON_CLASS", C.cssClassPrefix() + "quantity-selector-plus-button");
                    var Qe = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "exists",
                                value: function (e) {
                                    if (!e.jquery) throw new Error("This function only works for jQuery objects");
                                    return e && e[0]
                                }
                            }, {
                                key: "existsVisible",
                                value: function (t) {
                                    return e.exists(t) && t.is(":visible")
                                }
                            }]), e
                        }(),
                        Ye = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "find",
                                value: function (t, n) {
                                    var r = e._findConfiguredTarget(t, n);
                                    if (e._isValidTarget(r)) return r;
                                    var a = e._findDefaultTarget(t);
                                    return e._isValidTarget(a) ? a : null
                                }
                            }, {
                                key: "_findConfiguredTarget",
                                value: function (e, t) {
                                    return t ? b(e).closest(t) : null
                                }
                            }, {
                                key: "_findDefaultTarget",
                                value: function (t) {
                                    return e._discardUnwantedTargets(t).closest(e.COLLECTION_PRODUCT_ANCESTOR_SELECTORS.join(", ")).first()
                                }
                            }, {
                                key: "_discardUnwantedTargets",
                                value: function (t) {
                                    return e.UNWANTED_COLLECTION_PRODUCT_ANCESTOR_SELECTORS.forEach((function (e) {
                                        return t = t.filter((function (t, n) {
                                            return 0 === b(n).closest(e).length
                                        }))
                                    })), t
                                }
                            }, {
                                key: "_isValidTarget",
                                value: function (e) {
                                    return e && Qe.existsVisible(e)
                                }
                            }]), e
                        }();
                    a(Ye, "COLLECTION_PRODUCT_ANCESTOR_SELECTORS", [".grid-uniform > .grid__item > div",".st-product-inner.grid-product",".st-product-details.grid-product__meta",".grid-view-item.product-card",".collection > .products > .product",".grid__item",".m-product-card",".ProductCard", ".grid-item",".product-card.ic-relative",".product-card-item",".ct-product-card",".st-product-wrap>.st-product>.st-product-inner.grid-product",".card--noButton",".grid .card","card-product.card-product",".t4s-pr-grid",".st-product-inner.grid-product",".collection__page-product",".col.product-box",".ProductList .ProductItem", ".collection .product-item", ".collection-products .product", ".o-layout__item", ".products-grid .product",".grid__item.grid-product","product-grid-item", ".productgrid--items .productgrid--item .productitem", ".grid-collection .grid-product",".ic-grid-item > div.product-card",".product-index","product-card.product-card", ".product__grid-item", ".thumbnail", ".product--root", ".product-thumb", ".product-grid-item", ".product-block__inner", 'div[data-label="Product"]', ".products .product-inner","product-list > product-card","product-item.product-item","product-block.product-block",".product-item-v9",".product-list>.product-block",".bee-product.bee-pr-grid"]),
                                                            a(Ye, "UNWANTED_COLLECTION_PRODUCT_ANCESTOR_SELECTORS", ["header", "#shopify-section-header",".site-footer__linklist > li",".be-list-item", ".predictive-search__list-item","product-info",".product-section","nav", ".featured-product", ".feature-row", ".cleverapps-viewed-products-assistant-container", "#shopify-section-footer", ".cleverapps-collections-add-to-cart-ignore", ".ajaxcart__product", ".ajax-cart__cart-items", "#CartDrawer","#rebuy-cart",".kaching-cart__carousel-item"]);""
                    var Xe = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "find",
                            value: function (t, n, r) {
                                var a = Ye.find(t, n),
                                    i = e._normalizeImage(r),
                                    o = e.IMAGE_ELEMENT_SELECTORS.join(",").replaceAll(e.IMAGE_REPLACER, i);
                                return a.find(o).first()
                            }
                        }, {
                            key: "_normalizeImage",
                            value: function (e) {
                                var t = g.removeParameters(e),
                                    n = t.lastIndexOf(".");
                                return n > 0 ? t.substring(0, n) : t
                            }
                        }]), e
                    }();
                    a(Xe, "IMAGE_REPLACER", "_image_"), a(Xe, "IMAGE_ELEMENT_SELECTORS", ['img[srcset*="'.concat(Xe.IMAGE_REPLACER, '"]'), 'img[src*="'.concat(Xe.IMAGE_REPLACER, '"]')]);
                    var Ke = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "getSizes",
                                value: function (e) {
                                    return e.split(",").map((function (e) {
                                        return e.trim().split(" ")
                                    })).filter((function (e) {
                                        return 2 == e.length
                                    })).map((function (e) {
                                        return e[1].trim().replace("w", "")
                                    }))
                                }
                            }, {
                                key: "generateFrom",
                                value: function (t, n) {
                                    var r = e._getImageUrlWithoutExtension(t),
                                        a = e._getImageExtensionAndParams(t);
                                    return n.map((function (e) {
                                        return r + "_" + e + "x" + a + " " + e + "w"
                                    })).join(", ")
                                }
                            }, {
                                key: "_getImageUrlWithoutExtension",
                                value: function (e) {
                                    var t = g.removeParameters(e),
                                        n = t.lastIndexOf(".");
                                    return n > 0 ? t.substring(0, n) : t
                                }
                            }, {
                                key: "_getImageExtensionAndParams",
                                value: function (e) {
                                    var t = g.removeParameters(e),
                                        n = t.lastIndexOf(".");
                                    return n > 0 ? e.substring(n) : e.substring(t.length)
                                }
                            }]), e
                        }(),
                        Je = function () {
                            function e(n, r, a) {
                                t(this, e), this.imageElementFound = !1, this.product = n, this.$productLinkElement = r, this.target = a
                            }
                            return r(e, [{
                                key: "update",
                                value: function (e) {
                                    console.log(e)
                                    this._tryToFindImageElementIfRequired(), this.imageElementFound && this._updateVariantImage(e || this.defaultImage)
                                }
                            }, {
                                key: "_tryToFindImageElementIfRequired",
                                value: function () {
                                    this.imageElementFound || this._tryToFindImageElement()
                                }
                            }, {
                                key: "_tryToFindImageElement",
                                value: function () {
                                    var e = ze.getFeatureImage(this.product);
                                    e && this._initializeValues(e), e = ze.getFirstImageInProductImagesArray(this.product), !this.imageElementFound && e && this._initializeValues(e), e = ze.getFirstVariantImage(this.product), !this.imageElementFound && e && this._initializeValues(e)
                                }
                            }, {
                                key: "_initializeValues",
                                value: function (e) {
                                    this.$imageElement = Xe.find(this.$productLinkElement, this.target, e),
                                        this.defaultImage = e,
                                        this.imageElementFound = this.$imageElement && this.$imageElement.length > 0
                                }
                            }, {
                                key: "_updateVariantImage",
                                value: function (e) {

                                    this._tryToChangeImageSrcSet(e) || this._tryToChangeImageSrc(e)
                                }
                            }, {
                                key: "_tryToChangeImageSrcSet",
                                value: function (e) {
                                    var t = this.$imageElement.attr("srcset");
                                    if (!t) return !1;
                                    var n = Ke.getSizes(t),
                                        r = Ke.generateFrom(e, n);
                                    return t != r && (this.$imageElement.attr("srcset", r), this.currentImage = e, !0)
                                }
                            }, {
                                key: "_tryToChangeImageSrc",
                                value: function (e) {
                                    var t = this.$imageElement.attr("src");
                                    return !!t && (t != e && (this.$imageElement.attr("src", e), this.currentImage = e, !0))
                                }
                            }]), e
                        }(),
                        Ze = function () {
                            function e(n) {
                                t(this, e), this.preferences = n, this._build()
                            }
                            return r(e, [{
                                key: "soldOutButton",
                                value: function () {
                                    return this.$soldOutButton
                                }
                            }, {
                                key: "_build",
                                value: function () {
                                    this.$soldOutButton = new b("<button></button>"), this.$soldOutButton.addClass(e.SOLD_OUT_BUTTON_CLASS), this.$soldOutButton.text(this.preferences.showSoldOutButtonText), this._setStyles()
                                }
                            }, {
                                key: "_setStyles",
                                value: function () {
                                    this.$soldOutButton.css(L.getDefaultCss()), this.$soldOutButton.css("width", "100%"), this.$soldOutButton.css("height", "40px"), this.$soldOutButton.css("min-height", "40px"), L.applyFontStyle(this.$soldOutButton, this.preferences.soldOutButtonFontStyle), L.applyFontFamily(this.$soldOutButton, this.preferences.soldOutButtonFontFamily), this.$soldOutButton.css("font-size", this.preferences.soldOutButtonFontSize), this.$soldOutButton.css("color", this.preferences.soldOutButtonFontColor), this.$soldOutButton.css("background-color", this.preferences.soldOutButtonBackgroundColor ? this.preferences.soldOutButtonBackgroundColor : "transparent"), this.$soldOutButton.css("border-width", this.preferences.soldOutButtonBorderSize), this.$soldOutButton.css("border-color", this.preferences.soldOutButtonBorderColor ? this.preferences.soldOutButtonBorderColor : "transparent"), this.$soldOutButton.css("border-radius", this.preferences.soldOutButtonBorderRadius), this.$soldOutButton.css("border-style", "solid"), this.$soldOutButton.css("margin", "10px 0 0 0"), this.$soldOutButton.css("padding", "0px")
                                }
                            }]), e
                        }();
                    a(Ze, "SOLD_OUT_BUTTON_CLASS", C.cssClassPrefix() + "sold-out-button");
                    var et = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "format",
                                value: function (t) {
                                    return new Intl.NumberFormat(k.getLanguage(), {
                                        style: "currency",
                                        currency: l.getPresentmentCurrency(),
                                        currencyDisplay: e._currencyDisplay()
                                    }).format(t)
                                }
                            }, {
                                key: "_currencyDisplay",
                                value: function () {
                                    return k.isSafari() || k.isIE() ? "symbol" : "narrowSymbol"
                                }
                            }]), e
                        }(),
                        tt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "numberWithThousandSeparator",
                                value: function (e, t) {
                                    return e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, t)
                                }
                            }]), e
                        }(),
                        nt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "format",
                                value: function (t) {
                                    var n = t.toFixed(2).split("."),
                                        r = n[0],
                                        a = tt.numberWithThousandSeparator(r, e.THOUSAND_SEPARATOR),
                                        i = n[1];
                                    return a + e.DECIMAL_SEPARATOR + i
                                }
                            }]), e
                        }();
                    a(nt, "THOUSAND_SEPARATOR", ","), a(nt, "DECIMAL_SEPARATOR", ".");
                    var rt = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "format",
                            value: function (t) {
                                var n = t.toFixed(2).split("."),
                                    r = n[0],
                                    a = tt.numberWithThousandSeparator(r, e.THOUSAND_SEPARATOR),
                                    i = n[1];
                                return a + e.DECIMAL_SEPARATOR + i
                            }
                        }]), e
                    }();
                    a(rt, "THOUSAND_SEPARATOR", "."), a(rt, "DECIMAL_SEPARATOR", ",");
                    var at = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "format",
                            value: function (t) {
                                var n = t.toFixed(2).split("."),
                                    r = n[0],
                                    a = tt.numberWithThousandSeparator(r, e.THOUSAND_SEPARATOR),
                                    i = n[1];
                                return a + e.DECIMAL_SEPARATOR + i
                            }
                        }]), e
                    }();
                    a(at, "THOUSAND_SEPARATOR", "'"), a(at, "DECIMAL_SEPARATOR", ".");
                    var it = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "format",
                            value: function (t) {
                                var n = t.toFixed(0);
                                return tt.numberWithThousandSeparator(n, e.THOUSAND_SEPARATOR)
                            }
                        }]), e
                    }();
                    a(it, "THOUSAND_SEPARATOR", ",");
                    var ot = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "format",
                            value: function (t) {
                                var n = t.toFixed(0);
                                return tt.numberWithThousandSeparator(n, e.THOUSAND_SEPARATOR)
                            }
                        }]), e
                    }();
                    a(ot, "THOUSAND_SEPARATOR", ".");
                    var ut = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "format",
                            value: function (t, n) {
                                if (n) {
                                    if (n.includes(e.SHOPIFY_AMOUNT_FORMAT)) {
                                        var r = nt.format(t);
                                        return e._replaceAmount(n, e.SHOPIFY_AMOUNT_FORMAT, r)
                                    }
                                    if (n.includes(e.SHOPIFY_AMOUNT_WITH_COMMA_SEPARATOR_FORMAT)) {
                                        var a = rt.format(t);
                                        return e._replaceAmount(n, e.SHOPIFY_AMOUNT_WITH_COMMA_SEPARATOR_FORMAT, a)
                                    }
                                    if (n.includes(e.SHOPIFY_AMOUNT_WITH_APOSTROPHE_SEPARATOR_FORMAT)) {
                                        var i = at.format(t);
                                        return e._replaceAmount(n, e.SHOPIFY_AMOUNT_WITH_APOSTROPHE_SEPARATOR_FORMAT, i)
                                    }
                                    if (n.includes(e.SHOPIFY_AMOUNT_NO_DECIMALS_FORMAT)) {
                                        var o = it.format(t);
                                        return e._replaceAmount(n, e.SHOPIFY_AMOUNT_NO_DECIMALS_FORMAT, o)
                                    }
                                    if (n.includes(e.SHOPIFY_AMOUNT_NO_DECIMALS_WITH_COMMA_SEPARATOR_FORMAT)) {
                                        var u = ot.format(t);
                                        return e._replaceAmount(n, e.SHOPIFY_AMOUNT_NO_DECIMALS_WITH_COMMA_SEPARATOR_FORMAT, u)
                                    }
                                    return et.format(t)
                                }
                                return et.format(t)
                            }
                        }, {
                            key: "_replaceAmount",
                            value: function (e, t, n) {
                                return e.replace(t, n)
                            }
                        }]), e
                    }();
                    a(ut, "SHOPIFY_AMOUNT_FORMAT", "{{amount}}"), a(ut, "SHOPIFY_AMOUNT_WITH_COMMA_SEPARATOR_FORMAT", "{{amount_with_comma_separator}}"), a(ut, "SHOPIFY_AMOUNT_WITH_APOSTROPHE_SEPARATOR_FORMAT", "{{amount_with_apostrophe_separator}}"), a(ut, "SHOPIFY_AMOUNT_NO_DECIMALS_FORMAT", "{{amount_no_decimals}}"), a(ut, "SHOPIFY_AMOUNT_NO_DECIMALS_WITH_COMMA_SEPARATOR_FORMAT", "{{amount_no_decimals_with_comma_separator}}");
                    var st = function () {
                        function e(n, r, a, i, o) {
                            t(this, e), this.variants = n, this.allVariants = r, this.preferences = a, this.variantChangedCallback = i, this.options = o, this.$variantLabels = []
                        }
                        return r(e, [{
                            key: "build",
                            value: function () {}
                        }, {
                            key: "variantSelector",
                            value: function () {
                                return this.$variantSelector
                            }
                        }, {
                            key: "getSelectedVariantId",
                            value: function () {
                                return this.$variantSelector ? this.$variantSelector.val() : 0
                            }
                        }, {
                            key: "getClassName",
                            value: function (t) {
                                switch (t) {
                                    case 2:
                                        return e.VARIANT_SELECTOR_OPTION_2_CLASS;
                                    case 3:
                                        return e.VARIANT_SELECTOR_OPTION_3_CLASS;
                                    default:
                                        return e.VARIANT_SELECTOR_OPTION_1_CLASS
                                }
                            }
                        }, {
                            key: "_createLabelContainer",
                            value: function (t) {
                                var n = new b("<div></div>");
                                n.addClass(e.VARIANT_LABEL_OPTION_CLASS), n.html(t), n.css("margin", "5px 0 0 0"), n.css("font-size", this.preferences.variantSelectorLabelFontSize), n.css("color", this.preferences.variantSelectorLabelFontColor), L.applyFontStyle(n, this.preferences.variantSelectorLabelFontStyle), L.applyFontFamily(n, this.preferences.variantSelectorLabelFontFamily), this.$variantLabels.push(n)
                            }
                        }, {
                            key: "_setStyles",
                            value: function (e) {
                                e.css(L.getDefaultCss()), e.css("width", "100%"), e.css("height", "40px"), L.applyFontStyle(e, this.preferences.variantSelectorFontStyle), L.applyFontFamily(e, this.preferences.variantSelectorFontFamily), e.css("font-size", this.preferences.variantSelectorFontSize), e.css("color", this.preferences.variantSelectorFontColor), e.css("background-color", this.preferences.variantSelectorBackgroundColor ? this.preferences.variantSelectorBackgroundColor : "transparent"), e.css("border-width", this.preferences.variantSelectorBorderSize), e.css("border-color", this.preferences.variantSelectorBorderColor ? this.preferences.variantSelectorBorderColor : "transparent"), e.css("border-radius", this.preferences.variantSelectorBorderRadius), e.css("border-style", "solid"), e.css("margin", "5px 0 0 0"), e.css("padding", "0px 10px"), e.css("cursor", "pointer"), this._setArrowStyles(e)
                            }
                        }, {
                            key: "_setArrowStyles",
                            value: function (e) {
                                e.css("background-image", "linear-gradient(45deg, transparent 50%, #333 50%), linear-gradient(135deg, #333 50%, transparent 50%)"), e.css("background-position", "calc(100% - 14px) calc(1em + 2px), calc(100% - 10px) calc(1em + 2px)"), e.css("background-size", "4px 4px"), e.css("background-repeat", "no-repeat"), e.css("-webkit-appearance", "none"), e.css("-moz-appearance", "none"), e.css("text-indent", "1px"), e.css("text-overflow", "")
                            }
                        }, {
                            key: "_disableVariant",
                            value: function (t, n) {
                                this.preferences.showAllVariants && !t && (n.attr("disabled", "disabled"), n.addClass(e.OPTION_DISABLED_CLASS), n.css("color", "rgb(170,170,170)"))
                            }
                        }, {
                            key: "_defaultOption",
                            value: function (e) {
                                var t = b("<option />");
                                t.val("-1"), t.html("----"), t.attr("selected", "true"), e.append(t)
                            }
                        }, {
                            key: "_priceText",
                            value: function (t) {
                                if (this._shouldShowVariantPrices()) {
                                    var n = t.price / 100;
                                    return e.PRICE_SEPARATOR + ut.format(n, this.preferences.moneyFormat)
                                }
                                return ""
                            }
                        }, {
                            key: "_shouldShowVariantPrices",
                            value: function () {
                                return this.preferences.showVariantPrice && this._hasDifferentPrices()
                            }
                        }, {
                            key: "_hasDifferentPrices",
                            value: function () {
                                var e = this.allVariants.map((function (e) {
                                    return e.price
                                }));
                                return d.distinct(e).length > 1
                            }
                        }]), e
                    }();
                    a(st, "VARIANT_SELECTOR_OPTION_1_CLASS", C.cssClassPrefix() + "variant-selector"), a(st, "VARIANT_SELECTOR_OPTION_2_CLASS", C.cssClassPrefix() + "variant-selector-option-2"), a(st, "VARIANT_SELECTOR_OPTION_3_CLASS", C.cssClassPrefix() + "variant-selector-option-3"), a(st, "VARIANT_LABEL_OPTION_CLASS", C.cssClassPrefix() + "variant-label"), a(st, "PRICE_SEPARATOR", "   -   "), a(st, "OPTION_DISABLED_CLASS", C.cssClassPrefix() + "option-disabled");
                    var ct = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "getOptionsByPosition",
                                value: function (t, n, r, a) {
                                    switch (n) {
                                        case 1:
                                            return e.getOptionsLevel1(t);
                                        case 2:
                                            return e.getOptionsLevel2(t, r);
                                        case 3:
                                            return e.getOptionsLevel3(t, r, a)
                                    }
                                }
                            }, {
                                key: "getOptionsLevel3",
                                value: function (e, t, n) {
                                    var r = e.filter((function (e) {
                                        return e.option2 === n && e.option1 === t && f.isNotEmpty(e.option3)
                                    }));
                                    return d.isNotEmpty(r) ? d.removeDuplicates(r.map((function (e) {
                                        return e.option3
                                    }))) : void 0
                                }
                            }, {
                                key: "getOptionsLevel2",
                                value: function (e, t) {
                                    var n = e.filter((function (e) {
                                        return e.option1 === t && f.isNotEmpty(e.option2)
                                    }));
                                    return d.isNotEmpty(n) ? d.removeDuplicates(n.map((function (e) {
                                        return e.option2
                                    }))) : void 0
                                }
                            }, {
                                key: "getOptionsLevel1",
                                value: function (e) {
                                    var t = e.filter((function (e) {
                                        return f.isNotEmpty(e.option1)
                                    }));
                                    return d.isNotEmpty(t) ? d.removeDuplicates(t.map((function (e) {
                                        return e.option1
                                    }))) : void 0
                                }
                            }, {
                                key: "getVariantByOptions",
                                value: function (e, t, n, r) {
                                    return e.find((function (e) {
                                        return e.option1 === t && e.option2 === n && e.option3 === r
                                    }))
                                }
                            }, {
                                key: "getVariant",
                                value: function (e, t) {
                                    return e.find((function (e) {
                                        return e.id == t
                                    }))
                                }
                            }, {
                                key: "hasNotVariants",
                                value: function (t) {
                                    return !e.hasVariants(t)
                                }
                            }, {
                                key: "hasVariants",
                                value: function (e) {
                                    return e.length > 0
                                }
                            }, {
                                key: "availableVariantsByPosition",
                                value: function (e, t, n, r, a) {
                                    switch (t) {
                                        case 1:
                                            return e.find((function (e) {
                                                return e.option1 === a
                                            }));
                                        case 2:
                                            return e.find((function (e) {
                                                return e.option1 === n && e.option2 === a
                                            }));
                                        case 3:
                                            return e.find((function (e) {
                                                return e.option1 === n && e.option2 === r && e.option3 === a
                                            }))
                                    }
                                }
                            }]), e
                        }(),
                        lt = function (e) {
                            i(a, e);
                            var n = c(a);

                            function a(e, r, i, o, u, s) {
                                var c;
                                return t(this, a), (c = n.call(this, e, r, i, o, s)).$variantSelectors = [], c.variantSelectedId = u || r[0].id, c._defaultOptionSelected(), c._initializeOptions(), c._lastPosition(), c._addLabel(), c
                            }
                            return r(a, [{
                                key: "build",
                                value: function () {
                                    d.isNotEmpty(this.options1) && this._buildVariantAndPopulateSelector(1), d.isNotEmpty(this.options2) && this._buildVariantAndPopulateSelector(2), d.isNotEmpty(this.options3) && this._buildVariantAndPopulateSelector(3)
                                }
                            }, {
                                key: "variantSelector",
                                value: function () {
                                    var e = this;
                                    return this.preferences.showVariantSelectorLabel ? this.$variantLabels.map((function (t, n) {
                                        return [t, e.$variantSelectors[n + 1]]
                                    })).flat() : this.$variantSelectors
                                }
                            }, {
                                key: "getSelectedVariantId",
                                value: function () {
                                    return this.variantSelectedId
                                }
                            }, {
                                key: "_addLabel",
                                value: function () {
                                    var e = this;
                                    this.preferences.showVariantSelectorLabel && b.map(this.options, (function (t) {
                                        return e._createLabelContainer(t.name)
                                    }))
                                }
                            }, {
                                key: "_defaultOptionSelected",
                                value: function () {
                                    var e = ct.getVariant(this.allVariants, this.variantSelectedId);
                                    this.option1Selected = e.option1, this.option2Selected = e.option2, this.option3Selected = e.option3
                                }
                            }, {
                                key: "_initializeOptions",
                                value: function () {
                                    this.options1 = ct.getOptionsLevel1(this._variants()), this.options2 = ct.getOptionsLevel2(this._variants(), this.option1Selected), this.options3 = ct.getOptionsLevel3(this._variants(), this.option1Selected, this.option2Selected)
                                }
                            }, {
                                key: "_variants",
                                value: function () {
                                    return this.preferences.showAllVariants ? this.allVariants : this.variants
                                }
                            }, {
                                key: "_lastPosition",
                                value: function () {
                                    this.lastPosition = d.isNotEmpty(this.options1) ? 1 : 0, this.lastPosition = d.isNotEmpty(this.options2) ? 2 : this.lastPosition, this.lastPosition = d.isNotEmpty(this.options3) ? 3 : this.lastPosition
                                }
                            }, {
                                key: "_buildVariantAndPopulateSelector",
                                value: function (e) {
                                    this.$variantSelectors[e] = this._buildVariantSelector(e), this._populateSelect(e)
                                }
                            }, {
                                key: "_buildVariantSelector",
                                value: function (e) {
                                    var t = this,
                                        n = new b("<select></select>");
                                    return n.addClass(this.getClassName(e)), this._setStyles(n), n.change((function () {
                                        return t._changeSelector(e)
                                    })), n
                                }
                            }, {
                                key: "_changeSelector",
                                value: function (e) {
                                    for (this.option1Selected = this.$variantSelectors[1] ? this.$variantSelectors[1].val() : null, this.option2Selected = this.$variantSelectors[2] ? this.$variantSelectors[2].val() : null, this.option3Selected = this.$variantSelectors[3] ? this.$variantSelectors[3].val() : null; e < this.lastPosition; e++) {
                                        var t = e + 1;
                                        this._populateSelect(t)
                                    }
                                    var n = ct.getVariantByOptions(this.allVariants, this.option1Selected, this.option2Selected, this.option3Selected);
                                    n && (this.variantSelectedId = n.id), n && this.variantChangedCallback(this.getSelectedVariantId())
                                }
                            }, {
                                key: "_populateSelect",
                                value: function (e) {
                                    var t = this,
                                        n = ct.getOptionsByPosition(this._variants(), e, this.option1Selected, this.option2Selected),
                                        r = this.$variantSelectors[e];
                                    r.empty(), n.forEach((function (n) {
                                        return r.append(t._createOption(e, n))
                                    })), (r.val() ? r.val() : -1) < 0 && this._defaultOption(r)
                                }
                            }, {
                                key: "_createOption",
                                value: function (e, t) {
                                    var n = b("<option />");
                                    return n.attr("selected", this._isOptionSelected(e, t)), n.html(this._optionText(e, t)), n.val(t), this._disabledVariantByPosition(e, t, n), n
                                }
                            }, {
                                key: "_disabledVariantByPosition",
                                value: function (e, t, n) {
                                    var r = !!ct.availableVariantsByPosition(this.variants, e, this.option1Selected, this.option2Selected, t) || this.preferences.showSoldOutButton && ct.hasNotVariants(this.variants) && !this._isLastPosition(e);
                                    this._disableVariant(r, n)
                                }
                            }, {
                                key: "_optionText",
                                value: function (e, t) {
                                    var n = t;
                                    if (this._isLastPosition(e)) {
                                        var r = this._getVariantId(e, t),
                                            a = ct.getVariant(this.allVariants, r);
                                        n += this._priceText(a)
                                    }
                                    return n
                                }
                            }, {
                                key: "_isOptionSelected",
                                value: function (e, t) {
                                    return ct.getVariant(this.allVariants, this.variantSelectedId) === this._getVariantId(e, t)
                                }
                            }, {
                                key: "_isLastPosition",
                                value: function (e) {
                                    return e === this.lastPosition
                                }
                            }, {
                                key: "_getVariantId",
                                value: function (e, t) {
                                    var n = 1 === e ? t : this.option1Selected,
                                        r = 2 === e ? t : this.option2Selected,
                                        a = 3 === e ? t : this.option3Selected,
                                        i = ct.getVariantByOptions(this.allVariants, n, r, a);
                                    return i ? i.id : void 0
                                }
                            }]), a
                        }(st),
                        dt = function (e) {
                            i(a, e);
                            var n = c(a);

                            function a(e, r, i, o, u) {
                                return t(this, a), n.call(this, e, r, i, o, u)
                            }
                            return r(a, [{
                                key: "build",
                                value: function () {
                                    var e = this;
                                    this.$variantSelector = new b("<select></select>"), this.$variantSelector.addClass(st.VARIANT_SELECTOR_OPTION_1_CLASS), this._setStyles(this.$variantSelector), this._populateSelect(), this._addLabel(), this.$variantSelector.change((function () {
                                        return e.variantChangedCallback(e.getSelectedVariantId())
                                    }))
                                }
                            }, {
                                key: "variantSelector",
                                value: function () {
                                    return b.merge(this.$variantLabels, this.$variantSelector)
                                }
                            }, {
                                key: "getSelectedVariantId",
                                value: function () {
                                    return this.$variantSelector ? this.$variantSelector.val() : 0
                                }
                            }, {
                                key: "_populateSelect",
                                value: function () {
                                    this.preferences.showAllVariants ? (ct.hasNotVariants(this.variants) && this._defaultOption(this.$variantSelector), this._populateVariants(this.allVariants)) : this._populateVariants(this.variants)
                                }
                            }, {
                                key: "_addLabel",
                                value: function () {
                                    if (this.preferences.showVariantSelectorLabel) {
                                        var e = b.map(this.options, (function (e) {
                                            return e.name
                                        })).join(" / ");
                                        this._createLabelContainer(e)
                                    }
                                }
                            }, {
                                key: "_populateVariants",
                                value: function (e) {
                                    var t = this;
                                    e.forEach((function (e) {
                                        var n = t._createOption(e);
                                        t._disableVariant(e.available, n), t.$variantSelector.append(n)
                                    }))
                                }
                            }, {
                                key: "_createOption",
                                value: function (e) {
                                    var t = b("<option />");
                                    return t.val(e.id), t.html(this._optionText(e)), t.attr("data-variant-id", e.id), t
                                }
                            }, {
                                key: "_optionText",
                                value: function (e) {
                                    return e.title + this._priceText(e)
                                }
                            }]), a
                        }(st);
                    a(dt, "PRICE_SEPARATOR", "   -   ");
                    var ft = function () {
                        function e(n, r, a) {
                            t(this, e), this.product = n, this.preferences = r, this.$productLinkElement = a, this.errorUI = new We, this._buildVariants(n), this.variantImageUpdater = new Je(n, a, r.target), this.quantitySelectorUI = new Ge(r), this.soldOutButtonUI = new Ze(r), this._hasAvailableVariant() && (this.addToCartButtonUI = new $e(this.defaultVariantId, this.errorUI, this.quantitySelectorUI, r, n.tags, this.product.handle)), this._build()
                        }
                        return r(e, [{
                            key: "_buildVariants",
                            value: function (t) {
                                var n = this,
                                    r = D.href(this.$productLinkElement),
                                    a = g.getParameter(r, "variant");
                                this.id = a ? e.WIDGET_CLASS + "-" + t.id + "-" + a : e.WIDGET_CLASS + "-" + t.id;
                                var i = ze.availableVariants(t),
                                    o = ze.allVariants(t);
                                i.length > 0 && (this.defaultVariantId = a || i[0].id), this.variantSelectorUI = this._getVariantUI(i, o, (function (e) {
                                    return n._variantChanged(e)
                                }), t.options)
                            }
                        }, {
                            key: "_hasAvailableVariant",
                            value: function () {
                                return this.defaultVariantId
                            }
                        }, {
                            key: "widget",
                            value: function () {
                                return this.$widget
                            }
                        }, {
                            key: "getId",
                            value: function () {
                                return this.id
                            }
                        }, {
                            key: "_build",
                            value: function () {
                                this.$widget = new b("<div></div>"), this.$widget.addClass(e.WIDGET_CLASS), this.$widget.attr("id", this.id), this._appendVariantSelectorIfRequired(), this._appendErrorBox(), this._appendAddToCartButton(), this._appendQuantitySelectorIfRequired(), this.$widget.css("padding", "1px 5px 30px 5px"), this.$widget.css("width", "100%")
                            }
                        }, {
                            key: "_getVariantUI",
                            value: function (e, t, n, r) {
                                return this.preferences.enableMultipleVariantSelectors ? new lt(e, t, this.preferences, n, this.defaultVariantId, r) : new dt(e, t, this.preferences, n, r)
                            }
                        }, {
                            key: "_appendVariantSelectorIfRequired",
                            value: function () {
                                var e = ze.hasMoreThanOneVariants(this.product),
                                    t = ze.availableVariants(this.product).length > 0;
                                this.preferences.showVariantSelector && e && (t || this.preferences.showAllVariants) && (this.variantSelectorUI.build(), this.$widget.append(this.variantSelectorUI.variantSelector()))
                            }
                        }, {
                            key: "_appendErrorBox",
                            value: function () {
                                this.$widget.append(this.errorUI.errorBox())
                            }
                        }, {
                            key: "_appendAddToCartButton",
                            value: function () {
                                this.$buttonContainer = new b("<div></div>"), this.$buttonContainer.addClass(e.BUTTON_SUPER_CONTAINER), this.$buttonContainer.css("display", "flex"), this.$buttonContainer.css("flex-direction", "row"), this._shouldAppendAddToCartButton() ? (this.$buttonContainer.append(this.addToCartButtonUI.addToCartButton()), this.$widget.append(this.$buttonContainer)) : (this.$buttonContainer.append(this.soldOutButtonUI.soldOutButton()), this.$widget.append(this.$buttonContainer))
                            }
                        }, {
                            key: "_appendQuantitySelectorIfRequired",
                            value: function () {
                                this.preferences.showQuantitySelector && this._shouldAppendAddToCartButton() && (this.quantitySelectorUI.build(), this.$buttonContainer.prepend(this.quantitySelectorUI.quantitySelector()))
                            }
                        }, {
                            key: "_variantChanged",
                            value: function (e) {
                                this.addToCartButtonUI.updateSelectedVariantId(e), this.preferences.updateVariantImage && this.variantImageUpdater.update(ze.getVariantImage(this.product, e))
                            }
                        }, {
                            key: "_shouldAppendAddToCartButton",
                            value: function () {
                                var e = D.href(this.$productLinkElement),
                                    t = g.getParameter(e, "variant");
                                return t ? ze.isVariantAvailable(this.product, t) : ze.isAvailable(this.product)
                            }
                        }]), e
                    }();
                    a(ft, "WIDGET_CLASS", C.cssClassPrefix() + "widget"), a(ft, "BUTTON_SUPER_CONTAINER", C.cssClassPrefix() + "button-super-container");
                    var pt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "place",
                                value: function (t, n, r) {
                                    var a = e._targetElement(n);
                                    "LAST_CHILD" === r ? t.appendTo(a) : t.insertAfter(a)
                                }
                            }, {
                                key: "_targetElement",
                                value: function (e) {
                                    var t = b(e),
                                        n = t.filter(":visible").filter(":first");
                                    return n.length > 0 ? n : t.filter(":first")
                                }
                            }]), e
                        }(),
                        ht = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "place",
                                value: function (t, n, r, a) {
                                    var i = Ye.find(n, r);
                                    i && e._placeOnFoundTarget(t, r, a, i)
                                }
                            }, {
                                key: "_placeOnFoundTarget",
                                value: function (t, n, r, a) {
                                    e._isConfiguredTarget(a, n) ? pt.place(t, a, r) : a.append(t)
                                }
                            }, {
                                key: "_isConfiguredTarget",
                                value: function (e, t) {
                                    return e.is(b(t))
                                }
                            }]), e
                        }(),
                        vt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "build",
                                value: function (t, n, r) {
                                    e._buildSafely(b(t), n, r)
                                }
                            }, {
                                key: "_buildSafely",
                                value: function (t, n, r) {
                                    try {
                                        e._buildIfPossible(t, n, r)
                                    } catch (e) {
                                        console.log(e)
                                    }
                                }
                            }, {
                                key: "_buildIfPossible",
                                value: function (t, n, r) {
                                    var a = D.href(t),
                                        i = g.getParameter(a, "variant");
                                    e._shouldBuildWidget(n, i, r) && e._build(t, n, r)
                                }
                            }, {
                                key: "_shouldBuildWidget",
                                value: function (e, t, n) {
                                    return !ze.hasTag(e, C.AVOID_WIDGET_TAG) && (t ? n.showSoldOutButton || ze.isVariantAvailable(e, t) : n.showSoldOutButton || ze.isAvailable(e))
                                }
                            }, {
                                key: "_build",
                                value: function (t, n, r) {
                                    var a = new ft(n, r, t);
                                    ht.place(a.widget(), t, r.target, r.targetPlacement), e._removePossibleWidgetSimilarSiblings(a), e._removePossibleWidgetSimilarRelatives(a, t, r.target)
                                }
                            }, {
                                key: "_removePossibleWidgetSimilarSiblings",
                                value: function (e) {
                                    e.widget().siblings("." + ft.WIDGET_CLASS).remove()
                                }
                            }, {
                                key: "_removePossibleWidgetSimilarRelatives",
                                value: function (e, t, n) {
                                    var r = Ye.find(t, n);
                                    r && (r.find("#" + e.getId()).not(e.widget()).remove(), r.siblings("#" + e.getId()).not(e.widget()).remove())
                                }
                            }]), e
                        }(),
                        yt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "areProductsInRegularGrid",
                                value: function (t) {
                                    return e._areAllProductsSimilarWidth(t)
                                }
                            }, {
                                key: "gridRows",
                                value: function (e) {
                                    var t = e.map((function (e, t) {
                                            return b(t).offset().top
                                        })).toArray(),
                                        n = d.distinct(t),
                                        r = [];
                                    return n.forEach((function (t) {
                                        var n = e.filter((function (e, n) {
                                            return b(n).offset().top == t
                                        }));
                                        r.push(n)
                                    })), r
                                }
                            }, {
                                key: "_areAllProductsSimilarWidth",
                                value: function (t) {
                                    var n = t.map((function (e, t) {
                                        return b(t).innerWidth()
                                    }));
                                    return Math.max.apply(Math, n) / Math.min.apply(Math, n) < e.WIDTH_DIFFERENCE_RATIO_THRESHOLD
                                }
                            }]), e
                        }();
                    a(yt, "WIDTH_DIFFERENCE_RATIO_THRESHOLD", 2);
                    var mt = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "alignIfRequiredAndPossible",
                            value: function (t) {
                                t && e._alignIfPossible()
                            }
                        }, {
                            key: "_alignIfPossible",
                            value: function () {
                                var t = b(e.WIDGET_SELECTOR),
                                    n = t.parent();
                                e._canWidgetsMarginTopBeAligned(n) && e._alignWidgetsAndTryToRealignWhenNecessary(t)
                            }
                        }, {
                            key: "_canWidgetsMarginTopBeAligned",
                            value: function (e) {
                                return yt.areProductsInRegularGrid(e)
                            }
                        }, {
                            key: "_alignWidgetsAndTryToRealignWhenNecessary",
                            value: function (t) {
                                e._alignWidgets(t), setTimeout((function () {
                                    return e._alignWidgets(t)
                                }), 100), setTimeout((function () {
                                    return e._alignWidgets(t)
                                }), 500), setTimeout((function () {
                                    return e._alignWidgets(t)
                                }), 1e3), window.addEventListener("resize", (function () {
                                    return e._alignWidgets(t)
                                }))
                            }
                        }, {
                            key: "_alignWidgets",
                            value: function (t) {
                                var n = t.parent();
                                yt.gridRows(n).forEach((function (t) {
                                    var n = t.find(e.WIDGET_SELECTOR);
                                    n.length > 1 && (e._resetMarginTop(n), e._alignRowWidgets(n))
                                }))
                            }
                        }, {
                            key: "_alignRowWidgets",
                            value: function (e) {
                                var t = e.map((function (e, t) {
                                        return b(t).offset().top
                                    })),
                                    n = Math.max.apply(Math, t);
                                e.each((function (e, t) {
                                    var r = b(t).offset().top,
                                        a = n - r + 0;
                                    b(t).css("padding-top", a + "px")
                                }))
                            }
                        }, {
                            key: "_resetMarginTop",
                            value: function (e) {
                                e.each((function (e, t) {
                                    b(t).css("padding-top", "0px")
                                }))
                            }
                        }]), e
                    }();
                    a(mt, "WIDGET_SELECTOR", "." + ft.WIDGET_CLASS);
                    var gt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "fix",
                                value: function () {
                                    var t = b("." + ft.WIDGET_CLASS);
                                    e._clearPreviousElementMarginBottom(t)
                                }
                            }, {
                                key: "_clearPreviousElementMarginBottom",
                                value: function (e) {
                                    e.prev().css("margin-bottom", "0px"), e.prev().css("padding-bottom", "0px")
                                }
                            }]), e
                        }(),
                        _t = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "product",
                                value: function (t) {
                                    var n = t + ".js",
                                        r = g.isDemoPage() ? e.DEMO_URL : n;
                                    return w.jsonGetPromise(r).catch((function (e) {
                                        return Promise.resolve({})
                                    })).then((function (n) {
                                        return e._productWithUrl(n, t)
                                    }))
                                }
                            }, {
                                key: "_productWithUrl",
                                value: function (e, t) {
                                    return e.url = t, e
                                }
                            }]), e
                        }();
                    a(_t, "DEMO_URL", C.cdnUrl() + "/support/demo/product.json");
                    var Ct = function () {
                        function e() {
                            t(this, e)
                        }
                        return r(e, null, [{
                            key: "product",
                            value: function (t) {
                                return e.CACHE[t] ? Promise.resolve(e.CACHE[t]) : _t.product(t).then((function (n) {
                                    return e.CACHE[t] = n, n
                                }))
                            }
                        }]), e
                    }();
                    a(Ct, "CACHE", []);
                    var bt = function () {
                            function e(n) {
                                t(this, e), this.preferences = n
                            }
                            return r(e, [{
                                key: "build",
                                value: function () {
                                    var e = j.findUnprocessedProductLinks(),
                                        t = this._productUrls(e);
                                    window.CLEVER && window.CLEVER.enableSequentialLoading ? this._sequentialLoad(t, e) : this._parallelLoad(t, e)
                                }
                            }, {
                                key: "_sequentialLoad",
                                value: function (e, t) {
                                    var n = this;
                                    e.forEach((function (e) {
                                        Ct.product(e).then((function (e) {
                                            return n._buildWidget(t, e)
                                        }))
                                    })), this._afterBuildingProcess()
                                }
                            }, {
                                key: "_parallelLoad",
                                value: function (e, t) {
                                    var n = this,
                                        r = e.map((function (e) {
                                            return Ct.product(e)
                                        }));
                                    Promise.all(r).then((function (e) {
                                        return n._buildWidgets(t, e)
                                    })).then((function () {
                                        return n._afterBuildingProcess()
                                    }))
                                }
                            }, {
                                key: "_productUrls",
                                value: function (e) {
                                    var t = e.map((function (e) {
                                        return D.hrefPathname(e)
                                    }));
                                    return d.distinct(t)
                                }
                            }, {
                                key: "_buildWidgets",
                                value: function (e, t) {
                                    var n = this;
                                    e.forEach((function (e) {
                                        var r = t.find((function (t) {
                                            return t.url == D.hrefPathname(e)
                                        }));
                                        n._buildSingleWidget(e, r)
                                    }))
                                }
                            }, {
                                key: "_buildWidget",
                                value: function (e, t) {
                                    var n = e.find((function (e) {
                                        return t.url == D.hrefPathname(e)
                                    }));
                                    this._buildSingleWidget(n, t)
                                }
                            }, {
                                key: "_buildSingleWidget",
                                value: function (e, t) {
                                    vt.build(e, t, this.preferences), this._markProductLinkAsProcessed(e)
                                }
                            }, {
                                key: "_afterBuildingProcess",
                                value: function () {
                                    gt.fix(), mt.alignIfRequiredAndPossible(this.preferences.alignWidgets)
                                }
                            }, {
                                key: "_markProductLinkAsProcessed",
                                value: function (e) {
                                    b(e).addClass(C.PROCESSED_BY_CLEVER_CLASS)
                                }
                            }]), e
                        }(),
                        wt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "addScriptCode",
                                value: function (e) {
                                    var t = document.createElement("script");
                                    t.type = "text/javascript", t.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(t)
                                }
                            }]), e
                        }(),
                        kt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "addStyles",
                                value: function (e) {
                                    var t = document.createElement("style");
                                    t.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(t)
                                }
                            }]), e
                        }(),
                        St = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "addScripts",
                                value: function (e, t) {
                                    f.isNotEmpty(e) && kt.addStyles(e), f.isNotEmpty(t) && wt.addScriptCode(t)
                                }
                            }]), e
                        }(),
                        xt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "start",
                                value: function (t) {
                                    setInterval((function () {
                                        return e._executeCallbackIfPageProductLinksChanged(t)
                                    }), e.RELOAD_CHECKING_INTERVAL)
                                }
                            }, {
                                key: "_executeCallbackIfPageProductLinksChanged",
                                value: function (t) {
                                    e._isThereAnyUnprocessedProductLink() && t()
                                }
                            }, {
                                key: "_isThereAnyUnprocessedProductLink",
                                value: function () {
                                    return j.findUnprocessedProductLinks().length > 0
                                }
                            }]), e
                        }();
                    a(xt, "RELOAD_CHECKING_INTERVAL", 300);
                    var Tt = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "cssFixer",
                                value: function (e) {
                                    if (f.isEmpty(e)) return "";
                                    switch (e.toLowerCase()) {
                                        case "craft":
                                        case "crave":
                                        case "dawn":
                                        case "sense":
                                        case "studio":
                                        case "taste":
                                        case "ride":
                                        case "colorblock":
                                            return ".cleverapps-collections-add-to-cart-widget {\n                            position: relative; \n                            z-index: 1;\n     padding-top: 0% !important;\n                   }";
                                        case "refresh":
                                            return ".cleverapps-collections-add-to-cart-widget {\n                            position: relative; \n                            z-index: 1;\n    padding-top: 0% !important;\n                     }\n                        .cleverapps-collections-add-to-cart-sold-out-button,\n                        .cleverapps-collections-add-to-cart-add-to-cart-button,\n                        .cleverapps-collections-add-to-cart-quantity-selector-container,\n                        .cleverapps-collections-add-to-cart-variant-selector,\n                        .cleverapps-collections-add-to-cart-variant-selector-option-2,\n                        .cleverapps-collections-add-to-cart-variant-selector-option-3 {\n                            border-radius: 0.8rem !important;\n                        }";
                                        case "expanse":
                                            return ".grid-item.grid-product {\n                            flex-direction: column !important;\n                        }";
                                        default:
                                            return ""
                                    }
                                }
                            }]), e
                        }(),
                        At = function () {
                            function e() {
                                t(this, e)
                            }
                            return r(e, null, [{
                                key: "start",
                                value: function () {
                                    g.isDemoPage() ? setTimeout((function () {
                                        return e._start()
                                    }), 100) : e._start()
                                }
                            }, {
                                key: "_start",
                                value: function () {
                                    console.log(e._loadPreferencesAndBuildWidgets())
                                    true && 'undefined'
                                }
                            }, {
                                key: "_loadPreferencesAndBuildWidgets",
                                value: function () {
                                    O.publishCLEVERJqueryIfRequired()
                                    let t ={
                                        "customCss" : ".js-drawer-open .main-content:after { display: none !important; }html.js-drawer-open { overflow: visible !important; }.product-block__detail.align-ltr-left { margin-bottom: 0px !important; }cleverapps-collections-add-to-cart-variant-label { text-align: left; } ul.cbb-frequently-bought-selector-list > li > .cleverapps-collections-add-to-cart-widget { display: none; } div.cleverapps-collections-add-to-cart-widget { position: relative; } button.cleverapps-collections-add-to-cart-sold-out-button { border-radius: 10px; } .aos-init.aos-animate > .grid-product__content { margin-bottom: 0px !important; } .grid__item.grid-product.medium-up--one-half.grid-product__has-quick-shop.aos-init.aos-animate { margin-bottom: 30px; } #CollectionSwitcher1-template--18096174104825__featured_collection_switcher_BdidzJ .flickity-viewport { height: 415px !important; } #CollectionSwitcher1-template--18096174104825__featured-collection-switcher > .flickity-viewport { height: 480px !important; } li.mobile-nav__item > .cleverapps-collections-add-to-cart-widget { display: none; } @media only screen and (max-width: 767px) {#CollectionSwitcher1-template--22782545199428__featured_collection_switcher_FXhBY3 .flickity-viewport , #CollectionSwitcher1-template--22782545199428__featured_collection_switcher_Vhkatd .flickity-viewport { height: 320px !important; } } @media only screen and (min-width: 768px) { #CollectionSwitcher1-template--22782545199428__featured_collection_switcher_FXhBY3 .flickity-viewport , #CollectionSwitcher1-template--22782545199428__featured_collection_switcher_Vhkatd .flickity-viewport { height: 378px !important; } } .card__heading a:after{bottom:50% !important;}.cleverapps-collections-cart-button-widget { padding-top: 0px !important; } button.cleverapps-collections-add-to-cart-add-to-cart-button { text-align: center; } .slideshow__slide > .cleverapps-collections-add-to-cart-widget { display: none; }",
                                        "customJs" : "",
                                        "theme": window.Shopify?.theme?.schema_name || window.Shopify?.theme?.name || theme?.settings?.themeName || document.documentElement.getAttribute('data-theme-name') || window.theme?.name || '',
                                        "target" :".st-product-inner.grid-product",
                                        "targetPlacement" : "LAST_CHILD",
                                        "showOnHomepage" : data.showOnHomepage,
                                        "showOnSearchResultsPage" : data.showOnSearchResultsPage,
                                        "showOnProductPage" : data.showOnProductPage,
                                        "showOnCollectionPage" : true,
                                        "showOnCartPage" : false,
                                        "redirectPolicy" : data.redirectPolicy,
                                        "showDrawerCart" : true,
                                        "lazyLoading" : true,
                                        "alignWidgets" : true,
                                        "buttonText" : data.buttonText,
                                        "buttonAddedText" : data.buttonAddedText,
                                        "buttonRecovery" : true,
                                        "buttonBorderSize" : data.buttonBorderSize+'px',
                                        "buttonBorderColor" : data.buttonBorderColor,
                                        "buttonBorderRadius" : data.buttonBorderRadius+'px',
                                        "buttonBackgroundColor" : data.buttonBackgroundColor,
                                        "buttonFontSize" : data.buttonFontSize+'px',
                                        "buttonFontColor" : data.buttonFontColor,
                                        "buttonFontStyle" : data.buttonFontStyle,
                                        "buttonFontFamily" : data.buttonFontFamily,
                                        "showSoldOutButton" : data.showSoldOutButton,
                                        "showSoldOutButtonText" : data.showSoldOutButtonText || "Sold Out",
                                        "soldOutButtonBorderSize" : data.soldOutButtonBorderSize+'px',
                                        "soldOutButtonBorderColor" : data.soldOutButtonBorderColor,
                                        "soldOutButtonBorderRadius" : data.soldOutButtonBorderRadius,
                                        "soldOutButtonBackgroundColor" : "#000000",
                                        "soldOutButtonFontSize" : data.soldOutButtonFontSize+'px',
                                        "soldOutButtonFontColor" : "#ffffff",
                                        "soldOutButtonFontStyle" : data.soldOutButtonFontStyle,
                                        "soldOutButtonFontFamily" : data.soldOutButtonFontFamily,
                                        "showVariantSelector" : data.showVariantSelector,
                                        "variantSelectorBorderSize" : data.advancedBorderSize+'px' || data.variantSelectorBorderSize+'px',
                                        "variantSelectorBorderColor" : data.advancedBorderColor || data.variantSelectorBorderColor,
                                        "variantSelectorBorderRadius" : data.dvancedBorderRadius+'px' || data.variantSelectorBorderRadius+'px',
                                        "variantSelectorBackgroundColor" : data.advancedBackgroundColor || data.variantSelectorBackgroundColor ,
                                        "variantSelectorFontSize" : data.advancedFontSize+'px' || data.variantSelectorFontSize+'px',
                                        "variantSelectorFontColor" : data.advancedFontColor || data.variantSelectorFontColor,
                                        "variantSelectorFontStyle" : data.advancedFontStyle || data.variantSelectorFontStyle,
                                        "variantSelectorFontFamily" : data.advancedFontFamily || data.variantSelectorFontFamily,
                                        "showVariantPrice" : data.showVariantPrice,
                                        "updateVariantImage" : data.updateVariantImage,
                                        "showAllVariants" : data.showAllVariants,
                                        "enableMultipleVariantSelectors" : data.enableMultipleVariantSelectors,
                                        "showVariantSelectorLabel" : data.enableMultipleVariantSelectors,
                                        "variantSelectorLabelFontSize" : data.variantSelectorLabelFontSize+'px',
                                        "variantSelectorLabelFontColor" : data.variantSelectorLabelFontColor,
                                        "variantSelectorLabelFontStyle" : data.variantSelectorLabelFontStyle,
                                        "variantSelectorLabelFontFamily" : data.variantSelectorLabelFontFamily,
                                        "showQuantitySelector" : data.showQuantitySelector,
                                        "quantitySelectorBorderSize" : data.quantitySelectorBorderSize+'px',
                                        "quantitySelectorBorderColor" : data.quantitySelectorBorderColor,
                                        "quantitySelectorBorderRadius" : data.quantitySelectorBorderRadius+'px',
                                        "quantitySelectorBackgroundColor" : data.quantitySelectorBackgroundColor,
                                        "quantitySelectorFontSize" : data.quantitySelectorFontSize+'px',
                                        "quantitySelectorFontColor" : data.quantitySelectorFontColor,
                                        "quantitySelectorFontStyle" : data.quantitySelectorFontStyle,
                                        "quantitySelectorFontFamily" : data.quantitySelectorFontFamily,
                                        "quantitySelectorDefaultQuantity" : data.quantitySelectorDefaultQuantity
                                    }
                                    return e._buildWidgetsIfRequired(t)

                                }
                            }, {
                                key: "_buildWidgetsIfRequired",
                                value: function (t) {
                                    e._shouldBuildWidgets(t) && e._buildWidgets(t)
                                }
                            }, {
                                key: "_buildWidgets",
                                value: function (t) {
                                    var n = new bt(t);
                                    n.build(), xt.start((function () {
                                        return n.build()
                                    })), e._addCustomScripts(t)
                                }
                            }, {
                                key: "_shouldBuildWidgets",
                                value: function (e) {
                                    return e && P.isRightPage(e)
                                }
                            }, {
                                key: "_addCustomScripts",
                                value: function (e) {
                                    St.addScripts(e.customCss, e.customJs), St.addScripts(Tt.cssFixer(e.theme), "")
                                }
                            }, {
                                key: "_logError",
                                value: function (e) {
                                    console.log("Error when starting Collections Add to Cart Button app:"), console.log(e)
                                }
                            }]), e
                        }();
                    new(r((function e() {
                        t(this, e), At.start()
                    })))
                });
        }("undefined"==typeof collectionsAddToCart?collectionsAddToCart={}:collectionsAddToCart);
    });
}
